import { CurrencyType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteDetail.Types.CurrencyType */
export { CurrencyType };
/** CoStar.Api.SuiteDetail.Types.EntityType */
export var EntityType;
(function (EntityType) {
    EntityType[EntityType["Property"] = 1] = "Property";
    EntityType[EntityType["ForSale"] = 2] = "ForSale";
    EntityType[EntityType["CondoUnit"] = 3] = "CondoUnit";
    EntityType[EntityType["SpaceForLease"] = 4] = "SpaceForLease";
    EntityType[EntityType["Land"] = 6] = "Land";
    EntityType[EntityType["LeaseDeal"] = 7] = "LeaseDeal";
    EntityType[EntityType["PropertyIncomeExpense"] = 8] = "PropertyIncomeExpense";
    EntityType[EntityType["PropertyForSale"] = 9] = "PropertyForSale";
    EntityType[EntityType["LandForSale"] = 10] = "LandForSale";
    EntityType[EntityType["CondoForSale"] = 11] = "CondoForSale";
    EntityType[EntityType["Location"] = 12] = "Location";
    EntityType[EntityType["PropertyUpdateEvent"] = 13] = "PropertyUpdateEvent";
    EntityType[EntityType["TenantUpdateEvent"] = 14] = "TenantUpdateEvent";
    EntityType[EntityType["Tenant"] = 15] = "Tenant";
    EntityType[EntityType["Sales"] = 16] = "Sales";
    EntityType[EntityType["Contact"] = 17] = "Contact";
    EntityType[EntityType["Submarket"] = 18] = "Submarket";
    EntityType[EntityType["Comp"] = 23] = "Comp";
    EntityType[EntityType["PropertyGroup"] = 24] = "PropertyGroup";
    EntityType[EntityType["LandForLease"] = 25] = "LandForLease";
    EntityType[EntityType["CompEntity"] = 26] = "CompEntity";
    EntityType[EntityType["PropertyLoan"] = 27] = "PropertyLoan";
    EntityType[EntityType["ActionItem"] = 28] = "ActionItem";
    EntityType[EntityType["Listing"] = 29] = "Listing";
    EntityType[EntityType["Workspace"] = 30] = "Workspace";
})(EntityType || (EntityType = {}));
/** CoStar.Api.SuiteDetail.Types.MeasurementSystem */
export var MeasurementSystem;
(function (MeasurementSystem) {
    MeasurementSystem[MeasurementSystem["Unknown"] = 0] = "Unknown";
    MeasurementSystem[MeasurementSystem["Imperial"] = 1] = "Imperial";
    MeasurementSystem[MeasurementSystem["Metric"] = 2] = "Metric";
})(MeasurementSystem || (MeasurementSystem = {}));
import { PropertyType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteDetail.Types.PropertyType */
export { PropertyType };
import { PropertyGroupType } from "../../../../CoStar/Api/Analytics/CommonEntities/Enums/index.js";
/** CoStar.Api.SuiteDetail.Types.PropertyGroupType */
export { PropertyGroupType };
import { PropertyGroupSubtype } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.PropertyGroupSubtype */
export { PropertyGroupSubtype };
import { PropertySubtype } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.PropertySubtype */
export { PropertySubtype };
import { ServiceType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.ServiceType */
export { ServiceType };
import { ApartmentLifestyleType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.ApartmentLifestyleType */
export { ApartmentLifestyleType };
import { ApartmentRentType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.ApartmentRentType */
export { ApartmentRentType };
import { ApartmentStyleType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.ApartmentStyleType */
export { ApartmentStyleType };
import { AffordableRentSubtype } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.AffordableRentSubtype */
export { AffordableRentSubtype };
import { SprinklerType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.SprinklerType */
export { SprinklerType };
import { BreeamType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.BreeamType */
export { BreeamType };
import { ConstructionStatus } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.ConstructionStatus */
export { ConstructionStatus };
import { RetailLocation } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.RetailLocation */
export { RetailLocation };
import { LeedType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.LeedType */
export { LeedType };
/** CoStar.Api.SuiteDetail.Types.EnergyPerformanceConsumption */
export var EnergyPerformanceConsumption;
(function (EnergyPerformanceConsumption) {
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["None"] = 0] = "None";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["A_ESP"] = 510] = "A_ESP";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["B_ESP"] = 520] = "B_ESP";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["C_ESP"] = 530] = "C_ESP";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["D_ESP"] = 540] = "D_ESP";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["E_ESP"] = 550] = "E_ESP";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["F_ESP"] = 560] = "F_ESP";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["G_ESP"] = 570] = "G_ESP";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["A_Plus_DEU"] = 609] = "A_Plus_DEU";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["A_DEU"] = 610] = "A_DEU";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["B_DEU"] = 620] = "B_DEU";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["C_DEU"] = 630] = "C_DEU";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["D_DEU"] = 640] = "D_DEU";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["E_DEU"] = 650] = "E_DEU";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["F_DEU"] = 660] = "F_DEU";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["G_DEU"] = 670] = "G_DEU";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["A_FRA"] = 710] = "A_FRA";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["B_FRA"] = 720] = "B_FRA";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["C_FRA"] = 730] = "C_FRA";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["D_FRA"] = 740] = "D_FRA";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["E_FRA"] = 750] = "E_FRA";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["F_FRA"] = 760] = "F_FRA";
    EnergyPerformanceConsumption[EnergyPerformanceConsumption["G_FRA"] = 770] = "G_FRA";
})(EnergyPerformanceConsumption || (EnergyPerformanceConsumption = {}));
/** CoStar.Api.SuiteDetail.Types.GreenhouseGasEmission */
export var GreenhouseGasEmission;
(function (GreenhouseGasEmission) {
    GreenhouseGasEmission[GreenhouseGasEmission["None"] = 0] = "None";
    GreenhouseGasEmission[GreenhouseGasEmission["A_ESP"] = 510] = "A_ESP";
    GreenhouseGasEmission[GreenhouseGasEmission["B_ESP"] = 520] = "B_ESP";
    GreenhouseGasEmission[GreenhouseGasEmission["C_ESP"] = 530] = "C_ESP";
    GreenhouseGasEmission[GreenhouseGasEmission["D_ESP"] = 540] = "D_ESP";
    GreenhouseGasEmission[GreenhouseGasEmission["E_ESP"] = 550] = "E_ESP";
    GreenhouseGasEmission[GreenhouseGasEmission["F_ESP"] = 560] = "F_ESP";
    GreenhouseGasEmission[GreenhouseGasEmission["G_ESP"] = 570] = "G_ESP";
    GreenhouseGasEmission[GreenhouseGasEmission["A_FRA"] = 710] = "A_FRA";
    GreenhouseGasEmission[GreenhouseGasEmission["B_FRA"] = 720] = "B_FRA";
    GreenhouseGasEmission[GreenhouseGasEmission["C_FRA"] = 730] = "C_FRA";
    GreenhouseGasEmission[GreenhouseGasEmission["D_FRA"] = 740] = "D_FRA";
    GreenhouseGasEmission[GreenhouseGasEmission["E_FRA"] = 750] = "E_FRA";
    GreenhouseGasEmission[GreenhouseGasEmission["F_FRA"] = 760] = "F_FRA";
    GreenhouseGasEmission[GreenhouseGasEmission["G_FRA"] = 770] = "G_FRA";
})(GreenhouseGasEmission || (GreenhouseGasEmission = {}));
import { ConstructionMaterial } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.ConstructionMaterial */
export { ConstructionMaterial };
import { LocationType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.LocationType */
export { LocationType };
import { OwnershipType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.OwnershipType */
export { OwnershipType };
/** CoStar.Api.SuiteDetail.Types.PropertyFinancialAccountCategory */
export var PropertyFinancialAccountCategory;
(function (PropertyFinancialAccountCategory) {
    PropertyFinancialAccountCategory[PropertyFinancialAccountCategory["None"] = 0] = "None";
    PropertyFinancialAccountCategory[PropertyFinancialAccountCategory["Income"] = 100] = "Income";
    PropertyFinancialAccountCategory[PropertyFinancialAccountCategory["OperatingExpense"] = 200] = "OperatingExpense";
    PropertyFinancialAccountCategory[PropertyFinancialAccountCategory["CapitalExpense"] = 300] = "CapitalExpense";
})(PropertyFinancialAccountCategory || (PropertyFinancialAccountCategory = {}));
/** CoStar.Api.SuiteDetail.Types.PropertyFinancialAccount */
export var PropertyFinancialAccount;
(function (PropertyFinancialAccount) {
    PropertyFinancialAccount[PropertyFinancialAccount["None"] = 0] = "None";
    PropertyFinancialAccount[PropertyFinancialAccount["GrossPotentialRent"] = 101] = "GrossPotentialRent";
    PropertyFinancialAccount[PropertyFinancialAccount["VacancyCollectionLoss"] = 102] = "VacancyCollectionLoss";
    PropertyFinancialAccount[PropertyFinancialAccount["BaseRent"] = 103] = "BaseRent";
    PropertyFinancialAccount[PropertyFinancialAccount["ExpenseReimbursement"] = 104] = "ExpenseReimbursement";
    PropertyFinancialAccount[PropertyFinancialAccount["PercentageRent"] = 105] = "PercentageRent";
    PropertyFinancialAccount[PropertyFinancialAccount["ParkingIncome"] = 106] = "ParkingIncome";
    PropertyFinancialAccount[PropertyFinancialAccount["LaundryVendingIncome"] = 107] = "LaundryVendingIncome";
    PropertyFinancialAccount[PropertyFinancialAccount["RoomRevenue"] = 108] = "RoomRevenue";
    PropertyFinancialAccount[PropertyFinancialAccount["FoodBeverageRevenue"] = 109] = "FoodBeverageRevenue";
    PropertyFinancialAccount[PropertyFinancialAccount["TelephoneRevenue"] = 110] = "TelephoneRevenue";
    PropertyFinancialAccount[PropertyFinancialAccount["OtherDepartmentalRevenue"] = 111] = "OtherDepartmentalRevenue";
    PropertyFinancialAccount[PropertyFinancialAccount["OtherIncome"] = 112] = "OtherIncome";
    PropertyFinancialAccount[PropertyFinancialAccount["RealEstateTaxes"] = 201] = "RealEstateTaxes";
    PropertyFinancialAccount[PropertyFinancialAccount["PropertyInsurance"] = 202] = "PropertyInsurance";
    PropertyFinancialAccount[PropertyFinancialAccount["Utilities"] = 203] = "Utilities";
    PropertyFinancialAccount[PropertyFinancialAccount["RepairsMaintenance"] = 204] = "RepairsMaintenance";
    PropertyFinancialAccount[PropertyFinancialAccount["Janitoria"] = 205] = "Janitoria";
    PropertyFinancialAccount[PropertyFinancialAccount["ManagementFees"] = 206] = "ManagementFees";
    PropertyFinancialAccount[PropertyFinancialAccount["PayrollBenefits"] = 207] = "PayrollBenefits";
    PropertyFinancialAccount[PropertyFinancialAccount["AdvertisingMarketing"] = 208] = "AdvertisingMarketing";
    PropertyFinancialAccount[PropertyFinancialAccount["ProfessionalFees"] = 209] = "ProfessionalFees";
    PropertyFinancialAccount[PropertyFinancialAccount["GeneralAdministrative"] = 210] = "GeneralAdministrative";
    PropertyFinancialAccount[PropertyFinancialAccount["GroundRent"] = 211] = "GroundRent";
    PropertyFinancialAccount[PropertyFinancialAccount["Room"] = 212] = "Room";
    PropertyFinancialAccount[PropertyFinancialAccount["FoodBeverage"] = 213] = "FoodBeverage";
    PropertyFinancialAccount[PropertyFinancialAccount["TelephoneExpenses"] = 214] = "TelephoneExpenses";
    PropertyFinancialAccount[PropertyFinancialAccount["OtherDepartmentExpenses"] = 215] = "OtherDepartmentExpenses";
    PropertyFinancialAccount[PropertyFinancialAccount["FranchiseFee"] = 216] = "FranchiseFee";
    PropertyFinancialAccount[PropertyFinancialAccount["OtherExpenses"] = 217] = "OtherExpenses";
    PropertyFinancialAccount[PropertyFinancialAccount["LeasingCommissions"] = 301] = "LeasingCommissions";
    PropertyFinancialAccount[PropertyFinancialAccount["TenantImprovements"] = 302] = "TenantImprovements";
    PropertyFinancialAccount[PropertyFinancialAccount["CapitalExpenditures"] = 303] = "CapitalExpenditures";
    PropertyFinancialAccount[PropertyFinancialAccount["ExtraordinaryCapitalExpenditures"] = 304] = "ExtraordinaryCapitalExpenditures";
})(PropertyFinancialAccount || (PropertyFinancialAccount = {}));
/** CoStar.Api.SuiteDetail.Types.PropertyFinancialType */
export var PropertyFinancialType;
(function (PropertyFinancialType) {
    PropertyFinancialType[PropertyFinancialType["None"] = 0] = "None";
    PropertyFinancialType[PropertyFinancialType["Proforma"] = 1] = "Proforma";
    PropertyFinancialType[PropertyFinancialType["Actual"] = 2] = "Actual";
    PropertyFinancialType[PropertyFinancialType["Underwritten"] = 3] = "Underwritten";
})(PropertyFinancialType || (PropertyFinancialType = {}));
/** CoStar.Api.SuiteDetail.Types.PropertyFinancialAmountType */
export var PropertyFinancialAmountType;
(function (PropertyFinancialAmountType) {
    PropertyFinancialAmountType[PropertyFinancialAmountType["None"] = 0] = "None";
    PropertyFinancialAmountType[PropertyFinancialAmountType["YearlyAmount"] = 1] = "YearlyAmount";
    PropertyFinancialAmountType[PropertyFinancialAmountType["RatePerBuildingArea"] = 2] = "RatePerBuildingArea";
    PropertyFinancialAmountType[PropertyFinancialAmountType["YearToDateAmount"] = 3] = "YearToDateAmount";
})(PropertyFinancialAmountType || (PropertyFinancialAmountType = {}));
/** CoStar.Api.SuiteDetail.Types.LoanSourceType */
export var LoanSourceType;
(function (LoanSourceType) {
    LoanSourceType[LoanSourceType["None"] = 0] = "None";
    LoanSourceType[LoanSourceType["PublicRecord"] = 1] = "PublicRecord";
    LoanSourceType[LoanSourceType["CMBS"] = 2] = "CMBS";
})(LoanSourceType || (LoanSourceType = {}));
import { AreaMeasure } from "../../../../CoStar/Api/AnalyticReports/Common/index.js";
/** CoStar.Api.SuiteDetail.Types.AreaMeasure */
export { AreaMeasure };
/** CoStar.Api.SuiteDetail.Types.SalePriceStatus */
export var SalePriceStatus;
(function (SalePriceStatus) {
    SalePriceStatus[SalePriceStatus["None"] = 0] = "None";
    SalePriceStatus[SalePriceStatus["Affidavit"] = 1] = "Affidavit";
    SalePriceStatus[SalePriceStatus["Approximate"] = 2] = "Approximate";
    SalePriceStatus[SalePriceStatus["Confirmed"] = 3] = "Confirmed";
    SalePriceStatus[SalePriceStatus["Declaration"] = 4] = "Declaration";
    SalePriceStatus[SalePriceStatus["FullValue"] = 5] = "FullValue";
    SalePriceStatus[SalePriceStatus["Mini"] = 6] = "Mini";
    SalePriceStatus[SalePriceStatus["Unconfirmed"] = 7] = "Unconfirmed";
    SalePriceStatus[SalePriceStatus["Allocated"] = 8] = "Allocated";
})(SalePriceStatus || (SalePriceStatus = {}));
/** CoStar.Api.SuiteDetail.Types.SpaceUse */
export var SpaceUse;
(function (SpaceUse) {
    SpaceUse[SpaceUse["Default"] = 0] = "Default";
    SpaceUse[SpaceUse["Office"] = 1] = "Office";
    SpaceUse[SpaceUse["OffMed"] = 2] = "OffMed";
    SpaceUse[SpaceUse["OffRet"] = 3] = "OffRet";
    SpaceUse[SpaceUse["Medical"] = 4] = "Medical";
    SpaceUse[SpaceUse["Retail"] = 5] = "Retail";
    SpaceUse[SpaceUse["Flex"] = 6] = "Flex";
    SpaceUse[SpaceUse["Industrial"] = 7] = "Industrial";
})(SpaceUse || (SpaceUse = {}));
/** CoStar.Api.SuiteDetail.Types.PhoneType */
export var PhoneType;
(function (PhoneType) {
    /** @deprecated Specify one of the other types */
    PhoneType[PhoneType["Preferred"] = 0] = "Preferred";
    PhoneType[PhoneType["Office"] = 1] = "Office";
    PhoneType[PhoneType["Mobile"] = 2] = "Mobile";
    PhoneType[PhoneType["Fax"] = 3] = "Fax";
    PhoneType[PhoneType["Home"] = 4] = "Home";
    PhoneType[PhoneType["Pager"] = 5] = "Pager";
    PhoneType[PhoneType["Marketing"] = 6] = "Marketing";
})(PhoneType || (PhoneType = {}));
/** CoStar.Api.SuiteDetail.Types.Designation */
export var Designation;
(function (Designation) {
    Designation[Designation["None"] = 0] = "None";
    Designation[Designation["AIAAmericanInstituteofArchitects"] = 10] = "AIAAmericanInstituteofArchitects";
    Designation[Designation["ARM"] = 20] = "ARM";
    Designation[Designation["CCIMCertifiedCommercialInvestmentMember"] = 30] = "CCIMCertifiedCommercialInvestmentMember";
    Designation[Designation["CPACertifiedPublicAccountant"] = 40] = "CPACertifiedPublicAccountant";
    Designation[Designation["CPMCertifiedPropertyManager"] = 50] = "CPMCertifiedPropertyManager";
    Designation[Designation["CRP"] = 60] = "CRP";
    Designation[Designation["FAIAFellowAmericanInstituteofArchitects"] = 70] = "FAIAFellowAmericanInstituteofArchitects";
    Designation[Designation["MAIMemberoftheAppraisalInstitute"] = 80] = "MAIMemberoftheAppraisalInstitute";
    Designation[Designation["RARegisteredArchitect"] = 90] = "RARegisteredArchitect";
    Designation[Designation["RPARealPropertyAdministrator"] = 110] = "RPARealPropertyAdministrator";
    Designation[Designation["SIORSocietyofIndustrialAndOfficeRealtors"] = 120] = "SIORSocietyofIndustrialAndOfficeRealtors";
    Designation[Designation["SMC"] = 130] = "SMC";
    Designation[Designation["ALTAAmericanLandTitleAssociation"] = 140] = "ALTAAmericanLandTitleAssociation";
    Designation[Designation["AIAppraisalInstitute"] = 150] = "AIAppraisalInstitute";
    Designation[Designation["CMBSCommercialMortgageSecuritiesAssociation"] = 160] = "CMBSCommercialMortgageSecuritiesAssociation";
    Designation[Designation["CRECounselorsofRealEstate"] = 170] = "CRECounselorsofRealEstate";
    Designation[Designation["IREMInstituteofRealEstateManagement"] = 180] = "IREMInstituteofRealEstateManagement";
    Designation[Designation["MBAMortgageBankersAssociation"] = 200] = "MBAMortgageBankersAssociation";
    Designation[Designation["NAREITNationalAssociationofRealEstateInvestmentTrusts"] = 210] = "NAREITNationalAssociationofRealEstateInvestmentTrusts";
    Designation[Designation["CREWNetworkofCommercialRealEstateWomen"] = 230] = "CREWNetworkofCommercialRealEstateWomen";
    Designation[Designation["NARNationalAssociationofRealtors"] = 240] = "NARNationalAssociationofRealtors";
    Designation[Designation["NAIOPNationalAssociationofIndustrialAndOfficeProperties"] = 250] = "NAIOPNationalAssociationofIndustrialAndOfficeProperties";
    Designation[Designation["BOMABuildingOwnersAndManagersAssociation"] = 260] = "BOMABuildingOwnersAndManagersAssociation";
    Designation[Designation["PREAPensionRealEstateAssociation"] = 270] = "PREAPensionRealEstateAssociation";
    Designation[Designation["NAREIMNationalAssociationofRealEstateInvestmentManagers"] = 280] = "NAREIMNationalAssociationofRealEstateInvestmentManagers";
    Designation[Designation["ULIUrbanLandInstitute"] = 290] = "ULIUrbanLandInstitute";
    Designation[Designation["ARESAmericanRealEstateSociety"] = 300] = "ARESAmericanRealEstateSociety";
    Designation[Designation["NCREIFNationalCouncilofRealEstateInvestmentFiduciaries"] = 310] = "NCREIFNationalCouncilofRealEstateInvestmentFiduciaries";
    Designation[Designation["REIPARealEstateInformationProfessionalsAssociation"] = 320] = "REIPARealEstateInformationProfessionalsAssociation";
    Designation[Designation["CoreNetGlobalCorporateRealEstateNetwork"] = 321] = "CoreNetGlobalCorporateRealEstateNetwork";
    Designation[Designation["CIPSCertifiedInternationalPropertySpecialist"] = 322] = "CIPSCertifiedInternationalPropertySpecialist";
    Designation[Designation["GRIGraduateREALTORInstitute"] = 323] = "GRIGraduateREALTORInstitute";
    Designation[Designation["CIRCCommercialIndustrialRealtorsCommission"] = 324] = "CIRCCommercialIndustrialRealtorsCommission";
    Designation[Designation["IOREBAIndustrialAndOfficeRealEstateBrokersAssociation"] = 325] = "IOREBAIndustrialAndOfficeRealEstateBrokersAssociation";
    Designation[Designation["LEEDAPLEEDAccreditedProfessional"] = 326] = "LEEDAPLEEDAccreditedProfessional";
    Designation[Designation["MRICSMemberRoyalInstitutionofCharteredSurveyors"] = 327] = "MRICSMemberRoyalInstitutionofCharteredSurveyors";
    Designation[Designation["FRICSFellowRoyalInstitutionofCharteredSurveyors"] = 328] = "FRICSFellowRoyalInstitutionofCharteredSurveyors";
    Designation[Designation["FIABCIUSA"] = 330] = "FIABCIUSA";
    Designation[Designation["FIABCIWorldwide"] = 331] = "FIABCIWorldwide";
    Designation[Designation["InternationalCouncilofShoppingCentersICSC"] = 340] = "InternationalCouncilofShoppingCentersICSC";
    Designation[Designation["RLIRealtorsLandInstitute"] = 350] = "RLIRealtorsLandInstitute";
    Designation[Designation["ALCAccreditedLandConsultant"] = 360] = "ALCAccreditedLandConsultant";
})(Designation || (Designation = {}));
/** CoStar.Api.SuiteDetail.Types.OwnerType */
export var OwnerType;
(function (OwnerType) {
    OwnerType[OwnerType["None"] = 0] = "None";
    OwnerType[OwnerType["CorporateUser"] = 1] = "CorporateUser";
    OwnerType[OwnerType["PublicRealEstateInvestmentTrust"] = 2] = "PublicRealEstateInvestmentTrust";
    OwnerType[OwnerType["Individual"] = 3] = "Individual";
    OwnerType[OwnerType["Government"] = 4] = "Government";
    OwnerType[OwnerType["BankFinance"] = 5] = "BankFinance";
    OwnerType[OwnerType["DeveloperOwnerNational"] = 6] = "DeveloperOwnerNational";
    OwnerType[OwnerType["PensionFund"] = 7] = "PensionFund";
    OwnerType[OwnerType["Insurance"] = 8] = "Insurance";
    OwnerType[OwnerType["Nonprofit"] = 9] = "Nonprofit";
    OwnerType[OwnerType["Endowment"] = 10] = "Endowment";
    OwnerType[OwnerType["InvestmentManager"] = 11] = "InvestmentManager";
    OwnerType[OwnerType["OtherUnknown"] = 12] = "OtherUnknown";
    OwnerType[OwnerType["SovereignWealthFund"] = 13] = "SovereignWealthFund";
    OwnerType[OwnerType["RealEstateOperatingCompany"] = 14] = "RealEstateOperatingCompany";
    OwnerType[OwnerType["ListedFunds"] = 15] = "ListedFunds";
    OwnerType[OwnerType["DeveloperOwnerRegional"] = 16] = "DeveloperOwnerRegional";
    OwnerType[OwnerType["Trust"] = 17] = "Trust";
    OwnerType[OwnerType["TenantsInCommon"] = 18] = "TenantsInCommon";
    OwnerType[OwnerType["PrivateRealEstateInvestmentTrust"] = 19] = "PrivateRealEstateInvestmentTrust";
    OwnerType[OwnerType["OtherPrivate"] = 20] = "OtherPrivate";
    OwnerType[OwnerType["EquityFunds"] = 21] = "EquityFunds";
    OwnerType[OwnerType["Educational"] = 22] = "Educational";
    OwnerType[OwnerType["Religious"] = 24] = "Religious";
    OwnerType[OwnerType["Medical"] = 25] = "Medical";
    OwnerType[OwnerType["SpecialServicer"] = 26] = "SpecialServicer";
})(OwnerType || (OwnerType = {}));
/** CoStar.Api.SuiteDetail.Types.OwnerSuperType */
export var OwnerSuperType;
(function (OwnerSuperType) {
    OwnerSuperType[OwnerSuperType["None"] = 0] = "None";
    OwnerSuperType[OwnerSuperType["Institutional"] = 1] = "Institutional";
    OwnerSuperType[OwnerSuperType["Private"] = 2] = "Private";
    OwnerSuperType[OwnerSuperType["PrivateEquity"] = 3] = "PrivateEquity";
    OwnerSuperType[OwnerSuperType["Public"] = 4] = "Public";
    OwnerSuperType[OwnerSuperType["User"] = 5] = "User";
})(OwnerSuperType || (OwnerSuperType = {}));
/** CoStar.Api.SuiteDetail.Types.IncomeExpenseType */
export var IncomeExpenseType;
(function (IncomeExpenseType) {
    IncomeExpenseType[IncomeExpenseType["Portfolio"] = 0] = "Portfolio";
    IncomeExpenseType[IncomeExpenseType["Property"] = 1] = "Property";
    IncomeExpenseType[IncomeExpenseType["Condo"] = 2] = "Condo";
})(IncomeExpenseType || (IncomeExpenseType = {}));
/** CoStar.Api.SuiteDetail.Types.ListingAccessControlLevel */
export var ListingAccessControlLevel;
(function (ListingAccessControlLevel) {
    ListingAccessControlLevel[ListingAccessControlLevel["Everyone"] = 0] = "Everyone";
    ListingAccessControlLevel[ListingAccessControlLevel["Registration"] = 10] = "Registration";
    ListingAccessControlLevel[ListingAccessControlLevel["ConfidentialityAgreement"] = 20] = "ConfidentialityAgreement";
    ListingAccessControlLevel[ListingAccessControlLevel["SellerApproval"] = 30] = "SellerApproval";
})(ListingAccessControlLevel || (ListingAccessControlLevel = {}));
import { TimeZone } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.TimeZone */
export { TimeZone };
/** CoStar.Api.SuiteDetail.Types.BuildingParkType */
export var BuildingParkType;
(function (BuildingParkType) {
    BuildingParkType[BuildingParkType["None"] = 0] = "None";
    BuildingParkType[BuildingParkType["BusinessPark"] = 1] = "BusinessPark";
    BuildingParkType[BuildingParkType["IndustrialPark"] = 2] = "IndustrialPark";
    BuildingParkType[BuildingParkType["OfficePark"] = 3] = "OfficePark";
    BuildingParkType[BuildingParkType["ShoppingCenter"] = 4] = "ShoppingCenter";
})(BuildingParkType || (BuildingParkType = {}));
/** CoStar.Api.SuiteDetail.Types.InvestmentType */
export var InvestmentType;
(function (InvestmentType) {
    InvestmentType[InvestmentType["None"] = 0] = "None";
    InvestmentType[InvestmentType["Core"] = 1] = "Core";
    InvestmentType[InvestmentType["ValueAdd"] = 2] = "ValueAdd";
    InvestmentType[InvestmentType["Opportunistic"] = 4] = "Opportunistic";
    InvestmentType[InvestmentType["NNN"] = 8] = "NNN";
})(InvestmentType || (InvestmentType = {}));
/** CoStar.Api.SuiteDetail.Types.ItemType */
export var ItemType;
(function (ItemType) {
    ItemType[ItemType["None"] = 0] = "None";
    ItemType[ItemType["Unit"] = 1] = "Unit";
    ItemType[ItemType["Room"] = 2] = "Room";
})(ItemType || (ItemType = {}));
/** CoStar.Api.SuiteDetail.Types.PortfolioType */
export var PortfolioType;
(function (PortfolioType) {
    PortfolioType[PortfolioType["None"] = 0] = "None";
    PortfolioType[PortfolioType["MultipleProperty"] = 1] = "MultipleProperty";
    PortfolioType[PortfolioType["BulkPortfolio"] = 2] = "BulkPortfolio";
    PortfolioType[PortfolioType["PartOfMultipleProperty"] = 3] = "PartOfMultipleProperty";
    PortfolioType[PortfolioType["PartOfBulkPortfolio"] = 4] = "PartOfBulkPortfolio";
    PortfolioType[PortfolioType["MultipleCondo"] = 5] = "MultipleCondo";
})(PortfolioType || (PortfolioType = {}));
/** CoStar.Api.SuiteDetail.Types.SaleCondition */
export var SaleCondition;
(function (SaleCondition) {
    SaleCondition[SaleCondition["None"] = 0] = "None";
    SaleCondition[SaleCondition["DistressSale"] = 1] = "DistressSale";
    SaleCondition[SaleCondition["TenThreeOneExchange"] = 2] = "TenThreeOneExchange";
    SaleCondition[SaleCondition["SaleLeaseback"] = 3] = "SaleLeaseback";
    SaleCondition[SaleCondition["GroundLeaseLeasehold"] = 4] = "GroundLeaseLeasehold";
    SaleCondition[SaleCondition["GroundLeaseLeasedFee"] = 5] = "GroundLeaseLeasedFee";
    SaleCondition[SaleCondition["InvestmentTripleNet"] = 6] = "InvestmentTripleNet";
    SaleCondition[SaleCondition["DirectExchange"] = 7] = "DirectExchange";
    SaleCondition[SaleCondition["Assemblage"] = 8] = "Assemblage";
    SaleCondition[SaleCondition["AuctionSale"] = 9] = "AuctionSale";
    SaleCondition[SaleCondition["BuildToSuit"] = 11] = "BuildToSuit";
    SaleCondition[SaleCondition["BulkPortfolioSale"] = 12] = "BulkPortfolioSale";
    SaleCondition[SaleCondition["BusinessValueIncluded"] = 13] = "BusinessValueIncluded";
    SaleCondition[SaleCondition["CondoConversion"] = 14] = "CondoConversion";
    SaleCondition[SaleCondition["DeedRestriction"] = 15] = "DeedRestriction";
    SaleCondition[SaleCondition["EstateProbateSale"] = 16] = "EstateProbateSale";
    SaleCondition[SaleCondition["HistoricalSite"] = 17] = "HistoricalSite";
    SaleCondition[SaleCondition["LeaseOption"] = 18] = "LeaseOption";
    SaleCondition[SaleCondition["BuildingContaminationIssue"] = 19] = "BuildingContaminationIssue";
    SaleCondition[SaleCondition["DeferredMaintenance"] = 20] = "DeferredMaintenance";
    SaleCondition[SaleCondition["DoubleEscrow"] = 21] = "DoubleEscrow";
    SaleCondition[SaleCondition["ExerciseOfOption"] = 22] = "ExerciseOfOption";
    SaleCondition[SaleCondition["ExcessLand"] = 23] = "ExcessLand";
    SaleCondition[SaleCondition["Expansion"] = 24] = "Expansion";
    SaleCondition[SaleCondition["HighVacancyProperty"] = 25] = "HighVacancyProperty";
    SaleCondition[SaleCondition["LandContract"] = 26] = "LandContract";
    SaleCondition[SaleCondition["PartialInterestTransfer"] = 27] = "PartialInterestTransfer";
    SaleCondition[SaleCondition["PurchaseByTenant"] = 28] = "PurchaseByTenant";
    SaleCondition[SaleCondition["RedevelopmentProject"] = 29] = "RedevelopmentProject";
    SaleCondition[SaleCondition["RollingOptionTakedown"] = 30] = "RollingOptionTakedown";
    SaleCondition[SaleCondition["SoilContaminationIssue"] = 31] = "SoilContaminationIssue";
    SaleCondition[SaleCondition["BuildingInShellCondition"] = 32] = "BuildingInShellCondition";
    SaleCondition[SaleCondition["RealEstateOwnedSale"] = 33] = "RealEstateOwnedSale";
    SaleCondition[SaleCondition["ShortSale"] = 34] = "ShortSale";
    SaleCondition[SaleCondition["ThreatOfCondemnation"] = 35] = "ThreatOfCondemnation";
    SaleCondition[SaleCondition["CourtAppointedSale"] = 36] = "CourtAppointedSale";
    SaleCondition[SaleCondition["Recapitalization"] = 37] = "Recapitalization";
    SaleCondition[SaleCondition["DebtAssumption"] = 38] = "DebtAssumption";
    SaleCondition[SaleCondition["NotePurchase"] = 39] = "NotePurchase";
    SaleCondition[SaleCondition["BankruptcySale"] = 40] = "BankruptcySale";
    SaleCondition[SaleCondition["ZeroCashFlowInvestment"] = 41] = "ZeroCashFlowInvestment";
    SaleCondition[SaleCondition["LowIncomeHousingTaxCredit"] = 42] = "LowIncomeHousingTaxCredit";
    SaleCondition[SaleCondition["EntityBuyMembershipInterests"] = 43] = "EntityBuyMembershipInterests";
    SaleCondition[SaleCondition["CondoDeconversion"] = 44] = "CondoDeconversion";
})(SaleCondition || (SaleCondition = {}));
/** CoStar.Api.SuiteDetail.Types.SaleStatus */
export var SaleStatus;
(function (SaleStatus) {
    SaleStatus[SaleStatus["None"] = 0] = "None";
    SaleStatus[SaleStatus["Active"] = 1] = "Active";
    SaleStatus[SaleStatus["Escrow"] = 2] = "Escrow";
    SaleStatus[SaleStatus["Pending"] = 3] = "Pending";
    SaleStatus[SaleStatus["UnderContract"] = 4] = "UnderContract";
    SaleStatus[SaleStatus["Sold"] = 5] = "Sold";
    SaleStatus[SaleStatus["Withdrawn"] = 6] = "Withdrawn";
    SaleStatus[SaleStatus["Leased"] = 7] = "Leased";
    SaleStatus[SaleStatus["Rubbish"] = 8] = "Rubbish";
    SaleStatus[SaleStatus["Occupied"] = 9] = "Occupied";
})(SaleStatus || (SaleStatus = {}));
/** CoStar.Api.SuiteDetail.Types.SaleType */
export var SaleType;
(function (SaleType) {
    SaleType[SaleType["None"] = 0] = "None";
    SaleType[SaleType["Investment"] = 1] = "Investment";
    SaleType[SaleType["OwnerUser"] = 2] = "OwnerUser";
    SaleType[SaleType["InvestmentOROwnerUser"] = 3] = "InvestmentOROwnerUser";
})(SaleType || (SaleType = {}));
/** CoStar.Api.SuiteDetail.Types.Tenure */
export var Tenure;
(function (Tenure) {
    Tenure[Tenure["Unknown"] = 0] = "Unknown";
    Tenure[Tenure["Freehold"] = 1] = "Freehold";
    Tenure[Tenure["LongLeasehold"] = 2] = "LongLeasehold";
    Tenure[Tenure["FreeholdLongLeasehold"] = 3] = "FreeholdLongLeasehold";
})(Tenure || (Tenure = {}));
/** CoStar.Api.SuiteDetail.Types.FundStrategy */
export var FundStrategy;
(function (FundStrategy) {
    FundStrategy[FundStrategy["None"] = 0] = "None";
    FundStrategy[FundStrategy["RealEstateValueAdded"] = 1] = "RealEstateValueAdded";
    FundStrategy[FundStrategy["RealEstateOpportunistic"] = 2] = "RealEstateOpportunistic";
    FundStrategy[FundStrategy["RealEstateCore"] = 3] = "RealEstateCore";
    FundStrategy[FundStrategy["RealEstateDebt"] = 4] = "RealEstateDebt";
    FundStrategy[FundStrategy["RealEstateCorePlus"] = 5] = "RealEstateCorePlus";
    FundStrategy[FundStrategy["RealEstateFundofFunds"] = 6] = "RealEstateFundofFunds";
    FundStrategy[FundStrategy["RealEstate"] = 7] = "RealEstate";
    FundStrategy[FundStrategy["RealEstateDistressed"] = 8] = "RealEstateDistressed";
    FundStrategy[FundStrategy["RealEstateCoInvestment"] = 9] = "RealEstateCoInvestment";
    FundStrategy[FundStrategy["RealEstateSecondaries"] = 10] = "RealEstateSecondaries";
})(FundStrategy || (FundStrategy = {}));
/** CoStar.Api.SuiteDetail.Types.Continent */
export var Continent;
(function (Continent) {
    Continent[Continent["None"] = 0] = "None";
    Continent[Continent["Africa"] = 1] = "Africa";
    Continent[Continent["Antarctica"] = 2] = "Antarctica";
    Continent[Continent["Asia"] = 3] = "Asia";
    Continent[Continent["Europe"] = 4] = "Europe";
    Continent[Continent["NorthAmerica"] = 5] = "NorthAmerica";
    Continent[Continent["SouthAmerica"] = 6] = "SouthAmerica";
    Continent[Continent["Australia"] = 7] = "Australia";
    Continent[Continent["Americas"] = 8] = "Americas";
    Continent[Continent["AsiaPacific"] = 9] = "AsiaPacific";
    Continent[Continent["MiddleEastAndAfrica"] = 10] = "MiddleEastAndAfrica";
})(Continent || (Continent = {}));
/** CoStar.Api.SuiteDetail.Types.FundStatus */
export var FundStatus;
(function (FundStatus) {
    FundStatus[FundStatus["None"] = 0] = "None";
    FundStatus[FundStatus["Closed"] = 1] = "Closed";
    FundStatus[FundStatus["Liquidated"] = 2] = "Liquidated";
    FundStatus[FundStatus["OpenEnded"] = 3] = "OpenEnded";
    FundStatus[FundStatus["AnnouncedOrEstimated"] = 4] = "AnnouncedOrEstimated";
    FundStatus[FundStatus["SemiOpenEnded"] = 5] = "SemiOpenEnded";
    FundStatus[FundStatus["Evergreen"] = 6] = "Evergreen";
    FundStatus[FundStatus["Raising"] = 7] = "Raising";
    FundStatus[FundStatus["Listed"] = 8] = "Listed";
    FundStatus[FundStatus["FirstClose"] = 9] = "FirstClose";
    FundStatus[FundStatus["SecondClose"] = 10] = "SecondClose";
    FundStatus[FundStatus["ThirdClose"] = 11] = "ThirdClose";
    FundStatus[FundStatus["FourthClose"] = 12] = "FourthClose";
    FundStatus[FundStatus["FifthClose"] = 13] = "FifthClose";
    FundStatus[FundStatus["SixthClose"] = 14] = "SixthClose";
})(FundStatus || (FundStatus = {}));
import { FundStructure } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteDetail.Types.FundStructure */
export { FundStructure };
/** CoStar.Api.SuiteDetail.Types.ContactRole */
export var ContactRole;
(function (ContactRole) {
    ContactRole[ContactRole["None"] = 0] = "None";
    ContactRole[ContactRole["DeveloperConstruction"] = 1] = "DeveloperConstruction";
    ContactRole[ContactRole["Architect"] = 2] = "Architect";
    ContactRole[ContactRole["RecordedOwner"] = 3] = "RecordedOwner";
    ContactRole[ContactRole["PropertyManager"] = 4] = "PropertyManager";
    ContactRole[ContactRole["PrimaryLeasingCoLandlord"] = 6] = "PrimaryLeasingCoLandlord";
    ContactRole[ContactRole["TrueOwner"] = 7] = "TrueOwner";
    ContactRole[ContactRole["SignAgent"] = 8] = "SignAgent";
    ContactRole[ContactRole["AssetOrPortfolioManager"] = 9] = "AssetOrPortfolioManager";
    ContactRole[ContactRole["BuyerBroker"] = 10] = "BuyerBroker";
    ContactRole[ContactRole["ListingBroker"] = 11] = "ListingBroker";
    ContactRole[ContactRole["TenantRep"] = 15] = "TenantRep";
    ContactRole[ContactRole["DecisionMakerLeasing"] = 17] = "DecisionMakerLeasing";
    ContactRole[ContactRole["DecisionInfluencerLeasing"] = 18] = "DecisionInfluencerLeasing";
    ContactRole[ContactRole["LeasingCompany"] = 20] = "LeasingCompany";
    ContactRole[ContactRole["Principal"] = 26] = "Principal";
    ContactRole[ContactRole["SurveyContact"] = 27] = "SurveyContact";
    ContactRole[ContactRole["CenterMailContact"] = 28] = "CenterMailContact";
    ContactRole[ContactRole["CenterManager"] = 29] = "CenterManager";
    ContactRole[ContactRole["AsstAssocCenterManager"] = 30] = "AsstAssocCenterManager";
    ContactRole[ContactRole["Marketing"] = 31] = "Marketing";
    ContactRole[ContactRole["SpecialtyLeasingManager"] = 32] = "SpecialtyLeasingManager";
    ContactRole[ContactRole["BuildingSuperintendent"] = 33] = "BuildingSuperintendent";
    ContactRole[ContactRole["SecuritySupervisor"] = 34] = "SecuritySupervisor";
    ContactRole[ContactRole["AdvertisingManager"] = 35] = "AdvertisingManager";
    ContactRole[ContactRole["SpecialEventsManager"] = 36] = "SpecialEventsManager";
    ContactRole[ContactRole["PromotionDirectorManager"] = 37] = "PromotionDirectorManager";
    ContactRole[ContactRole["Other"] = 38] = "Other";
    ContactRole[ContactRole["RecordedSeller"] = 39] = "RecordedSeller";
    ContactRole[ContactRole["TrueSeller"] = 40] = "TrueSeller";
    ContactRole[ContactRole["Attorney"] = 41] = "Attorney";
    ContactRole[ContactRole["RecordedBuyer"] = 42] = "RecordedBuyer";
    ContactRole[ContactRole["TrueBuyer"] = 43] = "TrueBuyer";
    ContactRole[ContactRole["BuyerContact"] = 44] = "BuyerContact";
    ContactRole[ContactRole["SellerContact"] = 45] = "SellerContact";
    ContactRole[ContactRole["ListingAgent"] = 46] = "ListingAgent";
    ContactRole[ContactRole["LeasingAgent"] = 47] = "LeasingAgent";
    ContactRole[ContactRole["TenantContact"] = 48] = "TenantContact";
    ContactRole[ContactRole["Preparer"] = 49] = "Preparer";
    ContactRole[ContactRole["ListingAdministrator"] = 50] = "ListingAdministrator";
    ContactRole[ContactRole["SurveillanceOperator"] = 51] = "SurveillanceOperator";
    ContactRole[ContactRole["OwnerListingContact"] = 52] = "OwnerListingContact";
    ContactRole[ContactRole["WestSideRentalsListingAdministrator"] = 53] = "WestSideRentalsListingAdministrator";
    ContactRole[ContactRole["SocialAdminSetupContact"] = 54] = "SocialAdminSetupContact";
    ContactRole[ContactRole["OwnerListingAdministrator"] = 55] = "OwnerListingAdministrator";
    ContactRole[ContactRole["OwnerPermissionAdministrator"] = 56] = "OwnerPermissionAdministrator";
    ContactRole[ContactRole["ListingPermissionAdministrator"] = 57] = "ListingPermissionAdministrator";
    ContactRole[ContactRole["HotelMembershipCompany"] = 58] = "HotelMembershipCompany";
    ContactRole[ContactRole["AcquisitionsDispositions"] = 59] = "AcquisitionsDispositions";
    ContactRole[ContactRole["Leasing"] = 62] = "Leasing";
    ContactRole[ContactRole["Finance"] = 63] = "Finance";
    ContactRole[ContactRole["InvestorRelations"] = 64] = "InvestorRelations";
    ContactRole[ContactRole["Research"] = 66] = "Research";
    ContactRole[ContactRole["HRLegalITAndOperations"] = 67] = "HRLegalITAndOperations";
    ContactRole[ContactRole["DecisionMakerAcquisitions"] = 68] = "DecisionMakerAcquisitions";
    ContactRole[ContactRole["DecisionInfluencerAcquisitions"] = 69] = "DecisionInfluencerAcquisitions";
    ContactRole[ContactRole["DecisionMakerProductPurchase"] = 70] = "DecisionMakerProductPurchase";
    ContactRole[ContactRole["DecisionInfluencerProductPurchase"] = 71] = "DecisionInfluencerProductPurchase";
    ContactRole[ContactRole["Servicer"] = 72] = "Servicer";
    ContactRole[ContactRole["Borrower"] = 73] = "Borrower";
    ContactRole[ContactRole["SpecialServicer"] = 74] = "SpecialServicer";
    ContactRole[ContactRole["Originator"] = 75] = "Originator";
    ContactRole[ContactRole["Sponsor"] = 76] = "Sponsor";
    ContactRole[ContactRole["HotelOperator"] = 77] = "HotelOperator";
    ContactRole[ContactRole["Auctioneer"] = 78] = "Auctioneer";
    ContactRole[ContactRole["AuctionManager"] = 79] = "AuctionManager";
    ContactRole[ContactRole["GeneralContractor"] = 80] = "GeneralContractor";
    ContactRole[ContactRole["TitleCompany"] = 81] = "TitleCompany";
    ContactRole[ContactRole["EscrowCompany"] = 82] = "EscrowCompany";
    ContactRole[ContactRole["AuctionAssetManager"] = 83] = "AuctionAssetManager";
    ContactRole[ContactRole["ReportVendor"] = 84] = "ReportVendor";
    ContactRole[ContactRole["FundManager"] = 85] = "FundManager";
    ContactRole[ContactRole["LawFirm"] = 86] = "LawFirm";
    ContactRole[ContactRole["Auditor"] = 87] = "Auditor";
    ContactRole[ContactRole["FundPlacementAgent"] = 88] = "FundPlacementAgent";
    ContactRole[ContactRole["FundAdministrator"] = 89] = "FundAdministrator";
    ContactRole[ContactRole["Investor"] = 90] = "Investor";
    ContactRole[ContactRole["MediaSchedulingContact"] = 91] = "MediaSchedulingContact";
    ContactRole[ContactRole["SubletContact"] = 1000] = "SubletContact";
    ContactRole[ContactRole["PreviousTrueOwner"] = 1001] = "PreviousTrueOwner";
    ContactRole[ContactRole["PreviousRecordedOwner"] = 1002] = "PreviousRecordedOwner";
    ContactRole[ContactRole["ExecutiveLeadershipPrincipal"] = 1003] = "ExecutiveLeadershipPrincipal";
    ContactRole[ContactRole["LeaseCompsAdministrator"] = 1004] = "LeaseCompsAdministrator";
    ContactRole[ContactRole["FeedContact"] = 1005] = "FeedContact";
    ContactRole[ContactRole["ConstructionCompany"] = 1006] = "ConstructionCompany";
    ContactRole[ContactRole["PromotingOwner"] = 1007] = "PromotingOwner";
    ContactRole[ContactRole["CoWorkingCompany"] = 2000] = "CoWorkingCompany";
})(ContactRole || (ContactRole = {}));
import { IndustryType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteDetail.Types.IndustryType */
export { IndustryType };
/** CoStar.Api.SuiteDetail.Types.BuildingRating */
export var BuildingRating;
(function (BuildingRating) {
    BuildingRating[BuildingRating["None"] = 0] = "None";
    BuildingRating[BuildingRating["OneStar"] = 1] = "OneStar";
    BuildingRating[BuildingRating["TwoStar"] = 2] = "TwoStar";
    BuildingRating[BuildingRating["ThreeStar"] = 3] = "ThreeStar";
    BuildingRating[BuildingRating["FourStar"] = 4] = "FourStar";
    BuildingRating[BuildingRating["FiveStar"] = 5] = "FiveStar";
})(BuildingRating || (BuildingRating = {}));
/** CoStar.Api.SuiteDetail.Types.TopographyType */
export var TopographyType;
(function (TopographyType) {
    TopographyType[TopographyType["Default"] = 0] = "Default";
    TopographyType[TopographyType["Level"] = 1] = "Level";
    TopographyType[TopographyType["Rolling"] = 2] = "Rolling";
    TopographyType[TopographyType["Sloping"] = 3] = "Sloping";
    TopographyType[TopographyType["Steep"] = 4] = "Steep";
})(TopographyType || (TopographyType = {}));
/** CoStar.Api.SuiteDetail.Types.OnsiteImprovementType */
export var OnsiteImprovementType;
(function (OnsiteImprovementType) {
    OnsiteImprovementType[OnsiteImprovementType["Default"] = 0] = "Default";
    OnsiteImprovementType[OnsiteImprovementType["AsphaltPavedLot"] = 1] = "AsphaltPavedLot";
    OnsiteImprovementType[OnsiteImprovementType["FinishGrade"] = 2] = "FinishGrade";
    OnsiteImprovementType[OnsiteImprovementType["FinishedLot"] = 3] = "FinishedLot";
    OnsiteImprovementType[OnsiteImprovementType["PreviouslyDevelopedLot"] = 4] = "PreviouslyDevelopedLot";
    OnsiteImprovementType[OnsiteImprovementType["RawLand"] = 5] = "RawLand";
    OnsiteImprovementType[OnsiteImprovementType["RoughGraded"] = 6] = "RoughGraded";
})(OnsiteImprovementType || (OnsiteImprovementType = {}));
import { LandType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteDetail.Types.LandType */
export { LandType };
/** CoStar.Api.SuiteDetail.Types.DevelopmentApprovalType */
export var DevelopmentApprovalType;
(function (DevelopmentApprovalType) {
    DevelopmentApprovalType[DevelopmentApprovalType["Default"] = 0] = "Default";
    DevelopmentApprovalType[DevelopmentApprovalType["Maps"] = 1] = "Maps";
    DevelopmentApprovalType[DevelopmentApprovalType["Engineering"] = 2] = "Engineering";
    DevelopmentApprovalType[DevelopmentApprovalType["ApprovedPlan"] = 3] = "ApprovedPlan";
})(DevelopmentApprovalType || (DevelopmentApprovalType = {}));
/** CoStar.Api.SuiteDetail.Types.ProposedLandUse */
export var ProposedLandUse;
(function (ProposedLandUse) {
    ProposedLandUse[ProposedLandUse["None"] = 0] = "None";
    ProposedLandUse[ProposedLandUse["Commercial"] = 1] = "Commercial";
    ProposedLandUse[ProposedLandUse["Industrial"] = 2] = "Industrial";
    ProposedLandUse[ProposedLandUse["Retail"] = 3] = "Retail";
    ProposedLandUse[ProposedLandUse["Office"] = 4] = "Office";
    ProposedLandUse[ProposedLandUse["MixedUse"] = 5] = "MixedUse";
    ProposedLandUse[ProposedLandUse["Multifamily"] = 6] = "Multifamily";
    ProposedLandUse[ProposedLandUse["Hospitality"] = 7] = "Hospitality";
    ProposedLandUse[ProposedLandUse["AirplaneHangar"] = 8] = "AirplaneHangar";
    ProposedLandUse[ProposedLandUse["Airport"] = 9] = "Airport";
    ProposedLandUse[ProposedLandUse["ApartmentUnits"] = 10] = "ApartmentUnits";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsCondo"] = 11] = "ApartmentUnitsCondo";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsDorms"] = 12] = "ApartmentUnitsDorms";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsSenior"] = 13] = "ApartmentUnitsSenior";
    ProposedLandUse[ProposedLandUse["ApartmentUnitsSubsidized"] = 14] = "ApartmentUnitsSubsidized";
    ProposedLandUse[ProposedLandUse["AutoDealership"] = 15] = "AutoDealership";
    ProposedLandUse[ProposedLandUse["AutoRepair"] = 16] = "AutoRepair";
    ProposedLandUse[ProposedLandUse["AutoSalvageFacility"] = 17] = "AutoSalvageFacility";
    ProposedLandUse[ProposedLandUse["Bank"] = 18] = "Bank";
    ProposedLandUse[ProposedLandUse["Bar"] = 19] = "Bar";
    ProposedLandUse[ProposedLandUse["BaseballField"] = 20] = "BaseballField";
    ProposedLandUse[ProposedLandUse["BowlingAlley"] = 21] = "BowlingAlley";
    ProposedLandUse[ProposedLandUse["Carwash"] = 22] = "Carwash";
    ProposedLandUse[ProposedLandUse["Casino"] = 23] = "Casino";
    ProposedLandUse[ProposedLandUse["CementGravelPlant"] = 24] = "CementGravelPlant";
    ProposedLandUse[ProposedLandUse["CemeteryMausoleum"] = 25] = "CemeteryMausoleum";
    ProposedLandUse[ProposedLandUse["ChemicalOilRefinery"] = 26] = "ChemicalOilRefinery";
    ProposedLandUse[ProposedLandUse["CommunityCenter"] = 27] = "CommunityCenter";
    ProposedLandUse[ProposedLandUse["ContractorStorageYard"] = 28] = "ContractorStorageYard";
    ProposedLandUse[ProposedLandUse["ConvenienceStore"] = 29] = "ConvenienceStore";
    ProposedLandUse[ProposedLandUse["CorrectionalFacility"] = 30] = "CorrectionalFacility";
    ProposedLandUse[ProposedLandUse["DayCareCenter"] = 31] = "DayCareCenter";
    ProposedLandUse[ProposedLandUse["DepartmentStore"] = 32] = "DepartmentStore";
    ProposedLandUse[ProposedLandUse["Distribution"] = 33] = "Distribution";
    ProposedLandUse[ProposedLandUse["Drugstore"] = 34] = "Drugstore";
    ProposedLandUse[ProposedLandUse["FastFood"] = 35] = "FastFood";
    ProposedLandUse[ProposedLandUse["FoodProcessing"] = 36] = "FoodProcessing";
    ProposedLandUse[ProposedLandUse["FuneralHome"] = 37] = "FuneralHome";
    ProposedLandUse[ProposedLandUse["GardenCenter"] = 38] = "GardenCenter";
    ProposedLandUse[ProposedLandUse["GeneralFreestanding"] = 39] = "GeneralFreestanding";
    ProposedLandUse[ProposedLandUse["GolfCourseDrivingRange"] = 40] = "GolfCourseDrivingRange";
    ProposedLandUse[ProposedLandUse["Healthcare"] = 41] = "Healthcare";
    ProposedLandUse[ProposedLandUse["HealthClub"] = 42] = "HealthClub";
    ProposedLandUse[ProposedLandUse["HoldForDevelopment"] = 43] = "HoldForDevelopment";
    ProposedLandUse[ProposedLandUse["HoldForInvestment"] = 44] = "HoldForInvestment";
    ProposedLandUse[ProposedLandUse["HorseStables"] = 45] = "HorseStables";
    ProposedLandUse[ProposedLandUse["Hospital"] = 46] = "Hospital";
    ProposedLandUse[ProposedLandUse["Hotel"] = 47] = "Hotel";
    ProposedLandUse[ProposedLandUse["IndustrialLiveWorkUnit"] = 48] = "IndustrialLiveWorkUnit";
    ProposedLandUse[ProposedLandUse["IndustrialPark"] = 49] = "IndustrialPark";
    ProposedLandUse[ProposedLandUse["Landfill"] = 50] = "Landfill";
    ProposedLandUse[ProposedLandUse["LodgeMeetingHall"] = 51] = "LodgeMeetingHall";
    ProposedLandUse[ProposedLandUse["LoftCreativeSpace"] = 52] = "LoftCreativeSpace";
    ProposedLandUse[ProposedLandUse["Lumberyard"] = 53] = "Lumberyard";
    ProposedLandUse[ProposedLandUse["ManufacturedHomesMobileHomePark"] = 54] = "ManufacturedHomesMobileHomePark";
    ProposedLandUse[ProposedLandUse["Marina"] = 55] = "Marina";
    ProposedLandUse[ProposedLandUse["MasterPlannedCommunity"] = 56] = "MasterPlannedCommunity";
    ProposedLandUse[ProposedLandUse["Medical"] = 57] = "Medical";
    ProposedLandUse[ProposedLandUse["Motel"] = 58] = "Motel";
    ProposedLandUse[ProposedLandUse["MovieTheater"] = 59] = "MovieTheater";
    ProposedLandUse[ProposedLandUse["MovieRadioTVStudio"] = 60] = "MovieRadioTVStudio";
    ProposedLandUse[ProposedLandUse["NeighborhoodCenter"] = 61] = "NeighborhoodCenter";
    ProposedLandUse[ProposedLandUse["OfficePark"] = 62] = "OfficePark";
    ProposedLandUse[ProposedLandUse["OpenSpace"] = 63] = "OpenSpace";
    ProposedLandUse[ProposedLandUse["OutletCenter"] = 64] = "OutletCenter";
    ProposedLandUse[ProposedLandUse["ParkingGarage"] = 65] = "ParkingGarage";
    ProposedLandUse[ProposedLandUse["ParkingLot"] = 66] = "ParkingLot";
    ProposedLandUse[ProposedLandUse["PlannedUnitDevelopment"] = 67] = "PlannedUnitDevelopment";
    ProposedLandUse[ProposedLandUse["PoliceFireStation"] = 68] = "PoliceFireStation";
    ProposedLandUse[ProposedLandUse["PostOffice"] = 69] = "PostOffice";
    ProposedLandUse[ProposedLandUse["PowerCenter"] = 70] = "PowerCenter";
    ProposedLandUse[ProposedLandUse["PublicLibrary"] = 71] = "PublicLibrary";
    ProposedLandUse[ProposedLandUse["PublicPark"] = 72] = "PublicPark";
    ProposedLandUse[ProposedLandUse["PublicSwimmingPool"] = 73] = "PublicSwimmingPool";
    ProposedLandUse[ProposedLandUse["ResearchAndDevelopment"] = 74] = "ResearchAndDevelopment";
    ProposedLandUse[ProposedLandUse["RaceTrack"] = 75] = "RaceTrack";
    ProposedLandUse[ProposedLandUse["RadioTVTransmissionFacility"] = 76] = "RadioTVTransmissionFacility";
    ProposedLandUse[ProposedLandUse["RailroadYard"] = 77] = "RailroadYard";
    ProposedLandUse[ProposedLandUse["RecyclingCenter"] = 78] = "RecyclingCenter";
    ProposedLandUse[ProposedLandUse["RefrigerationColdStorage"] = 79] = "RefrigerationColdStorage";
    ProposedLandUse[ProposedLandUse["RegionalMall"] = 80] = "RegionalMall";
    ProposedLandUse[ProposedLandUse["RehabilitationCenter"] = 81] = "RehabilitationCenter";
    ProposedLandUse[ProposedLandUse["ReligiousFacility"] = 82] = "ReligiousFacility";
    ProposedLandUse[ProposedLandUse["Restaurant"] = 83] = "Restaurant";
    ProposedLandUse[ProposedLandUse["RetailWarehouse"] = 84] = "RetailWarehouse";
    ProposedLandUse[ProposedLandUse["Schools"] = 85] = "Schools";
    ProposedLandUse[ProposedLandUse["SelfStorage"] = 86] = "SelfStorage";
    ProposedLandUse[ProposedLandUse["ServiceStation"] = 87] = "ServiceStation";
    ProposedLandUse[ProposedLandUse["Shelter"] = 88] = "Shelter";
    ProposedLandUse[ProposedLandUse["Shipyard"] = 89] = "Shipyard";
    ProposedLandUse[ProposedLandUse["SingleFamilyDevelopment"] = 90] = "SingleFamilyDevelopment";
    ProposedLandUse[ProposedLandUse["SkatingRink"] = 91] = "SkatingRink";
    ProposedLandUse[ProposedLandUse["SpecialtyFestivalEntertainment"] = 92] = "SpecialtyFestivalEntertainment";
    ProposedLandUse[ProposedLandUse["Storefront"] = 93] = "Storefront";
    ProposedLandUse[ProposedLandUse["StorefrontRetailOffice"] = 94] = "StorefrontRetailOffice";
    ProposedLandUse[ProposedLandUse["StorefrontRetailResidential"] = 95] = "StorefrontRetailResidential";
    ProposedLandUse[ProposedLandUse["StripCenter"] = 96] = "StripCenter";
    ProposedLandUse[ProposedLandUse["Supermarket"] = 97] = "Supermarket";
    ProposedLandUse[ProposedLandUse["TheaterConcertHall"] = 98] = "TheaterConcertHall";
    ProposedLandUse[ProposedLandUse["TrailerCamperPark"] = 99] = "TrailerCamperPark";
    ProposedLandUse[ProposedLandUse["TruckStop"] = 100] = "TruckStop";
    ProposedLandUse[ProposedLandUse["TruckTerminal"] = 101] = "TruckTerminal";
    ProposedLandUse[ProposedLandUse["Unknown"] = 102] = "Unknown";
    ProposedLandUse[ProposedLandUse["UtilitySubstation"] = 103] = "UtilitySubstation";
    ProposedLandUse[ProposedLandUse["VeterinarianKennel"] = 104] = "VeterinarianKennel";
    ProposedLandUse[ProposedLandUse["Warehouse"] = 105] = "Warehouse";
    ProposedLandUse[ProposedLandUse["WaterRetentionFacility"] = 106] = "WaterRetentionFacility";
    ProposedLandUse[ProposedLandUse["WaterTreatmentFacility"] = 107] = "WaterTreatmentFacility";
    ProposedLandUse[ProposedLandUse["WineryVineyard"] = 108] = "WineryVineyard";
    ProposedLandUse[ProposedLandUse["AmusementPark"] = 109] = "AmusementPark";
    ProposedLandUse[ProposedLandUse["Agricultural"] = 110] = "Agricultural";
    ProposedLandUse[ProposedLandUse["Agribusiness"] = 111] = "Agribusiness";
    ProposedLandUse[ProposedLandUse["PastureRanch"] = 112] = "PastureRanch";
    ProposedLandUse[ProposedLandUse["Timberland"] = 113] = "Timberland";
    ProposedLandUse[ProposedLandUse["SingleFamilyResidence"] = 114] = "SingleFamilyResidence";
})(ProposedLandUse || (ProposedLandUse = {}));
/** CoStar.Api.SuiteDetail.Types.OffsiteImprovementType */
export var OffsiteImprovementType;
(function (OffsiteImprovementType) {
    OffsiteImprovementType[OffsiteImprovementType["Default"] = 0] = "Default";
    OffsiteImprovementType[OffsiteImprovementType["Sewer"] = 1] = "Sewer";
    OffsiteImprovementType[OffsiteImprovementType["Water"] = 2] = "Water";
    OffsiteImprovementType[OffsiteImprovementType["Electricity"] = 3] = "Electricity";
    OffsiteImprovementType[OffsiteImprovementType["Gas"] = 4] = "Gas";
    OffsiteImprovementType[OffsiteImprovementType["Streets"] = 5] = "Streets";
    OffsiteImprovementType[OffsiteImprovementType["CurbGutterSidewalk"] = 6] = "CurbGutterSidewalk";
    OffsiteImprovementType[OffsiteImprovementType["Cable"] = 7] = "Cable";
    OffsiteImprovementType[OffsiteImprovementType["Telephone"] = 8] = "Telephone";
    OffsiteImprovementType[OffsiteImprovementType["Irrigation"] = 9] = "Irrigation";
})(OffsiteImprovementType || (OffsiteImprovementType = {}));
/** CoStar.Api.SuiteDetail.Types.LeaseDealRentType */
export var LeaseDealRentType;
(function (LeaseDealRentType) {
    LeaseDealRentType[LeaseDealRentType["None"] = 0] = "None";
    LeaseDealRentType[LeaseDealRentType["Effective"] = 1] = "Effective";
    LeaseDealRentType[LeaseDealRentType["Contract"] = 2] = "Contract";
    LeaseDealRentType[LeaseDealRentType["Asking"] = 3] = "Asking";
})(LeaseDealRentType || (LeaseDealRentType = {}));
/** CoStar.Api.SuiteDetail.Types.RentPlusType */
export var RentPlusType;
(function (RentPlusType) {
    RentPlusType[RentPlusType["None"] = 0] = "None";
    RentPlusType[RentPlusType["AdditionalRent"] = 1] = "AdditionalRent";
    RentPlusType[RentPlusType["Tmi"] = 2] = "Tmi";
})(RentPlusType || (RentPlusType = {}));
/** CoStar.Api.SuiteDetail.Types.RentType */
export var RentType;
(function (RentType) {
    RentType[RentType["AmountPerArea"] = 0] = "AmountPerArea";
    RentType[RentType["AmountPerMonth"] = 1] = "AmountPerMonth";
    RentType[RentType["AmountPerYear"] = 2] = "AmountPerYear";
})(RentType || (RentType = {}));
/** CoStar.Api.SuiteDetail.Types.LeaseCompSearchRateSource */
export var LeaseCompSearchRateSource;
(function (LeaseCompSearchRateSource) {
    LeaseCompSearchRateSource[LeaseCompSearchRateSource["None"] = 0] = "None";
    LeaseCompSearchRateSource[LeaseCompSearchRateSource["EffectiveRate"] = 1] = "EffectiveRate";
    LeaseCompSearchRateSource[LeaseCompSearchRateSource["ContractRate"] = 2] = "ContractRate";
    LeaseCompSearchRateSource[LeaseCompSearchRateSource["ContractRateEstimatedFullService"] = 3] = "ContractRateEstimatedFullService";
    LeaseCompSearchRateSource[LeaseCompSearchRateSource["AskingMinMaxRate"] = 4] = "AskingMinMaxRate";
})(LeaseCompSearchRateSource || (LeaseCompSearchRateSource = {}));
/** CoStar.Api.SuiteDetail.Types.LeaseCompSource */
export var LeaseCompSource;
(function (LeaseCompSource) {
    LeaseCompSource[LeaseCompSource["None"] = 0] = "None";
    LeaseCompSource[LeaseCompSource["CoStar"] = 1] = "CoStar";
    LeaseCompSource[LeaseCompSource["UserEnteredComp"] = 2] = "UserEnteredComp";
    LeaseCompSource[LeaseCompSource["Shared"] = 3] = "Shared";
})(LeaseCompSource || (LeaseCompSource = {}));
/** CoStar.Api.SuiteDetail.Types.LeaseType */
export var LeaseType;
(function (LeaseType) {
    LeaseType[LeaseType["None"] = 0] = "None";
    LeaseType[LeaseType["Direct"] = 1] = "Direct";
    LeaseType[LeaseType["Sublease"] = 2] = "Sublease";
    LeaseType[LeaseType["MonthToMonth"] = 3] = "MonthToMonth";
    LeaseType[LeaseType["Owned"] = 4] = "Owned";
    LeaseType[LeaseType["Assignment"] = 5] = "Assignment";
})(LeaseType || (LeaseType = {}));
/** CoStar.Api.SuiteDetail.Types.LeaseBreakType */
export var LeaseBreakType;
(function (LeaseBreakType) {
    LeaseBreakType[LeaseBreakType["None"] = 0] = "None";
    LeaseBreakType[LeaseBreakType["Landlord"] = 1] = "Landlord";
    LeaseBreakType[LeaseBreakType["Tenant"] = 2] = "Tenant";
    LeaseBreakType[LeaseBreakType["Mutual"] = 3] = "Mutual";
})(LeaseBreakType || (LeaseBreakType = {}));
/** CoStar.Api.SuiteDetail.Types.RateEscalationAmountType */
export var RateEscalationAmountType;
(function (RateEscalationAmountType) {
    RateEscalationAmountType[RateEscalationAmountType["None"] = 0] = "None";
    RateEscalationAmountType[RateEscalationAmountType["StepRateOrAmount"] = 1] = "StepRateOrAmount";
    RateEscalationAmountType[RateEscalationAmountType["StepPercent"] = 2] = "StepPercent";
    RateEscalationAmountType[RateEscalationAmountType["Cpi"] = 3] = "Cpi";
    RateEscalationAmountType[RateEscalationAmountType["ToMarket"] = 4] = "ToMarket";
})(RateEscalationAmountType || (RateEscalationAmountType = {}));
/** CoStar.Api.SuiteDetail.Types.RateEscalationType */
export var RateEscalationType;
(function (RateEscalationType) {
    RateEscalationType[RateEscalationType["Unknown"] = 0] = "Unknown";
    RateEscalationType[RateEscalationType["MonetaryIncrease"] = 1] = "MonetaryIncrease";
    RateEscalationType[RateEscalationType["IndexIncrease"] = 2] = "IndexIncrease";
    RateEscalationType[RateEscalationType["FixedPercentIncrease"] = 3] = "FixedPercentIncrease";
    RateEscalationType[RateEscalationType["Negotiable"] = 4] = "Negotiable";
    RateEscalationType[RateEscalationType["PorterWageWithFringe"] = 5] = "PorterWageWithFringe";
    RateEscalationType[RateEscalationType["PorterWageWithoutFringe"] = 6] = "PorterWageWithoutFringe";
    RateEscalationType[RateEscalationType["Fuel"] = 7] = "Fuel";
    RateEscalationType[RateEscalationType["RetailPercentageIncrease"] = 8] = "RetailPercentageIncrease";
    RateEscalationType[RateEscalationType["RetailOverageIncrease"] = 9] = "RetailOverageIncrease";
    RateEscalationType[RateEscalationType["None"] = 10] = "None";
    RateEscalationType[RateEscalationType["Other"] = 11] = "Other";
    RateEscalationType[RateEscalationType["ToMarket"] = 12] = "ToMarket";
    RateEscalationType[RateEscalationType["EachCalendarYear"] = 13] = "EachCalendarYear";
    RateEscalationType[RateEscalationType["MidLeaseTerm"] = 14] = "MidLeaseTerm";
    RateEscalationType[RateEscalationType["SpecificDate"] = 15] = "SpecificDate";
    RateEscalationType[RateEscalationType["IntervalAfterLeaseStart"] = 16] = "IntervalAfterLeaseStart";
    RateEscalationType[RateEscalationType["IntervalStartingOnSpecDate"] = 17] = "IntervalStartingOnSpecDate";
})(RateEscalationType || (RateEscalationType = {}));
/** CoStar.Api.SuiteDetail.Types.LeaseReviewType */
export var LeaseReviewType;
(function (LeaseReviewType) {
    LeaseReviewType[LeaseReviewType["None"] = 0] = "None";
    LeaseReviewType[LeaseReviewType["OpenMarket"] = 1] = "OpenMarket";
    LeaseReviewType[LeaseReviewType["Index"] = 2] = "Index";
})(LeaseReviewType || (LeaseReviewType = {}));
import { BuildOutStatus } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.BuildOutStatus */
export { BuildOutStatus };
/** CoStar.Api.SuiteDetail.Types.BuildOut */
export var BuildOut;
(function (BuildOut) {
    BuildOut[BuildOut["None"] = 0] = "None";
    BuildOut[BuildOut["StandardOffice"] = 1] = "StandardOffice";
    BuildOut[BuildOut["FinancialServices"] = 2] = "FinancialServices";
    BuildOut[BuildOut["ProfessionalServices"] = 3] = "ProfessionalServices";
    BuildOut[BuildOut["LawFirm"] = 4] = "LawFirm";
    BuildOut[BuildOut["CallCenter"] = 5] = "CallCenter";
    BuildOut[BuildOut["GovernmentFacility"] = 7] = "GovernmentFacility";
    BuildOut[BuildOut["LiveWork"] = 8] = "LiveWork";
    BuildOut[BuildOut["StandardIndustrial"] = 9] = "StandardIndustrial";
    BuildOut[BuildOut["StorageAndDistribution"] = 10] = "StorageAndDistribution";
    BuildOut[BuildOut["SelfStorage"] = 11] = "SelfStorage";
    BuildOut[BuildOut["Warehouse"] = 12] = "Warehouse";
    BuildOut[BuildOut["StandardRetail"] = 13] = "StandardRetail";
    BuildOut[BuildOut["RestaurantsAndCafes"] = 14] = "RestaurantsAndCafes";
    BuildOut[BuildOut["FastFood"] = 15] = "FastFood";
    BuildOut[BuildOut["Bank"] = 16] = "Bank";
    BuildOut[BuildOut["ConvenienceStore"] = 17] = "ConvenienceStore";
    BuildOut[BuildOut["BarNightclub"] = 18] = "BarNightclub";
    BuildOut[BuildOut["StandardFlex"] = 19] = "StandardFlex";
    BuildOut[BuildOut["StandardMedical"] = 21] = "StandardMedical";
    BuildOut[BuildOut["Dental"] = 22] = "Dental";
    BuildOut[BuildOut["PhysicalTherapy"] = 23] = "PhysicalTherapy";
    BuildOut[BuildOut["RD"] = 24] = "RD";
    BuildOut[BuildOut["Healthcare"] = 25] = "Healthcare";
    BuildOut[BuildOut["Specialty"] = 26] = "Specialty";
    BuildOut[BuildOut["ReligiousFacility"] = 28] = "ReligiousFacility";
    BuildOut[BuildOut["MovieTheater"] = 29] = "MovieTheater";
    BuildOut[BuildOut["PopupTemporary"] = 30] = "PopupTemporary";
    BuildOut[BuildOut["PoliceFireStation"] = 31] = "PoliceFireStation";
    BuildOut[BuildOut["PostOffice"] = 32] = "PostOffice";
    BuildOut[BuildOut["CarDealership"] = 33] = "CarDealership";
    BuildOut[BuildOut["QuickService"] = 34] = "QuickService";
})(BuildOut || (BuildOut = {}));
import { BuildOutConditionType } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.BuildOutConditionType */
export { BuildOutConditionType };
/** CoStar.Api.SuiteDetail.Types.SpaceLayOutType */
export var SpaceLayOutType;
(function (SpaceLayOutType) {
    SpaceLayOutType[SpaceLayOutType["None"] = 0] = "None";
    SpaceLayOutType[SpaceLayOutType["OpenPlan"] = 1] = "OpenPlan";
    SpaceLayOutType[SpaceLayOutType["MostlyOpenPlan"] = 2] = "MostlyOpenPlan";
    SpaceLayOutType[SpaceLayOutType["PrivateOffices"] = 3] = "PrivateOffices";
})(SpaceLayOutType || (SpaceLayOutType = {}));
/** CoStar.Api.SuiteDetail.Types.SIC */
export var SIC;
(function (SIC) {
    SIC[SIC["Wheat"] = 1] = "Wheat";
    SIC[SIC["Rice"] = 2] = "Rice";
    SIC[SIC["Soybeans"] = 3] = "Soybeans";
    SIC[SIC["CashGrainsNec"] = 4] = "CashGrainsNec";
    SIC[SIC["Cotton"] = 5] = "Cotton";
    SIC[SIC["Tobacco"] = 6] = "Tobacco";
    SIC[SIC["SugarcaneAndSugarBeets"] = 7] = "SugarcaneAndSugarBeets";
    SIC[SIC["IrishPotatoes"] = 8] = "IrishPotatoes";
    SIC[SIC["FieldCrops"] = 9] = "FieldCrops";
    SIC[SIC["BerryCrops"] = 10] = "BerryCrops";
    SIC[SIC["Grapes"] = 11] = "Grapes";
    SIC[SIC["TreeNuts"] = 12] = "TreeNuts";
    SIC[SIC["CitrusFruits"] = 13] = "CitrusFruits";
    SIC[SIC["DeciduousTreeFruits"] = 14] = "DeciduousTreeFruits";
    SIC[SIC["FruitsAndTreeNutsNec"] = 15] = "FruitsAndTreeNutsNec";
    SIC[SIC["OrnamentalNurseryProd"] = 16] = "OrnamentalNurseryProd";
    SIC[SIC["FoodCropsGrownUndCov"] = 17] = "FoodCropsGrownUndCov";
    SIC[SIC["BeefCattleFeedlots"] = 18] = "BeefCattleFeedlots";
    SIC[SIC["Hogs"] = 19] = "Hogs";
    SIC[SIC["SheepAndGoats"] = 20] = "SheepAndGoats";
    SIC[SIC["DairyFarms"] = 21] = "DairyFarms";
    SIC[SIC["Chickens"] = 22] = "Chickens";
    SIC[SIC["ChickenEggs"] = 23] = "ChickenEggs";
    SIC[SIC["TurkeysAndTurkeyEggs"] = 24] = "TurkeysAndTurkeyEggs";
    SIC[SIC["PoultryHatcheries"] = 25] = "PoultryHatcheries";
    SIC[SIC["PoultryAndEggsNec"] = 26] = "PoultryAndEggsNec";
    SIC[SIC["FurAnimalsAndRabbits"] = 27] = "FurAnimalsAndRabbits";
    SIC[SIC["HorsesAndOtherEquines"] = 28] = "HorsesAndOtherEquines";
    SIC[SIC["AnimalSpecialtiesNec"] = 29] = "AnimalSpecialtiesNec";
    SIC[SIC["CropHarvesting"] = 30] = "CropHarvesting";
    SIC[SIC["CropPreparationServices"] = 31] = "CropPreparationServices";
    SIC[SIC["CottonGinning"] = 32] = "CottonGinning";
    SIC[SIC["AnimalSpecialtyServices"] = 33] = "AnimalSpecialtyServices";
    SIC[SIC["FarmLaborContractors"] = 34] = "FarmLaborContractors";
    SIC[SIC["FarmManagementServices"] = 35] = "FarmManagementServices";
    SIC[SIC["TimberTracts"] = 36] = "TimberTracts";
    SIC[SIC["ForestProducts"] = 37] = "ForestProducts";
    SIC[SIC["ForestryServices"] = 38] = "ForestryServices";
    SIC[SIC["Finfish"] = 39] = "Finfish";
    SIC[SIC["MiscMarineProducts"] = 40] = "MiscMarineProducts";
    SIC[SIC["HuntingTrappingGame"] = 41] = "HuntingTrappingGame";
    SIC[SIC["IronOres"] = 42] = "IronOres";
    SIC[SIC["LeadAndZincOres"] = 43] = "LeadAndZincOres";
    SIC[SIC["GoldOres"] = 44] = "GoldOres";
    SIC[SIC["SilverOres"] = 45] = "SilverOres";
    SIC[SIC["MetalMiningServices"] = 46] = "MetalMiningServices";
    SIC[SIC["UraniumRadiumVanadium"] = 47] = "UraniumRadiumVanadium";
    SIC[SIC["BituminousCoalAndLign"] = 48] = "BituminousCoalAndLign";
    SIC[SIC["BituminousCoalUnder"] = 49] = "BituminousCoalUnder";
    SIC[SIC["AnthraciteMining"] = 50] = "AnthraciteMining";
    SIC[SIC["CoalMiningServices"] = 51] = "CoalMiningServices";
    SIC[SIC["CrudePetroleumAndGas"] = 52] = "CrudePetroleumAndGas";
    SIC[SIC["DrillingOilAndGasWell"] = 53] = "DrillingOilAndGasWell";
    SIC[SIC["DimensionStone"] = 54] = "DimensionStone";
    SIC[SIC["CrushedLimestone"] = 55] = "CrushedLimestone";
    SIC[SIC["CrushedGranite"] = 56] = "CrushedGranite";
    SIC[SIC["ConstSandAndGravel"] = 57] = "ConstSandAndGravel";
    SIC[SIC["IndustrialSand"] = 58] = "IndustrialSand";
    SIC[SIC["PotashSodaAndBorate"] = 59] = "PotashSodaAndBorate";
    SIC[SIC["PhosphateRock"] = 60] = "PhosphateRock";
    SIC[SIC["NonmetallicMineralsServ"] = 61] = "NonmetallicMineralsServ";
    SIC[SIC["OperativeBuilders"] = 62] = "OperativeBuilders";
    SIC[SIC["TerrazzoTileMarble"] = 63] = "TerrazzoTileMarble";
    SIC[SIC["CarpentryWork"] = 64] = "CarpentryWork";
    SIC[SIC["FloorLayingAndWork"] = 65] = "FloorLayingAndWork";
    SIC[SIC["RoofingSidingSheetMtl"] = 66] = "RoofingSidingSheetMtl";
    SIC[SIC["ConcreteWork"] = 67] = "ConcreteWork";
    SIC[SIC["StructuralSteelErection"] = 68] = "StructuralSteelErection";
    SIC[SIC["PoultrySlaughtering"] = 69] = "PoultrySlaughtering";
    SIC[SIC["CreameryButter"] = 70] = "CreameryButter";
    SIC[SIC["CheeseNaturalAndProc"] = 71] = "CheeseNaturalAndProc";
    SIC[SIC["IceCreamFrozDessert"] = 72] = "IceCreamFrozDessert";
    SIC[SIC["CannedSpecialties"] = 73] = "CannedSpecialties";
    SIC[SIC["FrozenFruitsAndVeg"] = 74] = "FrozenFruitsAndVeg";
    SIC[SIC["FrozenSpecialtiesNec"] = 75] = "FrozenSpecialtiesNec";
    SIC[SIC["CerealBreakfastFoods"] = 76] = "CerealBreakfastFoods";
    SIC[SIC["PreparedFlourMixes"] = 77] = "PreparedFlourMixes";
    SIC[SIC["WetCornMilling"] = 78] = "WetCornMilling";
    SIC[SIC["DogAndCatFood"] = 79] = "DogAndCatFood";
    SIC[SIC["CookiesAndCrackers"] = 80] = "CookiesAndCrackers";
    SIC[SIC["FrozBakeProdExcpBread"] = 81] = "FrozBakeProdExcpBread";
    SIC[SIC["RawCaneSugar"] = 82] = "RawCaneSugar";
    SIC[SIC["CaneSugarRefining"] = 83] = "CaneSugarRefining";
    SIC[SIC["BeetSugar"] = 84] = "BeetSugar";
    SIC[SIC["ChocolateAndCocoaProd"] = 85] = "ChocolateAndCocoaProd";
    SIC[SIC["MaltBeverages"] = 86] = "MaltBeverages";
    SIC[SIC["Malt"] = 87] = "Malt";
    SIC[SIC["DistilledAndBlendedLiq"] = 88] = "DistilledAndBlendedLiq";
    SIC[SIC["BottlAndCanSoftDrinks"] = 89] = "BottlAndCanSoftDrinks";
    SIC[SIC["FlavoringExtracts"] = 90] = "FlavoringExtracts";
    SIC[SIC["ManufacturedIce"] = 91] = "ManufacturedIce";
    SIC[SIC["FoodPreparationsNec"] = 92] = "FoodPreparationsNec";
    SIC[SIC["Cigarettes"] = 93] = "Cigarettes";
    SIC[SIC["TobaccoStemingAndRedrng"] = 94] = "TobaccoStemingAndRedrng";
    SIC[SIC["HosieryNec"] = 95] = "HosieryNec";
    SIC[SIC["CarpetsAndRugs"] = 96] = "CarpetsAndRugs";
    SIC[SIC["ThrowingAndWindingMill"] = 97] = "ThrowingAndWindingMill";
    SIC[SIC["TireCordAndFabrics"] = 98] = "TireCordAndFabrics";
    SIC[SIC["CordageAndTwine"] = 99] = "CordageAndTwine";
    SIC[SIC["MensAndBoysNeckwear"] = 100] = "MensAndBoysNeckwear";
    SIC[SIC["MensBoysWorkCloth"] = 101] = "MensBoysWorkCloth";
    SIC[SIC["HatsCapsAndMillinery"] = 102] = "HatsCapsAndMillinery";
    SIC[SIC["CanvasAndRelatedProd"] = 103] = "CanvasAndRelatedProd";
    SIC[SIC["SchiffliMachEmbroider"] = 104] = "SchiffliMachEmbroider";
    SIC[SIC["Logging"] = 105] = "Logging";
    SIC[SIC["Millwork"] = 106] = "Millwork";
    SIC[SIC["HardwoodVeneerAndPlywd"] = 107] = "HardwoodVeneerAndPlywd";
    SIC[SIC["SoftwoodVeneerAndPlywd"] = 108] = "SoftwoodVeneerAndPlywd";
    SIC[SIC["StructuralWoodMembers"] = 109] = "StructuralWoodMembers";
    SIC[SIC["MobileHomes"] = 110] = "MobileHomes";
    SIC[SIC["PrefabricatedWoodBuild"] = 111] = "PrefabricatedWoodBuild";
    SIC[SIC["WoodPreserving"] = 112] = "WoodPreserving";
    SIC[SIC["ReconstitutedWoodProd"] = 113] = "ReconstitutedWoodProd";
    SIC[SIC["MetalHouseholdFurniture"] = 114] = "MetalHouseholdFurniture";
    SIC[SIC["MattressesAndBedsprings"] = 115] = "MattressesAndBedsprings";
    SIC[SIC["WoodTvAndRadioCabinet"] = 116] = "WoodTvAndRadioCabinet";
    SIC[SIC["WoodOfficeFurniture"] = 117] = "WoodOfficeFurniture";
    SIC[SIC["OfficeFurnExceptWood"] = 118] = "OfficeFurnExceptWood";
    SIC[SIC["WoodPartitionsAndFixt"] = 119] = "WoodPartitionsAndFixt";
    SIC[SIC["Drapery"] = 120] = "Drapery";
    SIC[SIC["PulpMills"] = 121] = "PulpMills";
    SIC[SIC["SetupPaperboardBoxes"] = 122] = "SetupPaperboardBoxes";
    SIC[SIC["FiberCansDrums"] = 123] = "FiberCansDrums";
    SIC[SIC["SanitaryFoodContainers"] = 124] = "SanitaryFoodContainers";
    SIC[SIC["FoldingPaperboardBoxes"] = 125] = "FoldingPaperboardBoxes";
    SIC[SIC["PaperCoatdAndLmntedPkg"] = 126] = "PaperCoatdAndLmntedPkg";
    SIC[SIC["BagsPlasticsLaminated"] = 127] = "BagsPlasticsLaminated";
    SIC[SIC["BagsUncoatedPaper"] = 128] = "BagsUncoatedPaper";
    SIC[SIC["DieCutPaperAndBoard"] = 129] = "DieCutPaperAndBoard";
    SIC[SIC["Envelopes"] = 130] = "Envelopes";
    SIC[SIC["StationeryProducts"] = 131] = "StationeryProducts";
    SIC[SIC["Newspapers"] = 132] = "Newspapers";
    SIC[SIC["BookPrinting"] = 133] = "BookPrinting";
    SIC[SIC["MiscellaneousPublishing"] = 134] = "MiscellaneousPublishing";
    SIC[SIC["CommercialPrintingNec"] = 135] = "CommercialPrintingNec";
    SIC[SIC["GreetingCards"] = 136] = "GreetingCards";
    SIC[SIC["LooseleafBinders"] = 137] = "LooseleafBinders";
    SIC[SIC["Bookbinding"] = 138] = "Bookbinding";
    SIC[SIC["AlkaliesAndChlorine"] = 139] = "AlkaliesAndChlorine";
    SIC[SIC["IndustrialInorganicChem"] = 140] = "IndustrialInorganicChem";
    SIC[SIC["PlasticsMaterialsSyntheticAndResins"] = 141] = "PlasticsMaterialsSyntheticAndResins";
    SIC[SIC["SyntheticRubber"] = 142] = "SyntheticRubber";
    SIC[SIC["CellulosicManmadeFibers"] = 143] = "CellulosicManmadeFibers";
    SIC[SIC["OrganFibersNoncellulos"] = 144] = "OrganFibersNoncellulos";
    SIC[SIC["MedicinalsAndBotanicals"] = 145] = "MedicinalsAndBotanicals";
    SIC[SIC["DiagnosticSubstances"] = 146] = "DiagnosticSubstances";
    SIC[SIC["BioProdExcpDiagnostic"] = 147] = "BioProdExcpDiagnostic";
    SIC[SIC["PolishsAndSanitatnGood"] = 148] = "PolishsAndSanitatnGood";
    SIC[SIC["SurfaceActiveAgents"] = 149] = "SurfaceActiveAgents";
    SIC[SIC["ToiletPreparations"] = 150] = "ToiletPreparations";
    SIC[SIC["GumAndWoodChemicals"] = 151] = "GumAndWoodChemicals";
    SIC[SIC["CyclicCrudesAndInter"] = 152] = "CyclicCrudesAndInter";
    SIC[SIC["IndustrialOrganicChem"] = 153] = "IndustrialOrganicChem";
    SIC[SIC["NitrogenousFertilizers"] = 154] = "NitrogenousFertilizers";
    SIC[SIC["PhosphaticFertilizers"] = 155] = "PhosphaticFertilizers";
    SIC[SIC["FertilizersMixingOnly"] = 156] = "FertilizersMixingOnly";
    SIC[SIC["AgriculturalChemicals"] = 157] = "AgriculturalChemicals";
    SIC[SIC["AdhesivesAndSealants"] = 158] = "AdhesivesAndSealants";
    SIC[SIC["Explosives"] = 159] = "Explosives";
    SIC[SIC["PrintingInk"] = 160] = "PrintingInk";
    SIC[SIC["PetroleumRefining"] = 161] = "PetroleumRefining";
    SIC[SIC["AsphaltPavingMixtures"] = 162] = "AsphaltPavingMixtures";
    SIC[SIC["AsphaltFeltsAndCoating"] = 163] = "AsphaltFeltsAndCoating";
    SIC[SIC["LubricatingOils"] = 164] = "LubricatingOils";
    SIC[SIC["TiresAndInnerTubes"] = 165] = "TiresAndInnerTubes";
    SIC[SIC["RubberFootwear"] = 166] = "RubberFootwear";
    SIC[SIC["RubberHoseAndBelting"] = 167] = "RubberHoseAndBelting";
    SIC[SIC["GasketsDevices"] = 168] = "GasketsDevices";
    SIC[SIC["MechanicalRubberGoods"] = 169] = "MechanicalRubberGoods";
    SIC[SIC["FabricatedRubberProducts"] = 170] = "FabricatedRubberProducts";
    SIC[SIC["UnsupportedPlasticsFilm"] = 171] = "UnsupportedPlasticsFilm";
    SIC[SIC["LaminatedPlastics"] = 172] = "LaminatedPlastics";
    SIC[SIC["PlasticsBottles"] = 173] = "PlasticsBottles";
    SIC[SIC["PlasticsFoamProducts"] = 174] = "PlasticsFoamProducts";
    SIC[SIC["CustCompndPurchsdResins"] = 175] = "CustCompndPurchsdResins";
    SIC[SIC["PlasticsPlumbingFixture"] = 176] = "PlasticsPlumbingFixture";
    SIC[SIC["HouseSlippers"] = 177] = "HouseSlippers";
    SIC[SIC["MenFtwearExcpAthletic"] = 178] = "MenFtwearExcpAthletic";
    SIC[SIC["WmnFootwearExcpAthletic"] = 179] = "WmnFootwearExcpAthletic";
    SIC[SIC["FootwearExceptRubber"] = 180] = "FootwearExceptRubber";
    SIC[SIC["Luggage"] = 181] = "Luggage";
    SIC[SIC["WomenHandbagsAndPurses"] = 182] = "WomenHandbagsAndPurses";
    SIC[SIC["PersonalLeatherGoods"] = 183] = "PersonalLeatherGoods";
    SIC[SIC["FlatGlass"] = 184] = "FlatGlass";
    SIC[SIC["GlassContainers"] = 185] = "GlassContainers";
    SIC[SIC["PressedAndBlownGlass"] = 186] = "PressedAndBlownGlass";
    SIC[SIC["ProdOfPurchasedGlass"] = 187] = "ProdOfPurchasedGlass";
    SIC[SIC["CementHydraulic"] = 188] = "CementHydraulic";
    SIC[SIC["BrickAndClayTile"] = 189] = "BrickAndClayTile";
    SIC[SIC["CeramicTile"] = 190] = "CeramicTile";
    SIC[SIC["ClayRefractories"] = 191] = "ClayRefractories";
    SIC[SIC["StructuralClayProducts"] = 192] = "StructuralClayProducts";
    SIC[SIC["VitreousPlumbingFixture"] = 193] = "VitreousPlumbingFixture";
    SIC[SIC["PorcelainElecSupplies"] = 194] = "PorcelainElecSupplies";
    SIC[SIC["ConcreteProductsNec"] = 195] = "ConcreteProductsNec";
    SIC[SIC["ReadyMixedConcrete"] = 196] = "ReadyMixedConcrete";
    SIC[SIC["Lime"] = 197] = "Lime";
    SIC[SIC["CutStoneAndStoneProd"] = 198] = "CutStoneAndStoneProd";
    SIC[SIC["AbrasiveProducts"] = 199] = "AbrasiveProducts";
    SIC[SIC["MineralsGrndOrTreated"] = 200] = "MineralsGrndOrTreated";
    SIC[SIC["MineralWool"] = 201] = "MineralWool";
    SIC[SIC["NonclayRefractories"] = 202] = "NonclayRefractories";
    SIC[SIC["ElectrometallurgicalProd"] = 203] = "ElectrometallurgicalProd";
    SIC[SIC["SteelWire"] = 204] = "SteelWire";
    SIC[SIC["SteelPipeAndTubes"] = 205] = "SteelPipeAndTubes";
    SIC[SIC["SteelInvestmentFoundry"] = 206] = "SteelInvestmentFoundry";
    SIC[SIC["SteelFoundriesNec"] = 207] = "SteelFoundriesNec";
    SIC[SIC["PrimaryCopper"] = 208] = "PrimaryCopper";
    SIC[SIC["PrimaryAluminum"] = 209] = "PrimaryAluminum";
    SIC[SIC["PrimaryNonferrousMetals"] = 210] = "PrimaryNonferrousMetals";
    SIC[SIC["CopperRollingAndDrawng"] = 211] = "CopperRollingAndDrawng";
    SIC[SIC["AluminumSheetPlate"] = 212] = "AluminumSheetPlate";
    SIC[SIC["AluminumExtrudedProduct"] = 213] = "AluminumExtrudedProduct";
    SIC[SIC["NonferusWiredrwngInsltng"] = 214] = "NonferusWiredrwngInsltng";
    SIC[SIC["AluminumDieCastings"] = 215] = "AluminumDieCastings";
    SIC[SIC["NonferrousDieCasting"] = 216] = "NonferrousDieCasting";
    SIC[SIC["AluminumFoundries"] = 217] = "AluminumFoundries";
    SIC[SIC["CopperFoundries"] = 218] = "CopperFoundries";
    SIC[SIC["NonferrousFoundriesNec"] = 219] = "NonferrousFoundriesNec";
    SIC[SIC["MetalHeatTreating"] = 220] = "MetalHeatTreating";
    SIC[SIC["MetalCans"] = 221] = "MetalCans";
    SIC[SIC["SawBladesAndHandsaws"] = 222] = "SawBladesAndHandsaws";
    SIC[SIC["MetalSanitaryWare"] = 223] = "MetalSanitaryWare";
    SIC[SIC["PlumbingFixtures"] = 224] = "PlumbingFixtures";
    SIC[SIC["FabricatedPlateWork"] = 225] = "FabricatedPlateWork";
    SIC[SIC["SheetMetalWork"] = 226] = "SheetMetalWork";
    SIC[SIC["PrefabricatedMetalBldg"] = 227] = "PrefabricatedMetalBldg";
    SIC[SIC["MiscellaneousMetalWork"] = 228] = "MiscellaneousMetalWork";
    SIC[SIC["ScrewMachineProducts"] = 229] = "ScrewMachineProducts";
    SIC[SIC["IronAndSteelForgings"] = 230] = "IronAndSteelForgings";
    SIC[SIC["NonferrousForgings"] = 231] = "NonferrousForgings";
    SIC[SIC["AutomotiveStampings"] = 232] = "AutomotiveStampings";
    SIC[SIC["CrownsAndClosures"] = 233] = "CrownsAndClosures";
    SIC[SIC["MetalStampingsNec"] = 234] = "MetalStampingsNec";
    SIC[SIC["SmallArmsAmmunition"] = 235] = "SmallArmsAmmunition";
    SIC[SIC["Ammunition"] = 236] = "Ammunition";
    SIC[SIC["OrdnanceAndAccessories"] = 237] = "OrdnanceAndAccessories";
    SIC[SIC["IndustrialValves"] = 238] = "IndustrialValves";
    SIC[SIC["SteelSpringsExcpWire"] = 239] = "SteelSpringsExcpWire";
    SIC[SIC["WireSprings"] = 240] = "WireSprings";
    SIC[SIC["MetalFoilAndLeaf"] = 241] = "MetalFoilAndLeaf";
    SIC[SIC["FabPipeAndFittings"] = 242] = "FabPipeAndFittings";
    SIC[SIC["FabricatedMetalProducts"] = 243] = "FabricatedMetalProducts";
    SIC[SIC["Turbines"] = 244] = "Turbines";
    SIC[SIC["LawnAndGardenEquipment"] = 245] = "LawnAndGardenEquipment";
    SIC[SIC["ConstructionMachinery"] = 246] = "ConstructionMachinery";
    SIC[SIC["MiningMachinery"] = 247] = "MiningMachinery";
    SIC[SIC["OilAndGasFieldMach"] = 248] = "OilAndGasFieldMach";
    SIC[SIC["ElevAndMovingStairways"] = 249] = "ElevAndMovingStairways";
    SIC[SIC["MachToolsMetalCutting"] = 250] = "MachToolsMetalCutting";
    SIC[SIC["MachToolsMetalForming"] = 251] = "MachToolsMetalForming";
    SIC[SIC["IndustrialPatterns"] = 252] = "IndustrialPatterns";
    SIC[SIC["SpecDiesToolsJigs"] = 253] = "SpecDiesToolsJigs";
    SIC[SIC["MachineToolAccessories"] = 254] = "MachineToolAccessories";
    SIC[SIC["PowerDrivenHandtools"] = 255] = "PowerDrivenHandtools";
    SIC[SIC["RollingMillMachinery"] = 256] = "RollingMillMachinery";
    SIC[SIC["MetalworkingMachinery"] = 257] = "MetalworkingMachinery";
    SIC[SIC["TextileMachinery"] = 258] = "TextileMachinery";
    SIC[SIC["WoodworkingMachinery"] = 259] = "WoodworkingMachinery";
    SIC[SIC["PaperIndustriesMach"] = 260] = "PaperIndustriesMach";
    SIC[SIC["PrintingTradesMachinery"] = 261] = "PrintingTradesMachinery";
    SIC[SIC["FoodProductsMachinery"] = 262] = "FoodProductsMachinery";
    SIC[SIC["SpecialIndustryMach"] = 263] = "SpecialIndustryMach";
    SIC[SIC["BallAndRollerBearings"] = 264] = "BallAndRollerBearings";
    SIC[SIC["AirAndGasCompressors"] = 265] = "AirAndGasCompressors";
    SIC[SIC["BlowersAndFans"] = 266] = "BlowersAndFans";
    SIC[SIC["PackagingMachinery"] = 267] = "PackagingMachinery";
    SIC[SIC["SpeedChangers"] = 268] = "SpeedChangers";
    SIC[SIC["IndstrlFurnacesAndOven"] = 269] = "IndstrlFurnacesAndOven";
    SIC[SIC["PowerTransmissionEqiup"] = 270] = "PowerTransmissionEqiup";
    SIC[SIC["ElectronicComputers"] = 271] = "ElectronicComputers";
    SIC[SIC["ComputerStorageDevices"] = 272] = "ComputerStorageDevices";
    SIC[SIC["ComputerTerminals"] = 273] = "ComputerTerminals";
    SIC[SIC["CommercialLaundryEquip"] = 274] = "CommercialLaundryEquip";
    SIC[SIC["RefrigAndHeatngEquip"] = 275] = "RefrigAndHeatngEquip";
    SIC[SIC["MeasuringPumps"] = 276] = "MeasuringPumps";
    SIC[SIC["CarburetorPistonValve"] = 277] = "CarburetorPistonValve";
    SIC[SIC["FluidPowerCylinders"] = 278] = "FluidPowerCylinders";
    SIC[SIC["FluidPowerPumps"] = 279] = "FluidPowerPumps";
    SIC[SIC["ScalesAndBalances"] = 280] = "ScalesAndBalances";
    SIC[SIC["IndustrialMachineryNec"] = 281] = "IndustrialMachineryNec";
    SIC[SIC["SwitchboardApparatus"] = 282] = "SwitchboardApparatus";
    SIC[SIC["CarbonAndGrapProd"] = 283] = "CarbonAndGrapProd";
    SIC[SIC["IndustrialControls"] = 284] = "IndustrialControls";
    SIC[SIC["HsehldCookngEquip"] = 285] = "HsehldCookngEquip";
    SIC[SIC["HsehldRefrigerators"] = 286] = "HsehldRefrigerators";
    SIC[SIC["HsehldLaundryEquip"] = 287] = "HsehldLaundryEquip";
    SIC[SIC["HouseholdAppliancesNec"] = 288] = "HouseholdAppliancesNec";
    SIC[SIC["ElectricLamps"] = 289] = "ElectricLamps";
    SIC[SIC["WiringDevices"] = 290] = "WiringDevices";
    SIC[SIC["NoncurrentWiringDevices"] = 291] = "NoncurrentWiringDevices";
    SIC[SIC["CmrclLghtngFixtures"] = 292] = "CmrclLghtngFixtures";
    SIC[SIC["VehiculrLghtngEquip"] = 293] = "VehiculrLghtngEquip";
    SIC[SIC["PrerecordedRecords"] = 294] = "PrerecordedRecords";
    SIC[SIC["TelephoneApparatus"] = 295] = "TelephoneApparatus";
    SIC[SIC["CommunicationsEquip"] = 296] = "CommunicationsEquip";
    SIC[SIC["ElectronTubes"] = 297] = "ElectronTubes";
    SIC[SIC["PrintedCircuitBoards"] = 298] = "PrintedCircuitBoards";
    SIC[SIC["Semiconductors"] = 299] = "Semiconductors";
    SIC[SIC["ElectronicCapacitors"] = 300] = "ElectronicCapacitors";
    SIC[SIC["ElectronicResistors"] = 301] = "ElectronicResistors";
    SIC[SIC["ElectronicCoils"] = 302] = "ElectronicCoils";
    SIC[SIC["ElectronicConnectors"] = 303] = "ElectronicConnectors";
    SIC[SIC["ElectronicComponents"] = 304] = "ElectronicComponents";
    SIC[SIC["StorageBatteries"] = 305] = "StorageBatteries";
    SIC[SIC["PrimaryBatteries"] = 306] = "PrimaryBatteries";
    SIC[SIC["MotorVehicles"] = 307] = "MotorVehicles";
    SIC[SIC["MotorVehicleParts"] = 308] = "MotorVehicleParts";
    SIC[SIC["TruckTrailers"] = 309] = "TruckTrailers";
    SIC[SIC["MotorHomes"] = 310] = "MotorHomes";
    SIC[SIC["AircraftEngines"] = 311] = "AircraftEngines";
    SIC[SIC["AircraftPartsAndEquip"] = 312] = "AircraftPartsAndEquip";
    SIC[SIC["ShipBldgAndRepairing"] = 313] = "ShipBldgAndRepairing";
    SIC[SIC["BoatBldgAndRepairing"] = 314] = "BoatBldgAndRepairing";
    SIC[SIC["GuidedMissiles"] = 315] = "GuidedMissiles";
    SIC[SIC["SpacePropulsionUnits"] = 316] = "SpacePropulsionUnits";
    SIC[SIC["SpaceVehicleEquipment"] = 317] = "SpaceVehicleEquipment";
    SIC[SIC["TransportationEquipment"] = 318] = "TransportationEquipment";
    SIC[SIC["NavigationEquipment"] = 319] = "NavigationEquipment";
    SIC[SIC["EnvironmentalControls"] = 320] = "EnvironmentalControls";
    SIC[SIC["ProcessCntrlInstruments"] = 321] = "ProcessCntrlInstruments";
    SIC[SIC["InstrumentsToMeasElec"] = 322] = "InstrumentsToMeasElec";
    SIC[SIC["AnalyticalInstruments"] = 323] = "AnalyticalInstruments";
    SIC[SIC["OpticalInstruments"] = 324] = "OpticalInstruments";
    SIC[SIC["DentalEquipment"] = 325] = "DentalEquipment";
    SIC[SIC["PhotographicEquipment"] = 326] = "PhotographicEquipment";
    SIC[SIC["JewelersMaterials"] = 327] = "JewelersMaterials";
    SIC[SIC["MusicalInstruments"] = 328] = "MusicalInstruments";
    SIC[SIC["DollsAndStuffedToys"] = 329] = "DollsAndStuffedToys";
    SIC[SIC["PensAndMechPencils"] = 330] = "PensAndMechPencils";
    SIC[SIC["MarkingDevices"] = 331] = "MarkingDevices";
    SIC[SIC["CarbonPaper"] = 332] = "CarbonPaper";
    SIC[SIC["SignsAndAdvertisngSpec"] = 333] = "SignsAndAdvertisngSpec";
    SIC[SIC["BurialCaskets"] = 334] = "BurialCaskets";
    SIC[SIC["RailroadsLineHaulOper"] = 335] = "RailroadsLineHaulOper";
    SIC[SIC["TerminalServices"] = 336] = "TerminalServices";
    SIC[SIC["LocalTransit"] = 337] = "LocalTransit";
    SIC[SIC["LocalPassengerTrans"] = 338] = "LocalPassengerTrans";
    SIC[SIC["IntercityTransportation"] = 339] = "IntercityTransportation";
    SIC[SIC["LocalTruckingWOStorage"] = 340] = "LocalTruckingWOStorage";
    SIC[SIC["TruckingExceptLocal"] = 341] = "TruckingExceptLocal";
    SIC[SIC["CourierServExcpByAir"] = 342] = "CourierServExcpByAir";
    SIC[SIC["FarmProductWarehousing"] = 343] = "FarmProductWarehousing";
    SIC[SIC["GnrlWarehousingAndStor"] = 344] = "GnrlWarehousingAndStor";
    SIC[SIC["SpclWarehousingAndStor"] = 345] = "SpclWarehousingAndStor";
    SIC[SIC["DeepSeaForeignTrans"] = 346] = "DeepSeaForeignTrans";
    SIC[SIC["DeepSeaPassngrTrans"] = 347] = "DeepSeaPassngrTrans";
    SIC[SIC["MarineCargoHandling"] = 348] = "MarineCargoHandling";
    SIC[SIC["Marinas"] = 349] = "Marinas";
    SIC[SIC["AirTransportationScheduled"] = 350] = "AirTransportationScheduled";
    SIC[SIC["AirTransNonscheduled"] = 351] = "AirTransNonscheduled";
    SIC[SIC["AirportsFlyingFields"] = 352] = "AirportsFlyingFields";
    SIC[SIC["CrudePetroleumPipelines"] = 353] = "CrudePetroleumPipelines";
    SIC[SIC["RefinedPetroleunPipels"] = 354] = "RefinedPetroleunPipels";
    SIC[SIC["PipelinesNec"] = 355] = "PipelinesNec";
    SIC[SIC["TravelAgencies"] = 356] = "TravelAgencies";
    SIC[SIC["TourOperators"] = 357] = "TourOperators";
    SIC[SIC["FreightTranArngement"] = 358] = "FreightTranArngement";
    SIC[SIC["PackingAndCrating"] = 359] = "PackingAndCrating";
    SIC[SIC["RadiotelephoneComm"] = 360] = "RadiotelephoneComm";
    SIC[SIC["RadioBroadcastingStations"] = 361] = "RadioBroadcastingStations";
    SIC[SIC["TVBroadcastingStations"] = 362] = "TVBroadcastingStations";
    SIC[SIC["Cable"] = 363] = "Cable";
    SIC[SIC["CommunicationsServices"] = 364] = "CommunicationsServices";
    SIC[SIC["SewerageSystems"] = 365] = "SewerageSystems";
    SIC[SIC["RefuseSystems"] = 366] = "RefuseSystems";
    SIC[SIC["SteamAndAirCondSupply"] = 367] = "SteamAndAirCondSupply";
    SIC[SIC["AutomobilesAndOtherMotorVehicles"] = 368] = "AutomobilesAndOtherMotorVehicles";
    SIC[SIC["MotorVehicleSuppliesAndNewParts"] = 369] = "MotorVehicleSuppliesAndNewParts";
    SIC[SIC["TiresAndTubes"] = 370] = "TiresAndTubes";
    SIC[SIC["MotorVehiclePartsUsed"] = 371] = "MotorVehiclePartsUsed";
    SIC[SIC["Furniture"] = 372] = "Furniture";
    SIC[SIC["Homefurnishings"] = 373] = "Homefurnishings";
    SIC[SIC["BrickStone"] = 374] = "BrickStone";
    SIC[SIC["RoofingSidingInsulation"] = 375] = "RoofingSidingInsulation";
    SIC[SIC["ConstructionMaterials"] = 376] = "ConstructionMaterials";
    SIC[SIC["PhotoEquipAndSupplies"] = 377] = "PhotoEquipAndSupplies";
    SIC[SIC["OfficeEquipment"] = 378] = "OfficeEquipment";
    SIC[SIC["ComputersAndSoftware"] = 379] = "ComputersAndSoftware";
    SIC[SIC["CommercialEquipmentNec"] = 380] = "CommercialEquipmentNec";
    SIC[SIC["MedicalAndHospitalEquip"] = 381] = "MedicalAndHospitalEquip";
    SIC[SIC["WholesalerOphthalmicGoods"] = 382] = "WholesalerOphthalmicGoods";
    SIC[SIC["ProfessionalEquipment"] = 383] = "ProfessionalEquipment";
    SIC[SIC["MtlSvcCntrAndOfc"] = 384] = "MtlSvcCntrAndOfc";
    SIC[SIC["CoalOtherMineralsOres"] = 385] = "CoalOtherMineralsOres";
    SIC[SIC["ElecApparatusAndEquip"] = 386] = "ElecApparatusAndEquip";
    SIC[SIC["ElecAppliancesTvRadios"] = 387] = "ElecAppliancesTvRadios";
    SIC[SIC["ElecPartsAndEquip"] = 388] = "ElecPartsAndEquip";
    SIC[SIC["Hardware"] = 389] = "Hardware";
    SIC[SIC["PlumbingHydronicHtngSupply"] = 390] = "PlumbingHydronicHtngSupply";
    SIC[SIC["WarmAirHtngAirCond"] = 391] = "WarmAirHtngAirCond";
    SIC[SIC["RefrigEquipAndSupplies"] = 392] = "RefrigEquipAndSupplies";
    SIC[SIC["ConstAndMiningMach"] = 393] = "ConstAndMiningMach";
    SIC[SIC["FarmAndGardenMachinery"] = 394] = "FarmAndGardenMachinery";
    SIC[SIC["IndustrialSupplies"] = 395] = "IndustrialSupplies";
    SIC[SIC["SvcEstablishmentEquip"] = 396] = "SvcEstablishmentEquip";
    SIC[SIC["TransEquipAndSupplies"] = 397] = "TransEquipAndSupplies";
    SIC[SIC["ToysAndHobbyGoods"] = 398] = "ToysAndHobbyGoods";
    SIC[SIC["ScrapAndWasteMaterials"] = 399] = "ScrapAndWasteMaterials";
    SIC[SIC["Jewelry"] = 400] = "Jewelry";
    SIC[SIC["WritingPaper"] = 401] = "WritingPaper";
    SIC[SIC["StationeryAndOfc"] = 402] = "StationeryAndOfc";
    SIC[SIC["IndstrlAndPrsnlSvcPaper"] = 403] = "IndstrlAndPrsnlSvcPaper";
    SIC[SIC["DrugsAndSundries"] = 404] = "DrugsAndSundries";
    SIC[SIC["MensAndBoysClothing"] = 405] = "MensAndBoysClothing";
    SIC[SIC["WmnsAndChldrnsCloth"] = 406] = "WmnsAndChldrnsCloth";
    SIC[SIC["GroceriesGeneralLine"] = 407] = "GroceriesGeneralLine";
    SIC[SIC["PackagedFrozenFoods"] = 408] = "PackagedFrozenFoods";
    SIC[SIC["DairyProdExcpDriedCanned"] = 409] = "DairyProdExcpDriedCanned";
    SIC[SIC["PoultryAndPoultryProd"] = 410] = "PoultryAndPoultryProd";
    SIC[SIC["Confectionery"] = 411] = "Confectionery";
    SIC[SIC["FishAndSeafoods"] = 412] = "FishAndSeafoods";
    SIC[SIC["MeatsAndMeatProducts"] = 413] = "MeatsAndMeatProducts";
    SIC[SIC["FreshFruitsAndVeg"] = 414] = "FreshFruitsAndVeg";
    SIC[SIC["Groceries"] = 415] = "Groceries";
    SIC[SIC["GrainAndFieldBeans"] = 416] = "GrainAndFieldBeans";
    SIC[SIC["Livestock"] = 417] = "Livestock";
    SIC[SIC["FarmProductRawMtrl"] = 418] = "FarmProductRawMtrl";
    SIC[SIC["ChemicalsAndAlliedProd"] = 419] = "ChemicalsAndAlliedProd";
    SIC[SIC["PetroleumBulkStations"] = 420] = "PetroleumBulkStations";
    SIC[SIC["PetroleumProductsNec"] = 421] = "PetroleumProductsNec";
    SIC[SIC["BeerAndAle"] = 422] = "BeerAndAle";
    SIC[SIC["WineAndDistilledBev"] = 423] = "WineAndDistilledBev";
    SIC[SIC["FarmSupplies"] = 424] = "FarmSupplies";
    SIC[SIC["BooksPeriodicalsAndNewspa"] = 425] = "BooksPeriodicalsAndNewspa";
    SIC[SIC["Flowers"] = 426] = "Flowers";
    SIC[SIC["TobaccoAndTobaccoProducts"] = 427] = "TobaccoAndTobaccoProducts";
    SIC[SIC["PaintsVarnishes"] = 428] = "PaintsVarnishes";
    SIC[SIC["NondurableGoodsNec"] = 429] = "NondurableGoodsNec";
    SIC[SIC["PaintGlassWallpaperStr"] = 430] = "PaintGlassWallpaperStr";
    SIC[SIC["MobileHomeDealers"] = 431] = "MobileHomeDealers";
    SIC[SIC["DepartmentStores"] = 432] = "DepartmentStores";
    SIC[SIC["GroceryStores"] = 433] = "GroceryStores";
    SIC[SIC["RetailBakeries"] = 434] = "RetailBakeries";
    SIC[SIC["NewAndUsedCarDealers"] = 435] = "NewAndUsedCarDealers";
    SIC[SIC["UsedCarDealers"] = 436] = "UsedCarDealers";
    SIC[SIC["GasolineServiceStations"] = 437] = "GasolineServiceStations";
    SIC[SIC["BoatDealers"] = 438] = "BoatDealers";
    SIC[SIC["RecreationalVhcleDealers"] = 439] = "RecreationalVhcleDealers";
    SIC[SIC["MotorcycleDealers"] = 440] = "MotorcycleDealers";
    SIC[SIC["AutomotiveDealersNec"] = 441] = "AutomotiveDealersNec";
    SIC[SIC["FamilyClothingStores"] = 442] = "FamilyClothingStores";
    SIC[SIC["MusicalInstrumentStores"] = 443] = "MusicalInstrumentStores";
    SIC[SIC["EatingPlaces"] = 444] = "EatingPlaces";
    SIC[SIC["DrinkingPlaces"] = 445] = "DrinkingPlaces";
    SIC[SIC["UsedMerchandiseStores"] = 446] = "UsedMerchandiseStores";
    SIC[SIC["CameraStores"] = 447] = "CameraStores";
    SIC[SIC["LuggageLeatherGoodsStr"] = 448] = "LuggageLeatherGoodsStr";
    SIC[SIC["CatalogMailOrderHouses"] = 449] = "CatalogMailOrderHouses";
    SIC[SIC["MdsgMachineOperators"] = 450] = "MdsgMachineOperators";
    SIC[SIC["DirectSellingEstab"] = 451] = "DirectSellingEstab";
    SIC[SIC["FuelDealersNec"] = 452] = "FuelDealersNec";
    SIC[SIC["Florists"] = 453] = "Florists";
    SIC[SIC["NewsDealers"] = 454] = "NewsDealers";
    SIC[SIC["OpticalGoodsStores"] = 455] = "OpticalGoodsStores";
    SIC[SIC["MiscRetailStores"] = 456] = "MiscRetailStores";
    SIC[SIC["BanksFederalReserve"] = 457] = "BanksFederalReserve";
    SIC[SIC["BanksStateCommercial"] = 458] = "BanksStateCommercial";
    SIC[SIC["CreditAgencyPersonal"] = 459] = "CreditAgencyPersonal";
    SIC[SIC["LoanBrokers"] = 460] = "LoanBrokers";
    SIC[SIC["SecurityBrokers"] = 461] = "SecurityBrokers";
    SIC[SIC["CommodityBrokers"] = 462] = "CommodityBrokers";
    SIC[SIC["SecurityCommodityExhng"] = 463] = "SecurityCommodityExhng";
    SIC[SIC["InvestmentAdvice"] = 464] = "InvestmentAdvice";
    SIC[SIC["InsuranceTitle"] = 465] = "InsuranceTitle";
    SIC[SIC["PensionAndProfitSharing"] = 466] = "PensionAndProfitSharing";
    SIC[SIC["InsuranceAgents"] = 467] = "InsuranceAgents";
    SIC[SIC["OperatorNonrsdntlBldg"] = 468] = "OperatorNonrsdntlBldg";
    SIC[SIC["RealEstateAgent"] = 469] = "RealEstateAgent";
    SIC[SIC["TitleCompanies"] = 470] = "TitleCompanies";
    SIC[SIC["DeveloperRealEstate"] = 471] = "DeveloperRealEstate";
    SIC[SIC["HoldingCompaniesBank"] = 472] = "HoldingCompaniesBank";
    SIC[SIC["HoldingCompaniesNEC"] = 473] = "HoldingCompaniesNEC";
    SIC[SIC["InvestmentOfcsOpenEnd"] = 474] = "InvestmentOfcsOpenEnd";
    SIC[SIC["TrustsEducAndReligious"] = 475] = "TrustsEducAndReligious";
    SIC[SIC["TrustsNEC"] = 476] = "TrustsNEC";
    SIC[SIC["RealEstateInvestmentTrusts"] = 477] = "RealEstateInvestmentTrusts";
    SIC[SIC["HotelsAndMotels"] = 478] = "HotelsAndMotels";
    SIC[SIC["Camps"] = 479] = "Camps";
    SIC[SIC["Campgrounds"] = 480] = "Campgrounds";
    SIC[SIC["LaundriesSelfService"] = 481] = "LaundriesSelfService";
    SIC[SIC["CleanersUpholstery"] = 482] = "CleanersUpholstery";
    SIC[SIC["LaunderersIndustrial"] = 483] = "LaunderersIndustrial";
    SIC[SIC["PhotoStudiosPortrait"] = 484] = "PhotoStudiosPortrait";
    SIC[SIC["BeautyShops"] = 485] = "BeautyShops";
    SIC[SIC["BarberShops"] = 486] = "BarberShops";
    SIC[SIC["FuneralService"] = 487] = "FuneralService";
    SIC[SIC["TaxReturnPreparation"] = 488] = "TaxReturnPreparation";
    SIC[SIC["PersonalServicesMisc"] = 489] = "PersonalServicesMisc";
    SIC[SIC["AdvertisingAgencies"] = 490] = "AdvertisingAgencies";
    SIC[SIC["AdvertisingRadioAndTv"] = 491] = "AdvertisingRadioAndTv";
    SIC[SIC["AdvertisingNEC"] = 492] = "AdvertisingNEC";
    SIC[SIC["CreditReportingServices"] = 493] = "CreditReportingServices";
    SIC[SIC["DirectMailAdvServices"] = 494] = "DirectMailAdvServices";
    SIC[SIC["CourtReptngAndSecSvcs"] = 495] = "CourtReptngAndSecSvcs";
    SIC[SIC["EquipRentalMedical"] = 496] = "EquipRentalMedical";
    SIC[SIC["EquipRentalAndLeasing"] = 497] = "EquipRentalAndLeasing";
    SIC[SIC["EmploymentAgenciesTemp"] = 498] = "EmploymentAgenciesTemp";
    SIC[SIC["ComputerProgrammingSvc"] = 499] = "ComputerProgrammingSvc";
    SIC[SIC["ComputerPackagedSftwre"] = 500] = "ComputerPackagedSftwre";
    SIC[SIC["ComputerInfoRetrieval"] = 501] = "ComputerInfoRetrieval";
    SIC[SIC["ComputerFacilitiesMgmt"] = 502] = "ComputerFacilitiesMgmt";
    SIC[SIC["ComputerRelatedServices"] = 503] = "ComputerRelatedServices";
    SIC[SIC["ArmoredCarServices"] = 504] = "ArmoredCarServices";
    SIC[SIC["SecuritySystemsServices"] = 505] = "SecuritySystemsServices";
    SIC[SIC["NewsSyndicates"] = 506] = "NewsSyndicates";
    SIC[SIC["PhotofinishingLab"] = 507] = "PhotofinishingLab";
    SIC[SIC["BusinessServicesNEC"] = 508] = "BusinessServicesNEC";
    SIC[SIC["AutomobileRental"] = 509] = "AutomobileRental";
    SIC[SIC["AutomobileLeasing"] = 510] = "AutomobileLeasing";
    SIC[SIC["AutoBodyRepairShops"] = 511] = "AutoBodyRepairShops";
    SIC[SIC["AutoExhaustRepairShops"] = 512] = "AutoExhaustRepairShops";
    SIC[SIC["TireRetreadingShops"] = 513] = "TireRetreadingShops";
    SIC[SIC["AutoTransRepairShops"] = 514] = "AutoTransRepairShops";
    SIC[SIC["AutoRepairShopsGenl"] = 515] = "AutoRepairShopsGenl";
    SIC[SIC["AutoRepairShopsNEC"] = 516] = "AutoRepairShopsNEC";
    SIC[SIC["Carwashes"] = 517] = "Carwashes";
    SIC[SIC["AutomotiveServicesNEC"] = 518] = "AutomotiveServicesNEC";
    SIC[SIC["RepairShopsNEC"] = 519] = "RepairShopsNEC";
    SIC[SIC["MotionPicAndVideoProd"] = 520] = "MotionPicAndVideoProd";
    SIC[SIC["MotionPicProdServices"] = 521] = "MotionPicProdServices";
    SIC[SIC["Theaters"] = 522] = "Theaters";
    SIC[SIC["DriveInTheaters"] = 523] = "DriveInTheaters";
    SIC[SIC["VideoTapeRental"] = 524] = "VideoTapeRental";
    SIC[SIC["TheatricalProdAndSvcs"] = 525] = "TheatricalProdAndSvcs";
    SIC[SIC["EntertainersNonTheater"] = 526] = "EntertainersNonTheater";
    SIC[SIC["BowlingCenters"] = 527] = "BowlingCenters";
    SIC[SIC["SportClubsProfessional"] = 528] = "SportClubsProfessional";
    SIC[SIC["Racing"] = 529] = "Racing";
    SIC[SIC["Arcades"] = 530] = "Arcades";
    SIC[SIC["AmusementParks"] = 531] = "AmusementParks";
    SIC[SIC["AmusementAndRecreation"] = 532] = "AmusementAndRecreation";
    SIC[SIC["MedicalDoctor"] = 533] = "MedicalDoctor";
    SIC[SIC["Dentists"] = 534] = "Dentists";
    SIC[SIC["Chiropractors"] = 535] = "Chiropractors";
    SIC[SIC["Optometrists"] = 536] = "Optometrists";
    SIC[SIC["Podiatrists"] = 537] = "Podiatrists";
    SIC[SIC["HealthPractitionersNEC"] = 538] = "HealthPractitionersNEC";
    SIC[SIC["HospitalNonPsychiatric"] = 539] = "HospitalNonPsychiatric";
    SIC[SIC["LaboratoriesMedical"] = 540] = "LaboratoriesMedical";
    SIC[SIC["LaboratoriesDental"] = 541] = "LaboratoriesDental";
    SIC[SIC["HomeHealthCareServices"] = 542] = "HomeHealthCareServices";
    SIC[SIC["KidneyDialysisCenters"] = 543] = "KidneyDialysisCenters";
    SIC[SIC["ClinicsOutpatient"] = 544] = "ClinicsOutpatient";
    SIC[SIC["HealthAndAlliedServices"] = 545] = "HealthAndAlliedServices";
    SIC[SIC["Attorneys"] = 546] = "Attorneys";
    SIC[SIC["SchoolsElemenSecondary"] = 547] = "SchoolsElemenSecondary";
    SIC[SIC["CollegesAndUniversities"] = 548] = "CollegesAndUniversities";
    SIC[SIC["JuniorColleges"] = 549] = "JuniorColleges";
    SIC[SIC["SchoolsComputerTrng"] = 550] = "SchoolsComputerTrng";
    SIC[SIC["SchoolsBusinessAndSec"] = 551] = "SchoolsBusinessAndSec";
    SIC[SIC["SchoolsTechnicalTrade"] = 552] = "SchoolsTechnicalTrade";
    SIC[SIC["SchoolsAndEducServices"] = 553] = "SchoolsAndEducServices";
    SIC[SIC["SocialSvcsIndivAndFam"] = 554] = "SocialSvcsIndivAndFam";
    SIC[SIC["SocialSvcsJobTraining"] = 555] = "SocialSvcsJobTraining";
    SIC[SIC["SocialSvcsChildCare"] = 556] = "SocialSvcsChildCare";
    SIC[SIC["SocialSvcsRsdntlCare"] = 557] = "SocialSvcsRsdntlCare";
    SIC[SIC["SocialSvcsNEC"] = 558] = "SocialSvcsNEC";
    SIC[SIC["MuseumsAndArtGalleries"] = 559] = "MuseumsAndArtGalleries";
    SIC[SIC["BotanicalZoologicalGrd"] = 560] = "BotanicalZoologicalGrd";
    SIC[SIC["ProfessionalOrganizations"] = 561] = "ProfessionalOrganizations";
    SIC[SIC["LaborOrganizations"] = 562] = "LaborOrganizations";
    SIC[SIC["CivicAndSocialAssoc"] = 563] = "CivicAndSocialAssoc";
    SIC[SIC["PoliticalOrganizations"] = 564] = "PoliticalOrganizations";
    SIC[SIC["ReligiousOrganizations"] = 565] = "ReligiousOrganizations";
    SIC[SIC["ArchitecturalServices"] = 566] = "ArchitecturalServices";
    SIC[SIC["AccountingAndBookkeeping"] = 567] = "AccountingAndBookkeeping";
    SIC[SIC["ResearchNonphysical"] = 568] = "ResearchNonphysical";
    SIC[SIC["LaboratoriesTesting"] = 569] = "LaboratoriesTesting";
    SIC[SIC["ConstructionManagement"] = 570] = "ConstructionManagement";
    SIC[SIC["ManagementConsultingSrvs"] = 571] = "ManagementConsultingSrvs";
    SIC[SIC["PublicRelationsServices"] = 572] = "PublicRelationsServices";
    SIC[SIC["FacilitiesSupportSvcs"] = 573] = "FacilitiesSupportSvcs";
    SIC[SIC["BusinessConsultingNEC"] = 574] = "BusinessConsultingNEC";
    SIC[SIC["HouseholdsPrivate"] = 575] = "HouseholdsPrivate";
    SIC[SIC["ServicesNEC"] = 576] = "ServicesNEC";
    SIC[SIC["GovtCityExecutiveOfc"] = 577] = "GovtCityExecutiveOfc";
    SIC[SIC["GovtLegislativeOfcs"] = 578] = "GovtLegislativeOfcs";
    SIC[SIC["GovtExecutiveAndLegis"] = 579] = "GovtExecutiveAndLegis";
    SIC[SIC["GovtGeneralNEC"] = 580] = "GovtGeneralNEC";
    SIC[SIC["GovtCourts"] = 581] = "GovtCourts";
    SIC[SIC["GovtPoliceProtection"] = 582] = "GovtPoliceProtection";
    SIC[SIC["GovtLegalCounsel"] = 583] = "GovtLegalCounsel";
    SIC[SIC["GovtCorrectionalInst"] = 584] = "GovtCorrectionalInst";
    SIC[SIC["GovtFireProtection"] = 585] = "GovtFireProtection";
    SIC[SIC["GovtPublicSafetyNEC"] = 586] = "GovtPublicSafetyNEC";
    SIC[SIC["GovtFinanceAndTaxation"] = 587] = "GovtFinanceAndTaxation";
    SIC[SIC["GovtEducProgramsAdm"] = 588] = "GovtEducProgramsAdm";
    SIC[SIC["GovtHealthProgramAdm"] = 589] = "GovtHealthProgramAdm";
    SIC[SIC["GovtSocialProgramAdm"] = 590] = "GovtSocialProgramAdm";
    SIC[SIC["GovtVeteranAffairAdm"] = 591] = "GovtVeteranAffairAdm";
    SIC[SIC["GovtEnvironmentalAdm"] = 592] = "GovtEnvironmentalAdm";
    SIC[SIC["GovtConservationAdm"] = 593] = "GovtConservationAdm";
    SIC[SIC["GovtHousingProgAdm"] = 594] = "GovtHousingProgAdm";
    SIC[SIC["GovtCommunityDevAdm"] = 595] = "GovtCommunityDevAdm";
    SIC[SIC["GovtEconomicProgAdm"] = 596] = "GovtEconomicProgAdm";
    SIC[SIC["GovtTransportationReg"] = 597] = "GovtTransportationReg";
    SIC[SIC["GovtUtilitiesRegulation"] = 598] = "GovtUtilitiesRegulation";
    SIC[SIC["GovtAgriculturalReg"] = 599] = "GovtAgriculturalReg";
    SIC[SIC["GovtCmrclSectorsReg"] = 600] = "GovtCmrclSectorsReg";
    SIC[SIC["GovtSpaceResearchAdm"] = 601] = "GovtSpaceResearchAdm";
    SIC[SIC["GovtNationalSecurity"] = 602] = "GovtNationalSecurity";
    SIC[SIC["GovtInternationalAffairs"] = 603] = "GovtInternationalAffairs";
    SIC[SIC["Corn"] = 604] = "Corn";
    SIC[SIC["VegetablesAndMelons"] = 605] = "VegetablesAndMelons";
    SIC[SIC["GeneralFarmsPrimCrop"] = 606] = "GeneralFarmsPrimCrop";
    SIC[SIC["BeefCattleExcpFeedlot"] = 607] = "BeefCattleExcpFeedlot";
    SIC[SIC["GeneralLivestockNec"] = 608] = "GeneralLivestockNec";
    SIC[SIC["AnimalAquaculture"] = 609] = "AnimalAquaculture";
    SIC[SIC["GeneralFarmsPrimAnimal"] = 610] = "GeneralFarmsPrimAnimal";
    SIC[SIC["SoilPreparationServices"] = 611] = "SoilPreparationServices";
    SIC[SIC["CropPlantingAndProtect"] = 612] = "CropPlantingAndProtect";
    SIC[SIC["VeterinaryServicesforLivestock"] = 613] = "VeterinaryServicesforLivestock";
    SIC[SIC["VeterinaryServicesforAnimalSpecialties"] = 614] = "VeterinaryServicesforAnimalSpecialties";
    SIC[SIC["LivestockServices"] = 615] = "LivestockServices";
    SIC[SIC["LandscapeCounseling"] = 616] = "LandscapeCounseling";
    SIC[SIC["LawnAndGardenServices"] = 617] = "LawnAndGardenServices";
    SIC[SIC["OrnamentalShrubAndTree"] = 618] = "OrnamentalShrubAndTree";
    SIC[SIC["Shellfish"] = 619] = "Shellfish";
    SIC[SIC["FishHatcheries"] = 620] = "FishHatcheries";
    SIC[SIC["CopperOres"] = 621] = "CopperOres";
    SIC[SIC["FeroaloyOresExcpVanad"] = 622] = "FeroaloyOresExcpVanad";
    SIC[SIC["MetalOresNec"] = 623] = "MetalOresNec";
    SIC[SIC["NaturalGasLiquids"] = 624] = "NaturalGasLiquids";
    SIC[SIC["OilAndGasExploration"] = 625] = "OilAndGasExploration";
    SIC[SIC["OilAndGasFieldService"] = 626] = "OilAndGasFieldService";
    SIC[SIC["CrushedAndBrokenStone"] = 627] = "CrushedAndBrokenStone";
    SIC[SIC["KaolinAndBallClay"] = 628] = "KaolinAndBallClay";
    SIC[SIC["ClayAndRelatedMinerals"] = 629] = "ClayAndRelatedMinerals";
    SIC[SIC["ChemAndFertMining"] = 630] = "ChemAndFertMining";
    SIC[SIC["MiscNonmetallicMinerals"] = 631] = "MiscNonmetallicMinerals";
    SIC[SIC["SingleFamHousingConst"] = 632] = "SingleFamHousingConst";
    SIC[SIC["ResidentialConstruction"] = 633] = "ResidentialConstruction";
    SIC[SIC["IndustrialBuildings"] = 634] = "IndustrialBuildings";
    SIC[SIC["NonresidentialConst"] = 635] = "NonresidentialConst";
    SIC[SIC["HighwayAndStreetConst"] = 636] = "HighwayAndStreetConst";
    SIC[SIC["BridgeTunnelElevHwy"] = 637] = "BridgeTunnelElevHwy";
    SIC[SIC["WaterSewerAndUtility"] = 638] = "WaterSewerAndUtility";
    SIC[SIC["HeavyConstructionNec"] = 639] = "HeavyConstructionNec";
    SIC[SIC["PlumbingHeatAirCond"] = 640] = "PlumbingHeatAirCond";
    SIC[SIC["PaintingAndPaperHanging"] = 641] = "PaintingAndPaperHanging";
    SIC[SIC["ElectricalWork"] = 642] = "ElectricalWork";
    SIC[SIC["Masonry"] = 643] = "Masonry";
    SIC[SIC["PlasteringDrywall"] = 644] = "PlasteringDrywall";
    SIC[SIC["WaterWellDrilling"] = 645] = "WaterWellDrilling";
    SIC[SIC["GlassAndGlazingWork"] = 646] = "GlassAndGlazingWork";
    SIC[SIC["ExcavationWork"] = 647] = "ExcavationWork";
    SIC[SIC["WreckingAndDemolition"] = 648] = "WreckingAndDemolition";
    SIC[SIC["InstallingBuildingEquip"] = 649] = "InstallingBuildingEquip";
    SIC[SIC["SpecialTradeContractors"] = 650] = "SpecialTradeContractors";
    SIC[SIC["MeatPackingPlants"] = 651] = "MeatPackingPlants";
    SIC[SIC["SausagesAndOtherMeats"] = 652] = "SausagesAndOtherMeats";
    SIC[SIC["DryCondensedEvapProd"] = 653] = "DryCondensedEvapProd";
    SIC[SIC["FluidMilk"] = 654] = "FluidMilk";
    SIC[SIC["CannedFruitsAndVeg"] = 655] = "CannedFruitsAndVeg";
    SIC[SIC["DehydratedFruitsVeg"] = 656] = "DehydratedFruitsVeg";
    SIC[SIC["PicklesSaucesSaladDrsngs"] = 657] = "PicklesSaucesSaladDrsngs";
    SIC[SIC["FlourOtherGrainMill"] = 658] = "FlourOtherGrainMill";
    SIC[SIC["RiceMilling"] = 659] = "RiceMilling";
    SIC[SIC["PreparedFeedsNec"] = 660] = "PreparedFeedsNec";
    SIC[SIC["BreadCakeAndRelProd"] = 661] = "BreadCakeAndRelProd";
    SIC[SIC["CandyAndOthConfectProd"] = 662] = "CandyAndOthConfectProd";
    SIC[SIC["ChewingGum"] = 663] = "ChewingGum";
    SIC[SIC["SaltAndRoastNutSeed"] = 664] = "SaltAndRoastNutSeed";
    SIC[SIC["CottonseedOilMills"] = 665] = "CottonseedOilMills";
    SIC[SIC["SoybeanOilMills"] = 666] = "SoybeanOilMills";
    SIC[SIC["VegetableOilMillsNec"] = 667] = "VegetableOilMillsNec";
    SIC[SIC["AnmlAndMarineFatsOils"] = 668] = "AnmlAndMarineFatsOils";
    SIC[SIC["EdibleFatsAndOilsNec"] = 669] = "EdibleFatsAndOilsNec";
    SIC[SIC["WinesAndBrandy"] = 670] = "WinesAndBrandy";
    SIC[SIC["CannedCuredFishSeafood"] = 671] = "CannedCuredFishSeafood";
    SIC[SIC["FreshOrFrozPreprdFish"] = 672] = "FreshOrFrozPreprdFish";
    SIC[SIC["RoastedCoffee"] = 673] = "RoastedCoffee";
    SIC[SIC["PotatoChipsAndSnacks"] = 674] = "PotatoChipsAndSnacks";
    SIC[SIC["MacaroniAndSpaghetti"] = 675] = "MacaroniAndSpaghetti";
    SIC[SIC["Cigars"] = 676] = "Cigars";
    SIC[SIC["ChewngAndSmokngTobacco"] = 677] = "ChewngAndSmokngTobacco";
    SIC[SIC["BroadwovenFabMillsCot"] = 678] = "BroadwovenFabMillsCot";
    SIC[SIC["BrdwvnFabMillsManmade"] = 679] = "BrdwvnFabMillsManmade";
    SIC[SIC["BroadwovnFabMillsWool"] = 680] = "BroadwovnFabMillsWool";
    SIC[SIC["NarrowFabricMills"] = 681] = "NarrowFabricMills";
    SIC[SIC["WomenHosieryExcpSocks"] = 682] = "WomenHosieryExcpSocks";
    SIC[SIC["KnitOuterwearMills"] = 683] = "KnitOuterwearMills";
    SIC[SIC["KnitUnderwearMills"] = 684] = "KnitUnderwearMills";
    SIC[SIC["WeftKnitFabricMills"] = 685] = "WeftKnitFabricMills";
    SIC[SIC["LaceAndWarpKnitFabMil"] = 686] = "LaceAndWarpKnitFabMil";
    SIC[SIC["KnittingMillsNec"] = 687] = "KnittingMillsNec";
    SIC[SIC["FinishingPlantsCotton"] = 688] = "FinishingPlantsCotton";
    SIC[SIC["FinishingPlantsManmade"] = 689] = "FinishingPlantsManmade";
    SIC[SIC["FinishingPlantsNec"] = 690] = "FinishingPlantsNec";
    SIC[SIC["YarnSpinningMills"] = 691] = "YarnSpinningMills";
    SIC[SIC["ThreadMills"] = 692] = "ThreadMills";
    SIC[SIC["CoatedFabNotRubberzd"] = 693] = "CoatedFabNotRubberzd";
    SIC[SIC["NonwovenFabrics"] = 694] = "NonwovenFabrics";
    SIC[SIC["TextileGoodsNec"] = 695] = "TextileGoodsNec";
    SIC[SIC["MenBoySuitAndCoat"] = 696] = "MenBoySuitAndCoat";
    SIC[SIC["MensAndBoysShirts"] = 697] = "MensAndBoysShirts";
    SIC[SIC["MensAndBoysUnderwear"] = 698] = "MensAndBoysUnderwear";
    SIC[SIC["MensAndBoysTrousers"] = 699] = "MensAndBoysTrousers";
    SIC[SIC["MensAndBoysClothingNEC"] = 700] = "MensAndBoysClothingNEC";
    SIC[SIC["WomensAndMissesShirt"] = 701] = "WomensAndMissesShirt";
    SIC[SIC["WomensMissesDresses"] = 702] = "WomensMissesDresses";
    SIC[SIC["WomensAndMissesSuits"] = 703] = "WomensAndMissesSuits";
    SIC[SIC["WomensMissesOuterwear"] = 704] = "WomensMissesOuterwear";
    SIC[SIC["WomensChldrnsUndrwear"] = 705] = "WomensChldrnsUndrwear";
    SIC[SIC["BrasGirdles"] = 706] = "BrasGirdles";
    SIC[SIC["GirlsChldrnsDresses"] = 707] = "GirlsChldrnsDresses";
    SIC[SIC["GirlsChldrnsOuterwear"] = 708] = "GirlsChldrnsOuterwear";
    SIC[SIC["FurGoods"] = 709] = "FurGoods";
    SIC[SIC["FabDressAndWorkGloves"] = 710] = "FabDressAndWorkGloves";
    SIC[SIC["RobesAndDressingGowns"] = 711] = "RobesAndDressingGowns";
    SIC[SIC["WaterproofOuterwear"] = 712] = "WaterproofOuterwear";
    SIC[SIC["LthrAndSheepLndClthng"] = 713] = "LthrAndSheepLndClthng";
    SIC[SIC["ApparelBelts"] = 714] = "ApparelBelts";
    SIC[SIC["ApparelAndAccessories"] = 715] = "ApparelAndAccessories";
    SIC[SIC["CurtainsAndDraperies"] = 716] = "CurtainsAndDraperies";
    SIC[SIC["HousefurnishingsNec"] = 717] = "HousefurnishingsNec";
    SIC[SIC["TextileBags"] = 718] = "TextileBags";
    SIC[SIC["PleatingAndStitching"] = 719] = "PleatingAndStitching";
    SIC[SIC["AutoAndApparelTrimming"] = 720] = "AutoAndApparelTrimming";
    SIC[SIC["FabricatedTextileProd"] = 721] = "FabricatedTextileProd";
    SIC[SIC["SawmillAndPlaningMills"] = 722] = "SawmillAndPlaningMills";
    SIC[SIC["HardwdDimAndFlrngMill"] = 723] = "HardwdDimAndFlrngMill";
    SIC[SIC["SpecialProductSawmills"] = 724] = "SpecialProductSawmills";
    SIC[SIC["WoodKitchenCabinets"] = 725] = "WoodKitchenCabinets";
    SIC[SIC["NailedWoodBoxes"] = 726] = "NailedWoodBoxes";
    SIC[SIC["WoodPalletsAndSkids"] = 727] = "WoodPalletsAndSkids";
    SIC[SIC["WoodContainersNec"] = 728] = "WoodContainersNec";
    SIC[SIC["WoodProductsNec"] = 729] = "WoodProductsNec";
    SIC[SIC["WoodHouseholdFurniture"] = 730] = "WoodHouseholdFurniture";
    SIC[SIC["UpholsterHouseholdFurn"] = 731] = "UpholsterHouseholdFurn";
    SIC[SIC["HouseholdFurnitureNec"] = 732] = "HouseholdFurnitureNec";
    SIC[SIC["PubBldgAndRelFurn"] = 733] = "PubBldgAndRelFurn";
    SIC[SIC["PartitionsAndFixtures"] = 734] = "PartitionsAndFixtures";
    SIC[SIC["FurnitureAndFixtures"] = 735] = "FurnitureAndFixtures";
    SIC[SIC["PaperMills"] = 736] = "PaperMills";
    SIC[SIC["PaperboardMills"] = 737] = "PaperboardMills";
    SIC[SIC["CorrugatedBoxes"] = 738] = "CorrugatedBoxes";
    SIC[SIC["PaperCoatedAndLaminate"] = 739] = "PaperCoatedAndLaminate";
    SIC[SIC["SanitaryPaperProducts"] = 740] = "SanitaryPaperProducts";
    SIC[SIC["ConvertedPaperProducts"] = 741] = "ConvertedPaperProducts";
    SIC[SIC["Periodicals"] = 742] = "Periodicals";
    SIC[SIC["BookPublishing"] = 743] = "BookPublishing";
    SIC[SIC["CommercialPrintingLitho"] = 744] = "CommercialPrintingLitho";
    SIC[SIC["CommercialPrtngGravure"] = 745] = "CommercialPrtngGravure";
    SIC[SIC["ManifoldBusinessForms"] = 746] = "ManifoldBusinessForms";
    SIC[SIC["Typesetting"] = 747] = "Typesetting";
    SIC[SIC["PlatemakingServices"] = 748] = "PlatemakingServices";
    SIC[SIC["IndustrialGases"] = 749] = "IndustrialGases";
    SIC[SIC["InorganicPigments"] = 750] = "InorganicPigments";
    SIC[SIC["PharmaceuticalPrep"] = 751] = "PharmaceuticalPrep";
    SIC[SIC["SoapAndOtherDetergents"] = 752] = "SoapAndOtherDetergents";
    SIC[SIC["PaintsAndAlliedProd"] = 753] = "PaintsAndAlliedProd";
    SIC[SIC["CarbonBlack"] = 754] = "CarbonBlack";
    SIC[SIC["ChemicalPreparations"] = 755] = "ChemicalPreparations";
    SIC[SIC["PetroleumAndCoalProd"] = 756] = "PetroleumAndCoalProd";
    SIC[SIC["UnsupportedPlasShapes"] = 757] = "UnsupportedPlasShapes";
    SIC[SIC["PlasticsPipe"] = 758] = "PlasticsPipe";
    SIC[SIC["PlasticsProductsNec"] = 759] = "PlasticsProductsNec";
    SIC[SIC["LthrTanningAndFinishng"] = 760] = "LthrTanningAndFinishng";
    SIC[SIC["FootwearCutStock"] = 761] = "FootwearCutStock";
    SIC[SIC["LeatherGlovesAndMitten"] = 762] = "LeatherGlovesAndMitten";
    SIC[SIC["LeatherGoodsNec"] = 763] = "LeatherGoodsNec";
    SIC[SIC["VitreousKitchenware"] = 764] = "VitreousKitchenware";
    SIC[SIC["SemivitreousKitchenware"] = 765] = "SemivitreousKitchenware";
    SIC[SIC["PotteryProductsNec"] = 766] = "PotteryProductsNec";
    SIC[SIC["ConcreteBlockAndBrick"] = 767] = "ConcreteBlockAndBrick";
    SIC[SIC["GypsumProducts"] = 768] = "GypsumProducts";
    SIC[SIC["AsbestosProducts"] = 769] = "AsbestosProducts";
    SIC[SIC["NonmetallicMineralProd"] = 770] = "NonmetallicMineralProd";
    SIC[SIC["BlastFurnAndSteelMill"] = 771] = "BlastFurnAndSteelMill";
    SIC[SIC["ColdFinishSteelShapes"] = 772] = "ColdFinishSteelShapes";
    SIC[SIC["GrayDuctleIronFoundries"] = 773] = "GrayDuctleIronFoundries";
    SIC[SIC["MalleableIronFoundries"] = 774] = "MalleableIronFoundries";
    SIC[SIC["SecondaryNonferrousMtl"] = 775] = "SecondaryNonferrousMtl";
    SIC[SIC["AlumRollingAndDrwng"] = 776] = "AlumRollingAndDrwng";
    SIC[SIC["NonferrousRlngAndDrwng"] = 777] = "NonferrousRlngAndDrwng";
    SIC[SIC["PrimaryMetalProducts"] = 778] = "PrimaryMetalProducts";
    SIC[SIC["MetalBarrels"] = 779] = "MetalBarrels";
    SIC[SIC["Cutlery"] = 780] = "Cutlery";
    SIC[SIC["HandAndEdgeToolsNec"] = 781] = "HandAndEdgeToolsNec";
    SIC[SIC["HardwareNec"] = 782] = "HardwareNec";
    SIC[SIC["HeatingEquipExceptElec"] = 783] = "HeatingEquipExceptElec";
    SIC[SIC["FabricatedStructuralMtl"] = 784] = "FabricatedStructuralMtl";
    SIC[SIC["MetalDoors"] = 785] = "MetalDoors";
    SIC[SIC["ArchitecturalMetalWork"] = 786] = "ArchitecturalMetalWork";
    SIC[SIC["BoltsNutsRivets"] = 787] = "BoltsNutsRivets";
    SIC[SIC["PlatingAndPolishing"] = 788] = "PlatingAndPolishing";
    SIC[SIC["MtlCoatngAndAlliedSvc"] = 789] = "MtlCoatngAndAlliedSvc";
    SIC[SIC["SmallArms"] = 790] = "SmallArms";
    SIC[SIC["FluidPowerValves"] = 791] = "FluidPowerValves";
    SIC[SIC["ValvesAndPipeFittings"] = 792] = "ValvesAndPipeFittings";
    SIC[SIC["MiscFabWireProd"] = 793] = "MiscFabWireProd";
    SIC[SIC["InternalCombustionEngns"] = 794] = "InternalCombustionEngns";
    SIC[SIC["FarmMachineryAndEquip"] = 795] = "FarmMachineryAndEquip";
    SIC[SIC["Conveyors"] = 796] = "Conveyors";
    SIC[SIC["HoistsCranesMonorails"] = 797] = "HoistsCranesMonorails";
    SIC[SIC["IndstrlTrcksAndTractor"] = 798] = "IndstrlTrcksAndTractor";
    SIC[SIC["WeldingApparatus"] = 799] = "WeldingApparatus";
    SIC[SIC["PumpsAndPumpingEquip"] = 800] = "PumpsAndPumpingEquip";
    SIC[SIC["GeneralIndustrialMach"] = 801] = "GeneralIndustrialMach";
    SIC[SIC["ComputerPeripheralEquip"] = 802] = "ComputerPeripheralEquip";
    SIC[SIC["CalculatingEquipment"] = 803] = "CalculatingEquipment";
    SIC[SIC["OfficeMachinesNec"] = 804] = "OfficeMachinesNec";
    SIC[SIC["AutomaticVendingMachine"] = 805] = "AutomaticVendingMachine";
    SIC[SIC["ServiceIndustryMach"] = 806] = "ServiceIndustryMach";
    SIC[SIC["Transformers"] = 807] = "Transformers";
    SIC[SIC["MotorsAndGenerators"] = 808] = "MotorsAndGenerators";
    SIC[SIC["ElecIndstrlApparatus"] = 809] = "ElecIndstrlApparatus";
    SIC[SIC["ElectricHousewares"] = 810] = "ElectricHousewares";
    SIC[SIC["HouseholdVacuumCleaners"] = 811] = "HouseholdVacuumCleaners";
    SIC[SIC["ResdentlLghtngFixt"] = 812] = "ResdentlLghtngFixt";
    SIC[SIC["LightingEquipmentNec"] = 813] = "LightingEquipmentNec";
    SIC[SIC["HouseholdEquipment"] = 814] = "HouseholdEquipment";
    SIC[SIC["RadioAndTVEquipment"] = 815] = "RadioAndTVEquipment";
    SIC[SIC["EngineElectricalEquip"] = 816] = "EngineElectricalEquip";
    SIC[SIC["MagAndOptRecMedia"] = 817] = "MagAndOptRecMedia";
    SIC[SIC["ElecEquipAndSupplies"] = 818] = "ElecEquipAndSupplies";
    SIC[SIC["TruckAndBusBodies"] = 819] = "TruckAndBusBodies";
    SIC[SIC["Aircraft"] = 820] = "Aircraft";
    SIC[SIC["RailroadEquipment"] = 821] = "RailroadEquipment";
    SIC[SIC["MotorcyclesBicycles"] = 822] = "MotorcyclesBicycles";
    SIC[SIC["TravelTrailers"] = 823] = "TravelTrailers";
    SIC[SIC["TanksAndTankComponent"] = 824] = "TanksAndTankComponent";
    SIC[SIC["LaboratoryApparatus"] = 825] = "LaboratoryApparatus";
    SIC[SIC["FluidMetersCountingDevices"] = 826] = "FluidMetersCountingDevices";
    SIC[SIC["MeasuringDevices"] = 827] = "MeasuringDevices";
    SIC[SIC["SurgicalInstruments"] = 828] = "SurgicalInstruments";
    SIC[SIC["SurgicalAppliances"] = 829] = "SurgicalAppliances";
    SIC[SIC["XRayApparatusAndTube"] = 830] = "XRayApparatusAndTube";
    SIC[SIC["ElectromedicalEquipment"] = 831] = "ElectromedicalEquipment";
    SIC[SIC["ManufacturingOphthalmicGoods"] = 832] = "ManufacturingOphthalmicGoods";
    SIC[SIC["WatchesClocks"] = 833] = "WatchesClocks";
    SIC[SIC["JewelryPreciousMetal"] = 834] = "JewelryPreciousMetal";
    SIC[SIC["Silverware"] = 835] = "Silverware";
    SIC[SIC["GamesToys"] = 836] = "GamesToys";
    SIC[SIC["SportngAndAthlcGoods"] = 837] = "SportngAndAthlcGoods";
    SIC[SIC["LeadPencilsAndArtGood"] = 838] = "LeadPencilsAndArtGood";
    SIC[SIC["CostumeJewelry"] = 839] = "CostumeJewelry";
    SIC[SIC["ButtonsNeedlesAndPins"] = 840] = "ButtonsNeedlesAndPins";
    SIC[SIC["BroomsAndBrushes"] = 841] = "BroomsAndBrushes";
    SIC[SIC["HardSurfaceFloorCover"] = 842] = "HardSurfaceFloorCover";
    SIC[SIC["ManufacturingIndustries"] = 843] = "ManufacturingIndustries";
    SIC[SIC["Taxicabs"] = 844] = "Taxicabs";
    SIC[SIC["LocalBusCharterService"] = 845] = "LocalBusCharterService";
    SIC[SIC["BusCharterService"] = 846] = "BusCharterService";
    SIC[SIC["SchoolBuses"] = 847] = "SchoolBuses";
    SIC[SIC["BusTerminal"] = 848] = "BusTerminal";
    SIC[SIC["LocalTruckingWStorage"] = 849] = "LocalTruckingWStorage";
    SIC[SIC["RefrigeratedWarehousing"] = 850] = "RefrigeratedWarehousing";
    SIC[SIC["TruckingTerminalFac"] = 851] = "TruckingTerminalFac";
    SIC[SIC["USPostalService"] = 852] = "USPostalService";
    SIC[SIC["DeepSeaDomesticTrans"] = 853] = "DeepSeaDomesticTrans";
    SIC[SIC["FreightTransGreatLakes"] = 854] = "FreightTransGreatLakes";
    SIC[SIC["WaterTransOfFreight"] = 855] = "WaterTransOfFreight";
    SIC[SIC["Ferries"] = 856] = "Ferries";
    SIC[SIC["WaterPassengerTrans"] = 857] = "WaterPassengerTrans";
    SIC[SIC["TowingAndTugboatSvc"] = 858] = "TowingAndTugboatSvc";
    SIC[SIC["WaterTransServices"] = 859] = "WaterTransServices";
    SIC[SIC["AirCourierServices"] = 860] = "AirCourierServices";
    SIC[SIC["PassTransportArngemnt"] = 861] = "PassTransportArngemnt";
    SIC[SIC["RentalOfRailroadCars"] = 862] = "RentalOfRailroadCars";
    SIC[SIC["InspectionAndFixedFac"] = 863] = "InspectionAndFixedFac";
    SIC[SIC["TransportationServicesNec"] = 864] = "TransportationServicesNec";
    SIC[SIC["TelephoneCommExcpRadio"] = 865] = "TelephoneCommExcpRadio";
    SIC[SIC["TelegraphAndOtherCommunicat"] = 866] = "TelegraphAndOtherCommunicat";
    SIC[SIC["ElectricServices"] = 867] = "ElectricServices";
    SIC[SIC["NaturalGasTransmission"] = 868] = "NaturalGasTransmission";
    SIC[SIC["GasTransmissionAndDist"] = 869] = "GasTransmissionAndDist";
    SIC[SIC["NaturalGasDistribution"] = 870] = "NaturalGasDistribution";
    SIC[SIC["GasProduction"] = 871] = "GasProduction";
    SIC[SIC["ElecAndOthServCombined"] = 872] = "ElecAndOthServCombined";
    SIC[SIC["GasAndOtherSvcCombined"] = 873] = "GasAndOtherSvcCombined";
    SIC[SIC["CombinationUtilities"] = 874] = "CombinationUtilities";
    SIC[SIC["WaterSupply"] = 875] = "WaterSupply";
    SIC[SIC["SanitaryServicesNec"] = 876] = "SanitaryServicesNec";
    SIC[SIC["IrrigationSystems"] = 877] = "IrrigationSystems";
    SIC[SIC["LumberPlywood"] = 878] = "LumberPlywood";
    SIC[SIC["IndustryMachAndEquip"] = 879] = "IndustryMachAndEquip";
    SIC[SIC["RecreationalGoods"] = 880] = "RecreationalGoods";
    SIC[SIC["DurableGoodsNec"] = 881] = "DurableGoodsNec";
    SIC[SIC["PieceGoodsAndNotions"] = 882] = "PieceGoodsAndNotions";
    SIC[SIC["Footwear"] = 883] = "Footwear";
    SIC[SIC["PlasticsMaterialsAndBasicFormsAndShapes"] = 884] = "PlasticsMaterialsAndBasicFormsAndShapes";
    SIC[SIC["Lumber"] = 885] = "Lumber";
    SIC[SIC["HardwareStores"] = 886] = "HardwareStores";
    SIC[SIC["RetailNurseries"] = 887] = "RetailNurseries";
    SIC[SIC["VarietyStores"] = 888] = "VarietyStores";
    SIC[SIC["MiscGnrlMerchandiseStores"] = 889] = "MiscGnrlMerchandiseStores";
    SIC[SIC["MeatAndFishMarkets"] = 890] = "MeatAndFishMarkets";
    SIC[SIC["FruitAndVegMarkets"] = 891] = "FruitAndVegMarkets";
    SIC[SIC["CandyNutConfecStr"] = 892] = "CandyNutConfecStr";
    SIC[SIC["DairyProductsStores"] = 893] = "DairyProductsStores";
    SIC[SIC["MiscellaneousFoodStores"] = 894] = "MiscellaneousFoodStores";
    SIC[SIC["AutoAndHmeSupplyStrs"] = 895] = "AutoAndHmeSupplyStrs";
    SIC[SIC["MensBoysClothingStores"] = 896] = "MensBoysClothingStores";
    SIC[SIC["WomensClothingStores"] = 897] = "WomensClothingStores";
    SIC[SIC["WomensAccsryAndSpecStrs"] = 898] = "WomensAccsryAndSpecStrs";
    SIC[SIC["ChildrenInfantWearStore"] = 899] = "ChildrenInfantWearStore";
    SIC[SIC["ShoeStores"] = 900] = "ShoeStores";
    SIC[SIC["ApparelAndAccessoryStr"] = 901] = "ApparelAndAccessoryStr";
    SIC[SIC["FurnitureStores"] = 902] = "FurnitureStores";
    SIC[SIC["FloorCoveringStores"] = 903] = "FloorCoveringStores";
    SIC[SIC["DraperyUpholsteryStr"] = 904] = "DraperyUpholsteryStr";
    SIC[SIC["MiscHomefurnishingsStr"] = 905] = "MiscHomefurnishingsStr";
    SIC[SIC["HouseholdApplianceStore"] = 906] = "HouseholdApplianceStore";
    SIC[SIC["RadioTvAndElecStore"] = 907] = "RadioTvAndElecStore";
    SIC[SIC["ComputerAndSoftwareStr"] = 908] = "ComputerAndSoftwareStr";
    SIC[SIC["RecordPrerecordedTapeStr"] = 909] = "RecordPrerecordedTapeStr";
    SIC[SIC["DrugStores"] = 910] = "DrugStores";
    SIC[SIC["LiquorStores"] = 911] = "LiquorStores";
    SIC[SIC["SprtngGoodsBicycleShops"] = 912] = "SprtngGoodsBicycleShops";
    SIC[SIC["BookStores"] = 913] = "BookStores";
    SIC[SIC["StationeryStores"] = 914] = "StationeryStores";
    SIC[SIC["JewelryStores"] = 915] = "JewelryStores";
    SIC[SIC["HobbyToyAndGameShop"] = 916] = "HobbyToyAndGameShop";
    SIC[SIC["GiftNoveltyAndSouvenir"] = 917] = "GiftNoveltyAndSouvenir";
    SIC[SIC["SewingNeedlework"] = 918] = "SewingNeedlework";
    SIC[SIC["FuelOilDealers"] = 919] = "FuelOilDealers";
    SIC[SIC["PetroleumGasDealers"] = 920] = "PetroleumGasDealers";
    SIC[SIC["TobaccoStoresAndStands"] = 921] = "TobaccoStoresAndStands";
    SIC[SIC["CntrlReserveDepository"] = 922] = "CntrlReserveDepository";
    SIC[SIC["BanksNtlCommercial"] = 923] = "BanksNtlCommercial";
    SIC[SIC["BanksCommercialNEC"] = 924] = "BanksCommercialNEC";
    SIC[SIC["BanksFederalSavings"] = 925] = "BanksFederalSavings";
    SIC[SIC["BanksStateSavings"] = 926] = "BanksStateSavings";
    SIC[SIC["CreditUnionsFederal"] = 927] = "CreditUnionsFederal";
    SIC[SIC["CreditUnionsState"] = 928] = "CreditUnionsState";
    SIC[SIC["BanksAndBranchesForeign"] = 929] = "BanksAndBranchesForeign";
    SIC[SIC["BanksForeignTrade"] = 930] = "BanksForeignTrade";
    SIC[SIC["TrustCoNondepository"] = 931] = "TrustCoNondepository";
    SIC[SIC["BankServicesNEC"] = 932] = "BankServicesNEC";
    SIC[SIC["CreditAgcyFedSponsrd"] = 933] = "CreditAgcyFedSponsrd";
    SIC[SIC["CreditAgShortTermBus"] = 934] = "CreditAgShortTermBus";
    SIC[SIC["CreditAgencyMiscBus"] = 935] = "CreditAgencyMiscBus";
    SIC[SIC["MortgageBankers"] = 936] = "MortgageBankers";
    SIC[SIC["SecurityCommodityServ"] = 937] = "SecurityCommodityServ";
    SIC[SIC["InsuranceLife"] = 938] = "InsuranceLife";
    SIC[SIC["InsuranceHealth"] = 939] = "InsuranceHealth";
    SIC[SIC["InsuranceMedSvcPlans"] = 940] = "InsuranceMedSvcPlans";
    SIC[SIC["InsuranceProperty"] = 941] = "InsuranceProperty";
    SIC[SIC["InsuranceSurety"] = 942] = "InsuranceSurety";
    SIC[SIC["InsuranceCarriersNEC"] = 943] = "InsuranceCarriersNEC";
    SIC[SIC["OperatorApartmentBldg"] = 944] = "OperatorApartmentBldg";
    SIC[SIC["OperatorDwlngsExcpApt"] = 945] = "OperatorDwlngsExcpApt";
    SIC[SIC["OperatorMobileHomes"] = 946] = "OperatorMobileHomes";
    SIC[SIC["PropertyLessorRailroad"] = 947] = "PropertyLessorRailroad";
    SIC[SIC["PropertyLessorReal"] = 948] = "PropertyLessorReal";
    SIC[SIC["DeveloperCemeteries"] = 949] = "DeveloperCemeteries";
    SIC[SIC["InvestmentOfficesNEC"] = 950] = "InvestmentOfficesNEC";
    SIC[SIC["TradersOilRoyalty"] = 951] = "TradersOilRoyalty";
    SIC[SIC["LessorsPatent"] = 952] = "LessorsPatent";
    SIC[SIC["InvestorsNEC"] = 953] = "InvestorsNEC";
    SIC[SIC["BoardingHouse"] = 954] = "BoardingHouse";
    SIC[SIC["HotelsMembershipBasis"] = 955] = "HotelsMembershipBasis";
    SIC[SIC["Laundries"] = 956] = "Laundries";
    SIC[SIC["Cleaners"] = 957] = "Cleaners";
    SIC[SIC["LinenSupplyService"] = 958] = "LinenSupplyService";
    SIC[SIC["CleanersDrapery"] = 959] = "CleanersDrapery";
    SIC[SIC["LaundryAndGarmentSvcs"] = 960] = "LaundryAndGarmentSvcs";
    SIC[SIC["ShoeRepair"] = 961] = "ShoeRepair";
    SIC[SIC["AdvertisingSvcOutdoor"] = 962] = "AdvertisingSvcOutdoor";
    SIC[SIC["CollectionServices"] = 963] = "CollectionServices";
    SIC[SIC["PhotocopyingServices"] = 964] = "PhotocopyingServices";
    SIC[SIC["PhotographyCommercial"] = 965] = "PhotographyCommercial";
    SIC[SIC["GraphicDesignCommercial"] = 966] = "GraphicDesignCommercial";
    SIC[SIC["PestControlServices"] = 967] = "PestControlServices";
    SIC[SIC["BuildingMaintenanceSvc"] = 968] = "BuildingMaintenanceSvc";
    SIC[SIC["EquipRentalHeavyConst"] = 969] = "EquipRentalHeavyConst";
    SIC[SIC["EmploymentAgenciesPerm"] = 970] = "EmploymentAgenciesPerm";
    SIC[SIC["ComputerSystemDesign"] = 971] = "ComputerSystemDesign";
    SIC[SIC["ComputerDataProcessing"] = 972] = "ComputerDataProcessing";
    SIC[SIC["ComputerRentalLeasing"] = 973] = "ComputerRentalLeasing";
    SIC[SIC["ComputerSvcAndRepair"] = 974] = "ComputerSvcAndRepair";
    SIC[SIC["TruckRentalAndLeasing"] = 975] = "TruckRentalAndLeasing";
    SIC[SIC["TrailerRentalAndLeasing"] = 976] = "TrailerRentalAndLeasing";
    SIC[SIC["ParkingStations"] = 977] = "ParkingStations";
    SIC[SIC["AutoGlassReplcmntShops"] = 978] = "AutoGlassReplcmntShops";
    SIC[SIC["RepairShopRadioAndTv"] = 979] = "RepairShopRadioAndTv";
    SIC[SIC["RepairShopRefrigerator"] = 980] = "RepairShopRefrigerator";
    SIC[SIC["RepairShopsElectrical"] = 981] = "RepairShopsElectrical";
    SIC[SIC["RepairShopsJewelry"] = 982] = "RepairShopsJewelry";
    SIC[SIC["RepairShopsUpholstery"] = 983] = "RepairShopsUpholstery";
    SIC[SIC["RepairShopsWelding"] = 984] = "RepairShopsWelding";
    SIC[SIC["RepairShopOutbrdMotor"] = 985] = "RepairShopOutbrdMotor";
    SIC[SIC["MotionPicAndVideoDist"] = 986] = "MotionPicAndVideoDist";
    SIC[SIC["MotionPicDistServices"] = 987] = "MotionPicDistServices";
    SIC[SIC["DanceStudiosSchools"] = 988] = "DanceStudiosSchools";
    SIC[SIC["HealthClubs"] = 989] = "HealthClubs";
    SIC[SIC["GolfCourses"] = 990] = "GolfCourses";
    SIC[SIC["SportsClubsPrivate"] = 991] = "SportsClubsPrivate";
    SIC[SIC["OsteopathicPhysician"] = 992] = "OsteopathicPhysician";
    SIC[SIC["NursingHomesContinuous"] = 993] = "NursingHomesContinuous";
    SIC[SIC["NursingHomeIntrmediate"] = 994] = "NursingHomeIntrmediate";
    SIC[SIC["RetirementHome"] = 995] = "RetirementHome";
    SIC[SIC["HospitalsGeneral"] = 996] = "HospitalsGeneral";
    SIC[SIC["HospitalsPsychiatric"] = 997] = "HospitalsPsychiatric";
    SIC[SIC["Libraries"] = 998] = "Libraries";
    SIC[SIC["BusinessAssociations"] = 999] = "BusinessAssociations";
    SIC[SIC["MembershipOrganizations"] = 1000] = "MembershipOrganizations";
    SIC[SIC["EngineeringServices"] = 1001] = "EngineeringServices";
    SIC[SIC["SurveyingServices"] = 1002] = "SurveyingServices";
    SIC[SIC["ResearchPhysical"] = 1003] = "ResearchPhysical";
    SIC[SIC["ResearchPhilanthropic"] = 1004] = "ResearchPhilanthropic";
    SIC[SIC["NonclassifiableEstab"] = 1005] = "NonclassifiableEstab";
})(SIC || (SIC = {}));
/** CoStar.Api.SuiteDetail.Types.NAICS */
export var NAICS;
(function (NAICS) {
    NAICS[NAICS["AdvertisingMaterialDistributionServices"] = 1] = "AdvertisingMaterialDistributionServices";
    NAICS[NAICS["AgentsAndManagersForArtistsAthletesEntertainersAndOtherPublicFigures"] = 2] = "AgentsAndManagersForArtistsAthletesEntertainersAndOtherPublicFigures";
    NAICS[NAICS["AirTrafficControl"] = 3] = "AirTrafficControl";
    NAICS[NAICS["AirConditioningAndWarmAirHeatingEquipmentAndCommercialAndIndustrialRefrigerationEquipmentManufacturing"] = 4] = "AirConditioningAndWarmAirHeatingEquipmentAndCommercialAndIndustrialRefrigerationEquipmentManufacturing";
    NAICS[NAICS["AircraftManufacturing"] = 5] = "AircraftManufacturing";
    NAICS[NAICS["AmusementAndRecreationIndustries"] = 6] = "AmusementAndRecreationIndustries";
    NAICS[NAICS["AnimalProduction"] = 7] = "AnimalProduction";
    NAICS[NAICS["AutomotiveRepairAndMaintenance"] = 8] = "AutomotiveRepairAndMaintenance";
    NAICS[NAICS["BasicOrganicChemicalManufacturing"] = 10] = "BasicOrganicChemicalManufacturing";
    NAICS[NAICS["ConvertedPaperProductManufacturing"] = 11] = "ConvertedPaperProductManufacturing";
    NAICS[NAICS["GeneralMerchandiseStores"] = 13] = "GeneralMerchandiseStores";
    NAICS[NAICS["GrainFarming"] = 14] = "GrainFarming";
    NAICS[NAICS["HealthAndPersonalCareStores"] = 15] = "HealthAndPersonalCareStores";
    NAICS[NAICS["HomeFurnishingsStores"] = 16] = "HomeFurnishingsStores";
    NAICS[NAICS["MetalOreMining"] = 19] = "MetalOreMining";
    NAICS[NAICS["ChemicalProductAndPreparationManufacturing"] = 20] = "ChemicalProductAndPreparationManufacturing";
    NAICS[NAICS["CropFarming"] = 21] = "CropFarming";
    NAICS[NAICS["ElectricalEquipmentAndComponentManufacturing"] = 22] = "ElectricalEquipmentAndComponentManufacturing";
    NAICS[NAICS["FoodManufacturing"] = 24] = "FoodManufacturing";
    NAICS[NAICS["GeneralPurposeMachineryManufacturing"] = 25] = "GeneralPurposeMachineryManufacturing";
    NAICS[NAICS["MiscellaneousManufacturing"] = 26] = "MiscellaneousManufacturing";
    NAICS[NAICS["NonmetallicMineralProductManufacturing"] = 27] = "NonmetallicMineralProductManufacturing";
    NAICS[NAICS["MiscellaneousSchoolsAndInstruction"] = 28] = "MiscellaneousSchoolsAndInstruction";
    NAICS[NAICS["MiscellaneousStoreRetailers"] = 29] = "MiscellaneousStoreRetailers";
    NAICS[NAICS["TextileProductMills"] = 30] = "TextileProductMills";
    NAICS[NAICS["MiscellaneousWasteManagementServices"] = 31] = "MiscellaneousWasteManagementServices";
    NAICS[NAICS["WoodProductManufacturing"] = 32] = "WoodProductManufacturing";
    NAICS[NAICS["NonDepositoryCreditIntermediation"] = 34] = "NonDepositoryCreditIntermediation";
    NAICS[NAICS["NonmetallicMineralMining"] = 35] = "NonmetallicMineralMining";
    NAICS[NAICS["PersonalServices"] = 36] = "PersonalServices";
    NAICS[NAICS["PetroleumAndCoalProductsManufacturing"] = 37] = "PetroleumAndCoalProductsManufacturing";
    NAICS[NAICS["ProfessionalScientificAndTechnicalServices"] = 39] = "ProfessionalScientificAndTechnicalServices";
    NAICS[NAICS["SpecialtyFoodStores"] = 40] = "SpecialtyFoodStores";
    NAICS[NAICS["SpecialtyTradeContractors"] = 41] = "SpecialtyTradeContractors";
    NAICS[NAICS["SupportActivitiesForTransportation"] = 42] = "SupportActivitiesForTransportation";
    NAICS[NAICS["SupportServices"] = 43] = "SupportServices";
    NAICS[NAICS["TransitAndGroundPassengerTransportation"] = 44] = "TransitAndGroundPassengerTransportation";
    NAICS[NAICS["TravelArrangementAndReservationServices"] = 45] = "TravelArrangementAndReservationServices";
    NAICS[NAICS["AmbulanceServices"] = 46] = "AmbulanceServices";
    NAICS[NAICS["AnimalSlaughtering"] = 47] = "AnimalSlaughtering";
    NAICS[NAICS["ApplianceRepairAndMaintenance"] = 48] = "ApplianceRepairAndMaintenance";
    NAICS[NAICS["AudioAndVideoEquipmentManufacturing"] = 49] = "AudioAndVideoEquipmentManufacturing";
    NAICS[NAICS["AutomotiveGlassReplacementShops"] = 51] = "AutomotiveGlassReplacementShops";
    NAICS[NAICS["AutomotivePartsAndAccessoriesStores"] = 52] = "AutomotivePartsAndAccessoriesStores";
    NAICS[NAICS["BeefCattleRanchingAndFarming"] = 53] = "BeefCattleRanchingAndFarming";
    NAICS[NAICS["BeerWineAndLiquorStores"] = 54] = "BeerWineAndLiquorStores";
    NAICS[NAICS["BoltNutScrewRivetAndWasherManufacturing"] = 55] = "BoltNutScrewRivetAndWasherManufacturing";
    NAICS[NAICS["BookPublishers"] = 56] = "BookPublishers";
    NAICS[NAICS["BookStores"] = 57] = "BookStores";
    NAICS[NAICS["BottledWaterManufacturing"] = 58] = "BottledWaterManufacturing";
    NAICS[NAICS["TextileAndFabricFinishingMills"] = 59] = "TextileAndFabricFinishingMills";
    NAICS[NAICS["BroadWovenFabricMills"] = 60] = "BroadWovenFabricMills";
    NAICS[NAICS["BroomBrushAndMopManufacturing"] = 61] = "BroomBrushAndMopManufacturing";
    NAICS[NAICS["BusinessAssociations"] = 62] = "BusinessAssociations";
    NAICS[NAICS["BusinessToBusinessElectronicMarkets"] = 63] = "BusinessToBusinessElectronicMarkets";
    NAICS[NAICS["InorganicChemicalManufacturing"] = 64] = "InorganicChemicalManufacturing";
    NAICS[NAICS["CemeteriesAndCrematories"] = 66] = "CemeteriesAndCrematories";
    NAICS[NAICS["CharterBusIndustry"] = 67] = "CharterBusIndustry";
    NAICS[NAICS["ChildrenAndInfantsClothingStores"] = 68] = "ChildrenAndInfantsClothingStores";
    NAICS[NAICS["CivicAndSocialOrganizations"] = 69] = "CivicAndSocialOrganizations";
    NAICS[NAICS["ClayAndCeramicAndRefractoryMineralsMining"] = 70] = "ClayAndCeramicAndRefractoryMineralsMining";
    NAICS[NAICS["ClothingAccessoriesStores"] = 71] = "ClothingAccessoriesStores";
    NAICS[NAICS["CoastalAndGreatLakesFreightTransportation"] = 72] = "CoastalAndGreatLakesFreightTransportation";
    NAICS[NAICS["CoastalAndGreatLakesPassengerTransportation"] = 73] = "CoastalAndGreatLakesPassengerTransportation";
    NAICS[NAICS["CoffeeAndTeaManufacturing"] = 75] = "CoffeeAndTeaManufacturing";
    NAICS[NAICS["CollectionAgencies"] = 76] = "CollectionAgencies";
    NAICS[NAICS["CommercialAirRailAndWaterTransportationEquipmentRentalAndLeasing"] = 77] = "CommercialAirRailAndWaterTransportationEquipmentRentalAndLeasing";
    NAICS[NAICS["CommercialAndIndustrialMachineryAndEquipmentRepairAndMaintenance"] = 78] = "CommercialAndIndustrialMachineryAndEquipmentRepairAndMaintenance";
    NAICS[NAICS["CommercialAndInstitutionalBuildingConstruction"] = 79] = "CommercialAndInstitutionalBuildingConstruction";
    NAICS[NAICS["CommercialBakeries"] = 80] = "CommercialBakeries";
    NAICS[NAICS["CommercialBanking"] = 81] = "CommercialBanking";
    NAICS[NAICS["CommercialPhotography"] = 85] = "CommercialPhotography";
    NAICS[NAICS["CommercialScreenPrinting"] = 86] = "CommercialScreenPrinting";
    NAICS[NAICS["CommodityContractsDealing"] = 87] = "CommodityContractsDealing";
    NAICS[NAICS["CommunicationEquipmentRepairAndMaintenance"] = 88] = "CommunicationEquipmentRepairAndMaintenance";
    NAICS[NAICS["ComputerAndOfficeMachineRepairAndMaintenance"] = 89] = "ComputerAndOfficeMachineRepairAndMaintenance";
    NAICS[NAICS["ComputerSystemsDesignServices"] = 91] = "ComputerSystemsDesignServices";
    NAICS[NAICS["ConcreteBlockAndBrickManufacturing"] = 92] = "ConcreteBlockAndBrickManufacturing";
    NAICS[NAICS["ConfectioneryAndNutStores"] = 93] = "ConfectioneryAndNutStores";
    NAICS[NAICS["ConfectioneryManufacturingFromPurchasedChocolate"] = 94] = "ConfectioneryManufacturingFromPurchasedChocolate";
    NAICS[NAICS["ConstructionMiningAndForestryMachineryAndEquipmentRentalAndLeasing"] = 95] = "ConstructionMiningAndForestryMachineryAndEquipmentRentalAndLeasing";
    NAICS[NAICS["ConsumerElectronicsRepairAndMaintenance"] = 96] = "ConsumerElectronicsRepairAndMaintenance";
    NAICS[NAICS["ContinuingCareRetirementCommunities"] = 97] = "ContinuingCareRetirementCommunities";
    NAICS[NAICS["ConveyorAndConveyingEquipmentManufacturing"] = 98] = "ConveyorAndConveyingEquipmentManufacturing";
    NAICS[NAICS["CornFarming"] = 100] = "CornFarming";
    NAICS[NAICS["CorrugatedAndSolidFiberBoxManufacturing"] = 101] = "CorrugatedAndSolidFiberBoxManufacturing";
    NAICS[NAICS["CosmeticsBeautySuppliesAndPerfumeStores"] = 102] = "CosmeticsBeautySuppliesAndPerfumeStores";
    NAICS[NAICS["CosmetologyAndBarberSchools"] = 103] = "CosmetologyAndBarberSchools";
    NAICS[NAICS["CouriersAndExpressDeliveryServices"] = 105] = "CouriersAndExpressDeliveryServices";
    NAICS[NAICS["CreditCardIssuing"] = 106] = "CreditCardIssuing";
    NAICS[NAICS["CreditUnions"] = 107] = "CreditUnions";
    NAICS[NAICS["CutStockResawingLumberAndPlaning"] = 109] = "CutStockResawingLumberAndPlaning";
    NAICS[NAICS["DataProcessingHostingAndRelatedServices"] = 112] = "DataProcessingHostingAndRelatedServices";
    NAICS[NAICS["StationeryProductManufacturing"] = 113] = "StationeryProductManufacturing";
    NAICS[NAICS["DirectHealthAndMedicalInsuranceCarriers"] = 114] = "DirectHealthAndMedicalInsuranceCarriers";
    NAICS[NAICS["DirectLifeInsuranceCarriers"] = 115] = "DirectLifeInsuranceCarriers";
    NAICS[NAICS["DirectPropertyAndCasualtyInsuranceCarriers"] = 116] = "DirectPropertyAndCasualtyInsuranceCarriers";
    NAICS[NAICS["DirectoryAndMailingListPublishers"] = 117] = "DirectoryAndMailingListPublishers";
    NAICS[NAICS["OutdoorAdvertising"] = 118] = "OutdoorAdvertising";
    NAICS[NAICS["DocumentPreparationServices"] = 119] = "DocumentPreparationServices";
    NAICS[NAICS["DriedAndDehydratedFoodManufacturing"] = 120] = "DriedAndDehydratedFoodManufacturing";
    NAICS[NAICS["DryCondensedAndEvaporatedDairyProductManufacturing"] = 122] = "DryCondensedAndEvaporatedDairyProductManufacturing";
    NAICS[NAICS["DryCleaningAndLaundryServices"] = 123] = "DryCleaningAndLaundryServices";
    NAICS[NAICS["DrywallAndInsulationContractors"] = 124] = "DrywallAndInsulationContractors";
    NAICS[NAICS["EducationalSupportServices"] = 125] = "EducationalSupportServices";
    NAICS[NAICS["ElectricBulkPowerTransmissionAndControl"] = 126] = "ElectricBulkPowerTransmissionAndControl";
    NAICS[NAICS["ElectricPowerDistribution"] = 128] = "ElectricPowerDistribution";
    NAICS[NAICS["ElectricalContractorsAndWiringInstallationContractors"] = 129] = "ElectricalContractorsAndWiringInstallationContractors";
    NAICS[NAICS["ElectromedicalAndElectrotherapeuticApparatusManufacturing"] = 130] = "ElectromedicalAndElectrotherapeuticApparatusManufacturing";
    NAICS[NAICS["ElectroplatingPlatingPolishingAnodizingAndColoring"] = 131] = "ElectroplatingPlatingPolishingAnodizingAndColoring";
    NAICS[NAICS["EmploymentPlacementAgencies"] = 132] = "EmploymentPlacementAgencies";
    NAICS[NAICS["EngineeringServices"] = 133] = "EngineeringServices";
    NAICS[NAICS["EnvironmentConservationAndWildlifeOrganizations"] = 134] = "EnvironmentConservationAndWildlifeOrganizations";
    NAICS[NAICS["ExterminatingAndPestControlServices"] = 135] = "ExterminatingAndPestControlServices";
    NAICS[NAICS["FabricCoatingMills"] = 136] = "FabricCoatingMills";
    NAICS[NAICS["FabricatedStructuralMetalManufacturing"] = 137] = "FabricatedStructuralMetalManufacturing";
    NAICS[NAICS["FamilyPlanningCenters"] = 138] = "FamilyPlanningCenters";
    NAICS[NAICS["FarmMachineryAndEquipmentManufacturing"] = 139] = "FarmMachineryAndEquipmentManufacturing";
    NAICS[NAICS["FastenerButtonNeedleAndPinManufacturing"] = 140] = "FastenerButtonNeedleAndPinManufacturing";
    NAICS[NAICS["FatsAndOilsRefiningAndBlending"] = 141] = "FatsAndOilsRefiningAndBlending";
    NAICS[NAICS["FinancialTransactionsProcessingReserveAndClearinghouseActivities"] = 142] = "FinancialTransactionsProcessingReserveAndClearinghouseActivities";
    NAICS[NAICS["FineArtsSchools"] = 143] = "FineArtsSchools";
    NAICS[NAICS["FinFishFarmingAndFishHatcheries"] = 144] = "FinFishFarmingAndFishHatcheries";
    NAICS[NAICS["FinishCarpentryContractors"] = 145] = "FinishCarpentryContractors";
    NAICS[NAICS["FishAndSeafoodMarkets"] = 146] = "FishAndSeafoodMarkets";
    NAICS[NAICS["FitnessAndRecreationalSportsCenters"] = 147] = "FitnessAndRecreationalSportsCenters";
    NAICS[NAICS["FlightTraining"] = 148] = "FlightTraining";
    NAICS[NAICS["FloorCoveringStores"] = 149] = "FloorCoveringStores";
    NAICS[NAICS["FlourMilling"] = 150] = "FlourMilling";
    NAICS[NAICS["FluidMilkManufacturing"] = 151] = "FluidMilkManufacturing";
    NAICS[NAICS["FluidPowerValveAndHoseFittingManufacturing"] = 152] = "FluidPowerValveAndHoseFittingManufacturing";
    NAICS[NAICS["FoodHealthSupplementStores"] = 153] = "FoodHealthSupplementStores";
    NAICS[NAICS["FoodServiceContractors"] = 154] = "FoodServiceContractors";
    NAICS[NAICS["FootwearAndLeatherGoodsRepair"] = 155] = "FootwearAndLeatherGoodsRepair";
    NAICS[NAICS["FootwearMerchantWholesalers"] = 156] = "FootwearMerchantWholesalers";
    NAICS[NAICS["FormalWearAndCostumeRental"] = 157] = "FormalWearAndCostumeRental";
    NAICS[NAICS["FossilFuelElectricPowerGeneration"] = 158] = "FossilFuelElectricPowerGeneration";
    NAICS[NAICS["FruitAndVegetableCanning"] = 160] = "FruitAndVegetableCanning";
    NAICS[NAICS["FruitAndVegetableMarkets"] = 161] = "FruitAndVegetableMarkets";
    NAICS[NAICS["FurnitureStores"] = 163] = "FurnitureStores";
    NAICS[NAICS["GasolineStationsWithConvenienceStores"] = 165] = "GasolineStationsWithConvenienceStores";
    NAICS[NAICS["GeneralWarehousingAndStorage"] = 166] = "GeneralWarehousingAndStorage";
    NAICS[NAICS["GeneralFreightTruckingLocal"] = 167] = "GeneralFreightTruckingLocal";
    NAICS[NAICS["GeneralMedicalAndSurgicalHospitals"] = 168] = "GeneralMedicalAndSurgicalHospitals";
    NAICS[NAICS["GeophysicalSurveyingAndMappingServices"] = 169] = "GeophysicalSurveyingAndMappingServices";
    NAICS[NAICS["GiftNoveltyAndSouvenirStores"] = 170] = "GiftNoveltyAndSouvenirStores";
    NAICS[NAICS["GlassAndGlazingContractors"] = 171] = "GlassAndGlazingContractors";
    NAICS[NAICS["GolfCoursesAndCountryClubs"] = 173] = "GolfCoursesAndCountryClubs";
    NAICS[NAICS["GraphicDesignServices"] = 174] = "GraphicDesignServices";
    NAICS[NAICS["GypsumProductManufacturing"] = 175] = "GypsumProductManufacturing";
    NAICS[NAICS["HardwareManufacturing"] = 177] = "HardwareManufacturing";
    NAICS[NAICS["HardwareStores"] = 178] = "HardwareStores";
    NAICS[NAICS["HeatingEquipmentManufacturing"] = 179] = "HeatingEquipmentManufacturing";
    NAICS[NAICS["HighwayStreetAndBridgeConstruction"] = 181] = "HighwayStreetAndBridgeConstruction";
    NAICS[NAICS["HobbyToyAndGameStores"] = 182] = "HobbyToyAndGameStores";
    NAICS[NAICS["HomeCenters"] = 183] = "HomeCenters";
    NAICS[NAICS["HotelsAndMotels"] = 184] = "HotelsAndMotels";
    NAICS[NAICS["HouseholdApplianceStores"] = 185] = "HouseholdApplianceStores";
    NAICS[NAICS["HouseholdFurnitureManufacturing"] = 186] = "HouseholdFurnitureManufacturing";
    NAICS[NAICS["SmallElectricalApplianceManufacturing"] = 187] = "SmallElectricalApplianceManufacturing";
    NAICS[NAICS["HumanResourcesConsultingServices"] = 188] = "HumanResourcesConsultingServices";
    NAICS[NAICS["HydroelectricPowerGeneration"] = 189] = "HydroelectricPowerGeneration";
    NAICS[NAICS["IndependentArtistsWritersAndPerFormers"] = 190] = "IndependentArtistsWritersAndPerFormers";
    NAICS[NAICS["IndustrialBuildingConstruction"] = 191] = "IndustrialBuildingConstruction";
    NAICS[NAICS["IndustrialGasManufacturing"] = 192] = "IndustrialGasManufacturing";
    NAICS[NAICS["IndustrialMachineryAndEquipmentMerchantWholesalers"] = 193] = "IndustrialMachineryAndEquipmentMerchantWholesalers";
    NAICS[NAICS["IndustrialTruckTractorTrailerAndStackerMachineryManufacturing"] = 194] = "IndustrialTruckTractorTrailerAndStackerMachineryManufacturing";
    NAICS[NAICS["CutAndSewApparelManufacturing"] = 195] = "CutAndSewApparelManufacturing";
    NAICS[NAICS["InlAndWaterFreightTransportation"] = 196] = "InlAndWaterFreightTransportation";
    NAICS[NAICS["InlAndWaterPassengerTransportation"] = 197] = "InlAndWaterPassengerTransportation";
    NAICS[NAICS["InstitutionalFurnitureManufacturing"] = 199] = "InstitutionalFurnitureManufacturing";
    NAICS[NAICS["InternationalTradeFinancing"] = 200] = "InternationalTradeFinancing";
    NAICS[NAICS["IronFoundries"] = 203] = "IronFoundries";
    NAICS[NAICS["IrradiationApparatusManufacturing"] = 204] = "IrradiationApparatusManufacturing";
    NAICS[NAICS["JanitorialServices"] = 205] = "JanitorialServices";
    NAICS[NAICS["JewelryStores"] = 207] = "JewelryStores";
    NAICS[NAICS["KaolinAndBallClayMining"] = 208] = "KaolinAndBallClayMining";
    NAICS[NAICS["MetalKitchenCookwareUtensilCutleryAndFlatwareManufacturing"] = 209] = "MetalKitchenCookwareUtensilCutleryAndFlatwareManufacturing";
    NAICS[NAICS["SurgicalApplianceAndSuppliesManufacturing"] = 210] = "SurgicalApplianceAndSuppliesManufacturing";
    NAICS[NAICS["LandscapeArchitecturalServices"] = 211] = "LandscapeArchitecturalServices";
    NAICS[NAICS["LandscapingServices"] = 212] = "LandscapingServices";
    NAICS[NAICS["OfficeSuppliesManufacturing"] = 213] = "OfficeSuppliesManufacturing";
    NAICS[NAICS["LeatherAndHideTanningAndFinishing"] = 214] = "LeatherAndHideTanningAndFinishing";
    NAICS[NAICS["LessorsOfNonFinancialIntangibleAssets"] = 215] = "LessorsOfNonFinancialIntangibleAssets";
    NAICS[NAICS["LessorsOfRealEstateProperty"] = 216] = "LessorsOfRealEstateProperty";
    NAICS[NAICS["LessorsOfResidentialBuildingsAndDwellings"] = 217] = "LessorsOfResidentialBuildingsAndDwellings";
    NAICS[NAICS["LibrariesAndArchives"] = 218] = "LibrariesAndArchives";
    NAICS[NAICS["LinenSupply"] = 219] = "LinenSupply";
    NAICS[NAICS["FuelDealers"] = 220] = "FuelDealers";
    NAICS[NAICS["LumberPlywoodMillworkAndWoodPanelMerchantWholesalers"] = 221] = "LumberPlywoodMillworkAndWoodPanelMerchantWholesalers";
    NAICS[NAICS["BlankMagneticAndOpticalRecordingMediaManufacturing"] = 222] = "BlankMagneticAndOpticalRecordingMediaManufacturing";
    NAICS[NAICS["MasonryContractors"] = 224] = "MasonryContractors";
    NAICS[NAICS["MayonnaiseDressingAndPreparedSauceManufacturing"] = 225] = "MayonnaiseDressingAndPreparedSauceManufacturing";
    NAICS[NAICS["MeatMarkets"] = 226] = "MeatMarkets";
    NAICS[NAICS["MeatProcessedFromCarcasses"] = 227] = "MeatProcessedFromCarcasses";
    NAICS[NAICS["MensAndBoysCutAndSewApparelManufacturing"] = 230] = "MensAndBoysCutAndSewApparelManufacturing";
    NAICS[NAICS["MensClothingStores"] = 231] = "MensClothingStores";
    NAICS[NAICS["MetalCoatingEngravingAndAlliedServicesToManufacturers"] = 235] = "MetalCoatingEngravingAndAlliedServicesToManufacturers";
    NAICS[NAICS["MetalWindowAndDoorManufacturing"] = 236] = "MetalWindowAndDoorManufacturing";
    NAICS[NAICS["MilitaryArmoredVehicleTankAndTankComponentManufacturing"] = 237] = "MilitaryArmoredVehicleTankAndTankComponentManufacturing";
    NAICS[NAICS["MiscellaneousFinancialInvestmentActivities"] = 238] = "MiscellaneousFinancialInvestmentActivities";
    NAICS[NAICS["MiscellaneousIntermediation"] = 239] = "MiscellaneousIntermediation";
    NAICS[NAICS["MotionPictureAndVideoDistribution"] = 240] = "MotionPictureAndVideoDistribution";
    NAICS[NAICS["MotorAndGeneratorManufacturing"] = 241] = "MotorAndGeneratorManufacturing";
    NAICS[NAICS["MotorVehicleBodyManufacturing"] = 242] = "MotorVehicleBodyManufacturing";
    NAICS[NAICS["MotorVehicleBrakeSystemManufacturing"] = 243] = "MotorVehicleBrakeSystemManufacturing";
    NAICS[NAICS["MotorVehicleSeatingAndInteriorTrimManufacturing"] = 244] = "MotorVehicleSeatingAndInteriorTrimManufacturing";
    NAICS[NAICS["MotorVehicleTransmissionAndPowerTrainPartsManufacturing"] = 245] = "MotorVehicleTransmissionAndPowerTrainPartsManufacturing";
    NAICS[NAICS["MotorcycleBicycleAndPartsManufacturing"] = 246] = "MotorcycleBicycleAndPartsManufacturing";
    NAICS[NAICS["MusicPublishers"] = 247] = "MusicPublishers";
    NAICS[NAICS["NaturalGasDistribution"] = 249] = "NaturalGasDistribution";
    NAICS[NAICS["NaturalGasExtraction"] = 250] = "NaturalGasExtraction";
    NAICS[NAICS["NatureParksAndSimilarInstitutions"] = 251] = "NatureParksAndSimilarInstitutions";
    NAICS[NAICS["NavigationalServicesToShipping"] = 252] = "NavigationalServicesToShipping";
    NAICS[NAICS["NewMultifamilyHousingConstruction"] = 253] = "NewMultifamilyHousingConstruction";
    NAICS[NAICS["NewSingleFamilyHousingConstruction"] = 254] = "NewSingleFamilyHousingConstruction";
    NAICS[NAICS["NewsprintMills"] = 255] = "NewsprintMills";
    NAICS[NAICS["NonChocolateConfectioneryManufacturing"] = 256] = "NonChocolateConfectioneryManufacturing";
    NAICS[NAICS["NonferrousMetalRollingDrawingAndExtruding"] = 257] = "NonferrousMetalRollingDrawingAndExtruding";
    NAICS[NAICS["NonWovenFabricMills"] = 259] = "NonWovenFabricMills";
    NAICS[NAICS["NuclearElectricPowerGeneration"] = 260] = "NuclearElectricPowerGeneration";
    NAICS[NAICS["NurseryGardenCenterAndFarmSupplyStores"] = 261] = "NurseryGardenCenterAndFarmSupplyStores";
    NAICS[NAICS["NurseryAndTreeProduction"] = 262] = "NurseryAndTreeProduction";
    NAICS[NAICS["SkilledNursingCareFacilities"] = 263] = "SkilledNursingCareFacilities";
    NAICS[NAICS["OfficeMachineryAndEquipmentRentalAndLeasing"] = 264] = "OfficeMachineryAndEquipmentRentalAndLeasing";
    NAICS[NAICS["OfficeSuppliesAndStationeryStores"] = 266] = "OfficeSuppliesAndStationeryStores";
    NAICS[NAICS["OfficesOfMiscellaneousHealthPractitioners"] = 267] = "OfficesOfMiscellaneousHealthPractitioners";
    NAICS[NAICS["OfficesOfPhysicians"] = 268] = "OfficesOfPhysicians";
    NAICS[NAICS["OfficesOfPhysiciansMentalHealthSpecialists"] = 269] = "OfficesOfPhysiciansMentalHealthSpecialists";
    NAICS[NAICS["OilAndGasPipelineAndRelatedStructuresConstruction"] = 270] = "OilAndGasPipelineAndRelatedStructuresConstruction";
    NAICS[NAICS["OphthalmicGoodsManufacturing"] = 271] = "OphthalmicGoodsManufacturing";
    NAICS[NAICS["OrnamentalAndArchitecturalMetalWorkManufacturing"] = 272] = "OrnamentalAndArchitecturalMetalWorkManufacturing";
    NAICS[NAICS["MotionPictureAndVideoIndustries"] = 273] = "MotionPictureAndVideoIndustries";
    NAICS[NAICS["ActivitiesRelatedToCreditIntermediation"] = 274] = "ActivitiesRelatedToCreditIntermediation";
    NAICS[NAICS["AirportOperations"] = 275] = "AirportOperations";
    NAICS[NAICS["AluminumRollingDrawingAndExtruding"] = 276] = "AluminumRollingDrawingAndExtruding";
    NAICS[NAICS["Aquaculture"] = 277] = "Aquaculture";
    NAICS[NAICS["AnimalFoodManufacturing"] = 278] = "AnimalFoodManufacturing";
    NAICS[NAICS["BuildingEquipmentContractors"] = 280] = "BuildingEquipmentContractors";
    NAICS[NAICS["BuildingFinishingContractors"] = 281] = "BuildingFinishingContractors";
    NAICS[NAICS["BuildingMaterialDealers"] = 282] = "BuildingMaterialDealers";
    NAICS[NAICS["BusinessServiceCentersAndCopyShops"] = 283] = "BusinessServiceCentersAndCopyShops";
    NAICS[NAICS["ChemicalAndFertilizerMineralMining"] = 284] = "ChemicalAndFertilizerMineralMining";
    NAICS[NAICS["ClothingStores"] = 285] = "ClothingStores";
    NAICS[NAICS["CommercialAndIndustrialMachineryAndEquipmentRentalAndLeasing"] = 286] = "CommercialAndIndustrialMachineryAndEquipmentRentalAndLeasing";
    NAICS[NAICS["DirectInsuranceExceptLifeHealthAndMedicalCarriers"] = 291] = "DirectInsuranceExceptLifeHealthAndMedicalCarriers";
    NAICS[NAICS["DirectSellingEstablishments"] = 292] = "DirectSellingEstablishments";
    NAICS[NAICS["ElectricPowerGeneration"] = 293] = "ElectricPowerGeneration";
    NAICS[NAICS["ElectronicAndPrecisionEquipmentRepairAndMaintenance"] = 294] = "ElectronicAndPrecisionEquipmentRepairAndMaintenance";
    NAICS[NAICS["EngineEquipmentManufacturing"] = 295] = "EngineEquipmentManufacturing";
    NAICS[NAICS["FabricatedWireProductManufacturing"] = 296] = "FabricatedWireProductManufacturing";
    NAICS[NAICS["FinancialVehicles"] = 297] = "FinancialVehicles";
    NAICS[NAICS["FoundationStructureAndBuildingExteriorContractors"] = 298] = "FoundationStructureAndBuildingExteriorContractors";
    NAICS[NAICS["GamblingIndustries"] = 299] = "GamblingIndustries";
    NAICS[NAICS["CivilEngineeringConstruction"] = 300] = "CivilEngineeringConstruction";
    NAICS[NAICS["CurtainAndLinenMills"] = 301] = "CurtainAndLinenMills";
    NAICS[NAICS["InsuranceFunds"] = 302] = "InsuranceFunds";
    NAICS[NAICS["KnitFabricMills"] = 303] = "KnitFabricMills";
    NAICS[NAICS["LightingEquipmentManufacturing"] = 304] = "LightingEquipmentManufacturing";
    NAICS[NAICS["MetalContainerManufacturing"] = 306] = "MetalContainerManufacturing";
    NAICS[NAICS["MetalValveAndPipeFittingManufacturing"] = 307] = "MetalValveAndPipeFittingManufacturing";
    NAICS[NAICS["MillworkAndFlooring"] = 308] = "MillworkAndFlooring";
    NAICS[NAICS["DurableGoodsMerchantWholesalers"] = 309] = "DurableGoodsMerchantWholesalers";
    NAICS[NAICS["NonCitrusFruitFarming"] = 311] = "NonCitrusFruitFarming";
    NAICS[NAICS["NonscheduledAirTransportation"] = 312] = "NonscheduledAirTransportation";
    NAICS[NAICS["PerFormingArtsCompanies"] = 314] = "PerFormingArtsCompanies";
    NAICS[NAICS["PersonalAndHouseholdGoodsRepairAndMaintenance"] = 315] = "PersonalAndHouseholdGoodsRepairAndMaintenance";
    NAICS[NAICS["ScientificAndTechnicalConsultingServices"] = 316] = "ScientificAndTechnicalConsultingServices";
    NAICS[NAICS["ServicesRelatedToAdvertising"] = 317] = "ServicesRelatedToAdvertising";
    NAICS[NAICS["ServicesToBuildingsAndDwellings"] = 318] = "ServicesToBuildingsAndDwellings";
    NAICS[NAICS["MiscellaneousOrganizations"] = 319] = "MiscellaneousOrganizations";
    NAICS[NAICS["SnackFoodManufacturing"] = 320] = "SnackFoodManufacturing";
    NAICS[NAICS["SocialAdvocacyOrganizations"] = 321] = "SocialAdvocacyOrganizations";
    NAICS[NAICS["SoundRecordingIndustries"] = 322] = "SoundRecordingIndustries";
    NAICS[NAICS["SpectatorSports"] = 323] = "SpectatorSports";
    NAICS[NAICS["SupportActivitiesForRoadTransportation"] = 324] = "SupportActivitiesForRoadTransportation";
    NAICS[NAICS["SupportActivitiesForWaterTransportation"] = 325] = "SupportActivitiesForWaterTransportation";
    NAICS[NAICS["TechnicalAndTradeSchools"] = 326] = "TechnicalAndTradeSchools";
    NAICS[NAICS["VegetableAndMelonFarming"] = 328] = "VegetableAndMelonFarming";
    NAICS[NAICS["OutdoorPowerEquipmentStores"] = 329] = "OutdoorPowerEquipmentStores";
    NAICS[NAICS["OverheadTravelingCraneHoistAndMonorailSystemManufacturing"] = 331] = "OverheadTravelingCraneHoistAndMonorailSystemManufacturing";
    NAICS[NAICS["PaintAndCoatingManufacturing"] = 332] = "PaintAndCoatingManufacturing";
    NAICS[NAICS["PaintingAndWallCoveringContractors"] = 333] = "PaintingAndWallCoveringContractors";
    NAICS[NAICS["PaperMills"] = 334] = "PaperMills";
    NAICS[NAICS["PaperboardMills"] = 335] = "PaperboardMills";
    NAICS[NAICS["ParkingLotsAndGarages"] = 336] = "ParkingLotsAndGarages";
    NAICS[NAICS["PayrollServices"] = 337] = "PayrollServices";
    NAICS[NAICS["PeriodicalPublishers"] = 338] = "PeriodicalPublishers";
    NAICS[NAICS["PetAndPetSuppliesStores"] = 339] = "PetAndPetSuppliesStores";
    NAICS[NAICS["PetrochemicalManufacturing"] = 340] = "PetrochemicalManufacturing";
    NAICS[NAICS["PharmaceuticalPreparationManufacturing"] = 341] = "PharmaceuticalPreparationManufacturing";
    NAICS[NAICS["PharmaciesAndDrugStores"] = 342] = "PharmaciesAndDrugStores";
    NAICS[NAICS["PieceGoodsNotionsAndOtherDryGoodsMerchantWholesalers"] = 343] = "PieceGoodsNotionsAndOtherDryGoodsMerchantWholesalers";
    NAICS[NAICS["PipelineTransportationOfNaturalGas"] = 344] = "PipelineTransportationOfNaturalGas";
    NAICS[NAICS["PlasticsMaterialsAndBasicFormsAndShapesMerchantWholesalers"] = 345] = "PlasticsMaterialsAndBasicFormsAndShapesMerchantWholesalers";
    NAICS[NAICS["PlasticsPipeAndPipeFittingManufacturing"] = 346] = "PlasticsPipeAndPipeFittingManufacturing";
    NAICS[NAICS["PlumbingHeatingAndAirConditioningContractors"] = 347] = "PlumbingHeatingAndAirConditioningContractors";
    NAICS[NAICS["PortAndHarborOperations"] = 348] = "PortAndHarborOperations";
    NAICS[NAICS["PortfolioManagement"] = 349] = "PortfolioManagement";
    NAICS[NAICS["PostalService"] = 350] = "PostalService";
    NAICS[NAICS["PowerAndCommunicationLineAndRelatedStructuresConstruction"] = 351] = "PowerAndCommunicationLineAndRelatedStructuresConstruction";
    NAICS[NAICS["PowerBoilerAndHeatExchangerManufacturing"] = 352] = "PowerBoilerAndHeatExchangerManufacturing";
    NAICS[NAICS["PowerDistributionAndSpecialtyTransFormerManufacturing"] = 353] = "PowerDistributionAndSpecialtyTransFormerManufacturing";
    NAICS[NAICS["SupportActivitiesForPrinting"] = 354] = "SupportActivitiesForPrinting";
    NAICS[NAICS["SoftwareAndOtherPrerecordedCompactDiscTapeAndRecordReproducing"] = 355] = "SoftwareAndOtherPrerecordedCompactDiscTapeAndRecordReproducing";
    NAICS[NAICS["PrintedCircuitAssemblyManufacturing"] = 357] = "PrintedCircuitAssemblyManufacturing";
    NAICS[NAICS["ProcessAndLogisticsConsultingServices"] = 358] = "ProcessAndLogisticsConsultingServices";
    NAICS[NAICS["PromotersOfPerFormingArtsSportsAndSimilarEventsWithFacilities"] = 359] = "PromotersOfPerFormingArtsSportsAndSimilarEventsWithFacilities";
    NAICS[NAICS["PromotersOfPerFormingArtsSportsAndSimilarEventsWithoutFacilities"] = 360] = "PromotersOfPerFormingArtsSportsAndSimilarEventsWithoutFacilities";
    NAICS[NAICS["PsychiatricAndSubstanceAbuseHospitals"] = 361] = "PsychiatricAndSubstanceAbuseHospitals";
    NAICS[NAICS["RadioAndTelevisionBroadcastingAndWirelessCommunicationsEquipmentManufacturing"] = 364] = "RadioAndTelevisionBroadcastingAndWirelessCommunicationsEquipmentManufacturing";
    NAICS[NAICS["RailroadRollingStockManufacturing"] = 366] = "RailroadRollingStockManufacturing";
    NAICS[NAICS["RealEstateCredit"] = 367] = "RealEstateCredit";
    NAICS[NAICS["RefrigeratedWarehousingAndStorage"] = 368] = "RefrigeratedWarehousingAndStorage";
    NAICS[NAICS["ReinsuranceCarriers"] = 369] = "ReinsuranceCarriers";
    NAICS[NAICS["RemediationServices"] = 370] = "RemediationServices";
    NAICS[NAICS["RenderingAndMeatByproductProcessing"] = 371] = "RenderingAndMeatByproductProcessing";
    NAICS[NAICS["ResearchAndDevelopmentInThePhysicalEngineeringAndLifeSciences"] = 372] = "ResearchAndDevelopmentInThePhysicalEngineeringAndLifeSciences";
    NAICS[NAICS["ResearchAndDevelopmentInTheSocialSciencesAndHumanities"] = 373] = "ResearchAndDevelopmentInTheSocialSciencesAndHumanities";
    NAICS[NAICS["ResidentialElectricLightingFixtureManufacturing"] = 374] = "ResidentialElectricLightingFixtureManufacturing";
    NAICS[NAICS["ResidentialIntellectualAndDevelopmentalDisabilityFacilities"] = 375] = "ResidentialIntellectualAndDevelopmentalDisabilityFacilities";
    NAICS[NAICS["ResidentialRemodelers"] = 376] = "ResidentialRemodelers";
    NAICS[NAICS["PlasticsProductManufacturing"] = 377] = "PlasticsProductManufacturing";
    NAICS[NAICS["ReupholsteryAndFurnitureRepair"] = 378] = "ReupholsteryAndFurnitureRepair";
    NAICS[NAICS["RiceMilling"] = 379] = "RiceMilling";
    NAICS[NAICS["RoastedNutsAndPeanutButterManufacturing"] = 380] = "RoastedNutsAndPeanutButterManufacturing";
    NAICS[NAICS["RolledSteelShapeManufacturing"] = 381] = "RolledSteelShapeManufacturing";
    NAICS[NAICS["RoomingAndBoardingHousesDormitoriesAndWorkersCamps"] = 382] = "RoomingAndBoardingHousesDormitoriesAndWorkersCamps";
    NAICS[NAICS["SalesFinancing"] = 383] = "SalesFinancing";
    NAICS[NAICS["SanitaryPaperProductManufacturing"] = 384] = "SanitaryPaperProductManufacturing";
    NAICS[NAICS["SavingsInstitutions"] = 385] = "SavingsInstitutions";
    NAICS[NAICS["Sawmills"] = 386] = "Sawmills";
    NAICS[NAICS["ScenicAndSightseeingTransportationLAnd"] = 387] = "ScenicAndSightseeingTransportationLAnd";
    NAICS[NAICS["ScenicAndSightseeingTransportationOther"] = 388] = "ScenicAndSightseeingTransportationOther";
    NAICS[NAICS["ScenicAndSightseeingTransportationWater"] = 389] = "ScenicAndSightseeingTransportationWater";
    NAICS[NAICS["SchoolAndEmployeeBusTransportation"] = 390] = "SchoolAndEmployeeBusTransportation";
    NAICS[NAICS["SeafoodProductPreparationAndPackaging"] = 391] = "SeafoodProductPreparationAndPackaging";
    NAICS[NAICS["SecondaryMarketFinancing"] = 392] = "SecondaryMarketFinancing";
    NAICS[NAICS["SecondarySmeltingRefiningAndAlloyingOfNonferrousMetal"] = 394] = "SecondarySmeltingRefiningAndAlloyingOfNonferrousMetal";
    NAICS[NAICS["SepticTankAndRelatedServices"] = 396] = "SepticTankAndRelatedServices";
    NAICS[NAICS["SewingNeedleworkAndPieceGoodsStores"] = 397] = "SewingNeedleworkAndPieceGoodsStores";
    NAICS[NAICS["HosieryAndSockMills"] = 398] = "HosieryAndSockMills";
    NAICS[NAICS["ShellfishFarming"] = 399] = "ShellfishFarming";
    NAICS[NAICS["ShellfishFishing"] = 400] = "ShellfishFishing";
    NAICS[NAICS["ShoeStores"] = 401] = "ShoeStores";
    NAICS[NAICS["ShowcasePartitionShelvingAndLockerManufacturing"] = 402] = "ShowcasePartitionShelvingAndLockerManufacturing";
    NAICS[NAICS["JewelryAndSilverwareManufacturing"] = 403] = "JewelryAndSilverwareManufacturing";
    NAICS[NAICS["SitePreparationContractors"] = 404] = "SitePreparationContractors";
    NAICS[NAICS["SnackAndNonalcoholicBeverageBars"] = 406] = "SnackAndNonalcoholicBeverageBars";
    NAICS[NAICS["SoapAndDetergentManufacturing"] = 407] = "SoapAndDetergentManufacturing";
    NAICS[NAICS["SoilPreparationPlantingAndCultivating"] = 408] = "SoilPreparationPlantingAndCultivating";
    NAICS[NAICS["SoybeanAndOilseedProcessing"] = 409] = "SoybeanAndOilseedProcessing";
    NAICS[NAICS["SpecializedFreightTruckingLocal"] = 410] = "SpecializedFreightTruckingLocal";
    NAICS[NAICS["SpiceAndExtractManufacturing"] = 411] = "SpiceAndExtractManufacturing";
    NAICS[NAICS["SportingAndAthleticGoodsManufacturing"] = 412] = "SportingAndAthleticGoodsManufacturing";
    NAICS[NAICS["SportingAndRecreationalGoodsAndSuppliesMerchantWholesalers"] = 413] = "SportingAndRecreationalGoodsAndSuppliesMerchantWholesalers";
    NAICS[NAICS["SportingGoodsStores"] = 414] = "SportingGoodsStores";
    NAICS[NAICS["SportsAndRecreationInstruction"] = 415] = "SportsAndRecreationInstruction";
    NAICS[NAICS["SupermarketsAndGroceryStores"] = 416] = "SupermarketsAndGroceryStores";
    NAICS[NAICS["SupportActivitiesForAnimalProduction"] = 417] = "SupportActivitiesForAnimalProduction";
    NAICS[NAICS["SupportActivitiesForOilAndGasOperations"] = 418] = "SupportActivitiesForOilAndGasOperations";
    NAICS[NAICS["SupportActivitiesForRailTransportation"] = 419] = "SupportActivitiesForRailTransportation";
    NAICS[NAICS["SurgicalAndMedicalInstrumentManufacturing"] = 420] = "SurgicalAndMedicalInstrumentManufacturing";
    NAICS[NAICS["SurveyingAndMappingServices"] = 422] = "SurveyingAndMappingServices";
    NAICS[NAICS["TaxiService"] = 423] = "TaxiService";
    NAICS[NAICS["TelecommunicationsResellers"] = 424] = "TelecommunicationsResellers";
    NAICS[NAICS["TheaterCompaniesAndDinnerTheaters"] = 427] = "TheaterCompaniesAndDinnerTheaters";
    NAICS[NAICS["ThirdPartyAdministrationOfInsuranceAndPensionFunds"] = 428] = "ThirdPartyAdministrationOfInsuranceAndPensionFunds";
    NAICS[NAICS["TireDealers"] = 430] = "TireDealers";
    NAICS[NAICS["TobaccoStores"] = 431] = "TobaccoStores";
    NAICS[NAICS["TotalizingFluidMeterAndCountingDeviceManufacturing"] = 432] = "TotalizingFluidMeterAndCountingDeviceManufacturing";
    NAICS[NAICS["TravelTrailerAndCamperManufacturing"] = 433] = "TravelTrailerAndCamperManufacturing";
    NAICS[NAICS["TruckUtilityTrailerAndRVRentalAndLeasing"] = 434] = "TruckUtilityTrailerAndRVRentalAndLeasing";
    NAICS[NAICS["TrustFiduciaryAndCustodyActivities"] = 435] = "TrustFiduciaryAndCustodyActivities";
    NAICS[NAICS["ApparelKnittingMills"] = 436] = "ApparelKnittingMills";
    NAICS[NAICS["UnlaminatedPlasticsProfileShapeManufacturing"] = 437] = "UnlaminatedPlasticsProfileShapeManufacturing";
    NAICS[NAICS["UpholsteredHouseholdFurnitureManufacturing"] = 438] = "UpholsteredHouseholdFurnitureManufacturing";
    NAICS[NAICS["UsedHouseholdAndOfficeGoodsMoving"] = 439] = "UsedHouseholdAndOfficeGoodsMoving";
    NAICS[NAICS["VeterinaryServices"] = 440] = "VeterinaryServices";
    NAICS[NAICS["WarehouseClubsAndSuperCenters"] = 442] = "WarehouseClubsAndSuperCenters";
    NAICS[NAICS["MeasuringAndControllingDeviceManufacturing"] = 443] = "MeasuringAndControllingDeviceManufacturing";
    NAICS[NAICS["WaterAndSewerLineAndRelatedStructuresConstruction"] = 444] = "WaterAndSewerLineAndRelatedStructuresConstruction";
    NAICS[NAICS["WaterSupplyAndIrrigationSystems"] = 445] = "WaterSupplyAndIrrigationSystems";
    NAICS[NAICS["WeldingAndSolderingEquipmentManufacturing"] = 447] = "WeldingAndSolderingEquipmentManufacturing";
    NAICS[NAICS["WholesaleTradeAgentsAndBrokers"] = 448] = "WholesaleTradeAgentsAndBrokers";
    NAICS[NAICS["WindowTreatmentStores"] = 449] = "WindowTreatmentStores";
    NAICS[NAICS["Wineries"] = 450] = "Wineries";
    NAICS[NAICS["WomenClothingStores"] = 452] = "WomenClothingStores";
    NAICS[NAICS["WomenGirlsAndInfantsCutAndSewApparelManufacturing"] = 458] = "WomenGirlsAndInfantsCutAndSewApparelManufacturing";
    NAICS[NAICS["WoodContainerAndPalletManufacturing"] = 459] = "WoodContainerAndPalletManufacturing";
    NAICS[NAICS["WoodKitchenCabinetAndCounterTopManufacturing"] = 460] = "WoodKitchenCabinetAndCounterTopManufacturing";
    NAICS[NAICS["WheatFarming"] = 462] = "WheatFarming";
    NAICS[NAICS["RiceFarming"] = 463] = "RiceFarming";
    NAICS[NAICS["SoybeanFarming"] = 464] = "SoybeanFarming";
    NAICS[NAICS["OilseedFarming"] = 465] = "OilseedFarming";
    NAICS[NAICS["DryPeaAndBeanFarming"] = 466] = "DryPeaAndBeanFarming";
    NAICS[NAICS["OilseedAndGrainCombinationFarming"] = 467] = "OilseedAndGrainCombinationFarming";
    NAICS[NAICS["CottonFarming"] = 468] = "CottonFarming";
    NAICS[NAICS["TobaccoFarming"] = 469] = "TobaccoFarming";
    NAICS[NAICS["SugarcaneFarming"] = 470] = "SugarcaneFarming";
    NAICS[NAICS["SugarBeetFarming"] = 471] = "SugarBeetFarming";
    NAICS[NAICS["PotatoFarming"] = 472] = "PotatoFarming";
    NAICS[NAICS["HayFarming"] = 473] = "HayFarming";
    NAICS[NAICS["PeanutFarming"] = 474] = "PeanutFarming";
    NAICS[NAICS["StrawberryFarming"] = 475] = "StrawberryFarming";
    NAICS[NAICS["BerryFarming"] = 476] = "BerryFarming";
    NAICS[NAICS["GrapeVineyards"] = 477] = "GrapeVineyards";
    NAICS[NAICS["TreeNutFarming"] = 478] = "TreeNutFarming";
    NAICS[NAICS["OrangeGroves"] = 479] = "OrangeGroves";
    NAICS[NAICS["CitrusGroves"] = 480] = "CitrusGroves";
    NAICS[NAICS["AppleOrchards"] = 481] = "AppleOrchards";
    NAICS[NAICS["FruitAndTreeNutCombinationFarming"] = 482] = "FruitAndTreeNutCombinationFarming";
    NAICS[NAICS["FloricultureProduction"] = 483] = "FloricultureProduction";
    NAICS[NAICS["MushroomProduction"] = 484] = "MushroomProduction";
    NAICS[NAICS["FoodCropsGrownUnderCover"] = 485] = "FoodCropsGrownUnderCover";
    NAICS[NAICS["CattleFeedlots"] = 486] = "CattleFeedlots";
    NAICS[NAICS["HogAndPigFarming"] = 487] = "HogAndPigFarming";
    NAICS[NAICS["SheepFarming"] = 488] = "SheepFarming";
    NAICS[NAICS["GoatFarming"] = 489] = "GoatFarming";
    NAICS[NAICS["DairyCattleAndMilkProduction"] = 490] = "DairyCattleAndMilkProduction";
    NAICS[NAICS["BroilersAndOtherMeatTypeChickenProduction"] = 491] = "BroilersAndOtherMeatTypeChickenProduction";
    NAICS[NAICS["ChickenEggProduction"] = 492] = "ChickenEggProduction";
    NAICS[NAICS["TurkeyProduction"] = 493] = "TurkeyProduction";
    NAICS[NAICS["PoultryHatcheries"] = 494] = "PoultryHatcheries";
    NAICS[NAICS["PoultryProduction"] = 495] = "PoultryProduction";
    NAICS[NAICS["FurBearingAnimalAndRabbitProduction"] = 496] = "FurBearingAnimalAndRabbitProduction";
    NAICS[NAICS["HorsesAndOtherEquineProduction"] = 497] = "HorsesAndOtherEquineProduction";
    NAICS[NAICS["Apiculture"] = 498] = "Apiculture";
    NAICS[NAICS["CropHarvestingPrimarilyByMachine"] = 499] = "CropHarvestingPrimarilyByMachine";
    NAICS[NAICS["PostharvestCropActivities"] = 500] = "PostharvestCropActivities";
    NAICS[NAICS["CottonGinning"] = 501] = "CottonGinning";
    NAICS[NAICS["NonmedicalPetCareServices"] = 502] = "NonmedicalPetCareServices";
    NAICS[NAICS["FarmLaborContractorsAndCrewLeaders"] = 503] = "FarmLaborContractorsAndCrewLeaders";
    NAICS[NAICS["FarmManagementServices"] = 504] = "FarmManagementServices";
    NAICS[NAICS["TimberTractOperations"] = 505] = "TimberTractOperations";
    NAICS[NAICS["ForestNurseriesAndGatheringOfForestProducts"] = 506] = "ForestNurseriesAndGatheringOfForestProducts";
    NAICS[NAICS["SupportActivitiesForForestry"] = 507] = "SupportActivitiesForForestry";
    NAICS[NAICS["FinfishFishing"] = 508] = "FinfishFishing";
    NAICS[NAICS["MarineFishing"] = 509] = "MarineFishing";
    NAICS[NAICS["HuntingAndTrapping"] = 510] = "HuntingAndTrapping";
    NAICS[NAICS["IronOreMining"] = 511] = "IronOreMining";
    NAICS[NAICS["CopperNickelLeadAndZincMining"] = 512] = "CopperNickelLeadAndZincMining";
    NAICS[NAICS["GoldOreMining"] = 513] = "GoldOreMining";
    NAICS[NAICS["SilverOreMining"] = 514] = "SilverOreMining";
    NAICS[NAICS["SupportActivitiesForMetalMining"] = 515] = "SupportActivitiesForMetalMining";
    NAICS[NAICS["UraniumRadiumVanadiumOreMining"] = 516] = "UraniumRadiumVanadiumOreMining";
    NAICS[NAICS["BituminousCoalAndLigniteSurfaceMining"] = 517] = "BituminousCoalAndLigniteSurfaceMining";
    NAICS[NAICS["BituminousCoalUndergroundMining"] = 518] = "BituminousCoalUndergroundMining";
    NAICS[NAICS["AnthraciteMining"] = 519] = "AnthraciteMining";
    NAICS[NAICS["SupportActivitiesForCoalMining"] = 520] = "SupportActivitiesForCoalMining";
    NAICS[NAICS["CrudePetroleumExtraction"] = 521] = "CrudePetroleumExtraction";
    NAICS[NAICS["DrillingOilAndGasWells"] = 522] = "DrillingOilAndGasWells";
    NAICS[NAICS["DimensionStoneMiningAndQuarrying"] = 523] = "DimensionStoneMiningAndQuarrying";
    NAICS[NAICS["CrushedAndBrokenLimestoneMiningAndQuarrying"] = 524] = "CrushedAndBrokenLimestoneMiningAndQuarrying";
    NAICS[NAICS["CrushedAndBrokenGraniteMiningAndQuarrying"] = 525] = "CrushedAndBrokenGraniteMiningAndQuarrying";
    NAICS[NAICS["ConstructionSAndAndGravelMining"] = 526] = "ConstructionSAndAndGravelMining";
    NAICS[NAICS["IndustrialSAndMining"] = 527] = "IndustrialSAndMining";
    NAICS[NAICS["PotashSodaAndBorateMineralMining"] = 528] = "PotashSodaAndBorateMineralMining";
    NAICS[NAICS["PhosphateRockMining"] = 529] = "PhosphateRockMining";
    NAICS[NAICS["SupportActivitiesForNonmetallicMineralsMining"] = 530] = "SupportActivitiesForNonmetallicMineralsMining";
    NAICS[NAICS["NewHousingForSaleBuilders"] = 531] = "NewHousingForSaleBuilders";
    NAICS[NAICS["TileAndTerrazzoContractors"] = 532] = "TileAndTerrazzoContractors";
    NAICS[NAICS["FramingContractors"] = 533] = "FramingContractors";
    NAICS[NAICS["FlooringContractors"] = 534] = "FlooringContractors";
    NAICS[NAICS["RoofingContractors"] = 535] = "RoofingContractors";
    NAICS[NAICS["SidingContractors"] = 536] = "SidingContractors";
    NAICS[NAICS["PouredConcreteFoundationAndStructureContractors"] = 537] = "PouredConcreteFoundationAndStructureContractors";
    NAICS[NAICS["StructuralSteelAndPrecastConcreteContractors"] = 538] = "StructuralSteelAndPrecastConcreteContractors";
    NAICS[NAICS["PoultryProcessing"] = 539] = "PoultryProcessing";
    NAICS[NAICS["CreameryButterManufacturing"] = 540] = "CreameryButterManufacturing";
    NAICS[NAICS["CheeseManufacturing"] = 541] = "CheeseManufacturing";
    NAICS[NAICS["IceCreamAndFrozenDessertManufacturing"] = 542] = "IceCreamAndFrozenDessertManufacturing";
    NAICS[NAICS["SpecialtyCanning"] = 543] = "SpecialtyCanning";
    NAICS[NAICS["FrozenFruitJuiceAndVegetableManufacturing"] = 544] = "FrozenFruitJuiceAndVegetableManufacturing";
    NAICS[NAICS["FrozenSpecialtyFoodManufacturing"] = 545] = "FrozenSpecialtyFoodManufacturing";
    NAICS[NAICS["BreakfastCerealManufacturing"] = 546] = "BreakfastCerealManufacturing";
    NAICS[NAICS["DryPastaDoughAndFlourMixesManufacturingFromPurchasedFlour"] = 547] = "DryPastaDoughAndFlourMixesManufacturingFromPurchasedFlour";
    NAICS[NAICS["WetCornMilling"] = 548] = "WetCornMilling";
    NAICS[NAICS["DogAndCatFoodManufacturing"] = 549] = "DogAndCatFoodManufacturing";
    NAICS[NAICS["CookieAndCrackerManufacturing"] = 550] = "CookieAndCrackerManufacturing";
    NAICS[NAICS["FrozenCakesPiesAndPastriesManufacturing"] = 551] = "FrozenCakesPiesAndPastriesManufacturing";
    NAICS[NAICS["CaneSugarManufacturing"] = 552] = "CaneSugarManufacturing";
    NAICS[NAICS["BeetSugarManufacturing"] = 554] = "BeetSugarManufacturing";
    NAICS[NAICS["ChocolateAndConfectioneryManufacturingFromCacaoBeans"] = 555] = "ChocolateAndConfectioneryManufacturingFromCacaoBeans";
    NAICS[NAICS["Breweries"] = 556] = "Breweries";
    NAICS[NAICS["MaltManufacturing"] = 557] = "MaltManufacturing";
    NAICS[NAICS["Distilleries"] = 558] = "Distilleries";
    NAICS[NAICS["SoftDrinkManufacturing"] = 559] = "SoftDrinkManufacturing";
    NAICS[NAICS["FlavoringSyrupAndConcentrateManufacturing"] = 560] = "FlavoringSyrupAndConcentrateManufacturing";
    NAICS[NAICS["IceManufacturing"] = 561] = "IceManufacturing";
    NAICS[NAICS["TortillaManufacturing"] = 562] = "TortillaManufacturing";
    NAICS[NAICS["PerishablePreparedFoodManufacturing"] = 563] = "PerishablePreparedFoodManufacturing";
    NAICS[NAICS["TobaccoManufacturing"] = 565] = "TobaccoManufacturing";
    NAICS[NAICS["CarpetAndRugMills"] = 567] = "CarpetAndRugMills";
    NAICS[NAICS["FiberYarnAndThreadMills"] = 568] = "FiberYarnAndThreadMills";
    NAICS[NAICS["RopeCordageTwineTireCordAndTireFabricMills"] = 569] = "RopeCordageTwineTireCordAndTireFabricMills";
    NAICS[NAICS["ApparelAccessoriesManufacturing"] = 571] = "ApparelAccessoriesManufacturing";
    NAICS[NAICS["TextileBagAndCanvasMills"] = 574] = "TextileBagAndCanvasMills";
    NAICS[NAICS["NarrowFabricMillsAndSchiffliMachineEmbroidery"] = 575] = "NarrowFabricMillsAndSchiffliMachineEmbroidery";
    NAICS[NAICS["Logging"] = 576] = "Logging";
    NAICS[NAICS["WoodWindowAndDoorManufacturing"] = 577] = "WoodWindowAndDoorManufacturing";
    NAICS[NAICS["HardwoodVeneerAndPlywoodManufacturing"] = 578] = "HardwoodVeneerAndPlywoodManufacturing";
    NAICS[NAICS["SoftwoodVeneerAndPlywoodManufacturing"] = 579] = "SoftwoodVeneerAndPlywoodManufacturing";
    NAICS[NAICS["EngineeredWoodMemberManufacturing"] = 580] = "EngineeredWoodMemberManufacturing";
    NAICS[NAICS["TrussManufacturing"] = 581] = "TrussManufacturing";
    NAICS[NAICS["ManufacturedHomeMobileHomeManufacturing"] = 582] = "ManufacturedHomeMobileHomeManufacturing";
    NAICS[NAICS["PrefabricatedWoodBuildingManufacturing"] = 583] = "PrefabricatedWoodBuildingManufacturing";
    NAICS[NAICS["WoodPreservation"] = 584] = "WoodPreservation";
    NAICS[NAICS["ReconstitutedWoodProductManufacturing"] = 585] = "ReconstitutedWoodProductManufacturing";
    NAICS[NAICS["MetalHouseholdFurnitureManufacturing"] = 586] = "MetalHouseholdFurnitureManufacturing";
    NAICS[NAICS["MattressManufacturing"] = 587] = "MattressManufacturing";
    NAICS[NAICS["NonUpholsteredWoodHouseholdFurnitureManufacturing"] = 588] = "NonUpholsteredWoodHouseholdFurnitureManufacturing";
    NAICS[NAICS["WoodOfficeFurnitureManufacturing"] = 589] = "WoodOfficeFurnitureManufacturing";
    NAICS[NAICS["OfficeFurnitureManufacturing"] = 590] = "OfficeFurnitureManufacturing";
    NAICS[NAICS["CustomArchitecturalWoodworkAndMillworkManufacturing"] = 591] = "CustomArchitecturalWoodworkAndMillworkManufacturing";
    NAICS[NAICS["BlindAndShadeManufacturing"] = 592] = "BlindAndShadeManufacturing";
    NAICS[NAICS["PulpMills"] = 593] = "PulpMills";
    NAICS[NAICS["FoldingPaperboardBoxManufacturing"] = 597] = "FoldingPaperboardBoxManufacturing";
    NAICS[NAICS["PlasticsPackagingFilmAndSheetManufacturing"] = 599] = "PlasticsPackagingFilmAndSheetManufacturing";
    NAICS[NAICS["PlasticsBagAndPouchManufacturing"] = 601] = "PlasticsBagAndPouchManufacturing";
    NAICS[NAICS["PaperboardContainerManufacturing"] = 602] = "PaperboardContainerManufacturing";
    NAICS[NAICS["PaperBagAndCoatedAndTreatedPaperManufacturing"] = 603] = "PaperBagAndCoatedAndTreatedPaperManufacturing";
    NAICS[NAICS["NewspaperPublishers"] = 606] = "NewspaperPublishers";
    NAICS[NAICS["BooksPrinting"] = 607] = "BooksPrinting";
    NAICS[NAICS["Publishers"] = 608] = "Publishers";
    NAICS[NAICS["GreetingCardPublishers"] = 610] = "GreetingCardPublishers";
    NAICS[NAICS["CommercialPrinting"] = 611] = "CommercialPrinting";
    NAICS[NAICS["AluminaRefiningAndPrimaryAluminumProduction"] = 614] = "AluminaRefiningAndPrimaryAluminumProduction";
    NAICS[NAICS["PlasticsMaterialAndResinManufacturing"] = 615] = "PlasticsMaterialAndResinManufacturing";
    NAICS[NAICS["SyntheticRubberManufacturing"] = 616] = "SyntheticRubberManufacturing";
    NAICS[NAICS["ArtificialAndSyntheticFibersAndFilamentsManufacturing"] = 617] = "ArtificialAndSyntheticFibersAndFilamentsManufacturing";
    NAICS[NAICS["MedicinalAndBotanicalManufacturing"] = 619] = "MedicinalAndBotanicalManufacturing";
    NAICS[NAICS["InVitroDiagnosticSubstanceManufacturing"] = 620] = "InVitroDiagnosticSubstanceManufacturing";
    NAICS[NAICS["BiologicalProductManufacturing"] = 621] = "BiologicalProductManufacturing";
    NAICS[NAICS["PolishAndSanitationGoodManufacturing"] = 622] = "PolishAndSanitationGoodManufacturing";
    NAICS[NAICS["SurfaceActiveAgentManufacturing"] = 623] = "SurfaceActiveAgentManufacturing";
    NAICS[NAICS["ToiletPreparationManufacturing"] = 624] = "ToiletPreparationManufacturing";
    NAICS[NAICS["CyclicCrudeIntermediateAndGumAndWoodChemicalManufacturing"] = 625] = "CyclicCrudeIntermediateAndGumAndWoodChemicalManufacturing";
    NAICS[NAICS["SyntheticDyeAndPigmentManufacturing"] = 626] = "SyntheticDyeAndPigmentManufacturing";
    NAICS[NAICS["EthylAlcoholManufacturing"] = 627] = "EthylAlcoholManufacturing";
    NAICS[NAICS["NitrogenousFertilizerManufacturing"] = 628] = "NitrogenousFertilizerManufacturing";
    NAICS[NAICS["PhosphaticFertilizerManufacturing"] = 629] = "PhosphaticFertilizerManufacturing";
    NAICS[NAICS["FertilizerMixingOnlyManufacturing"] = 630] = "FertilizerMixingOnlyManufacturing";
    NAICS[NAICS["PesticideAndAgriculturalChemicalManufacturing"] = 631] = "PesticideAndAgriculturalChemicalManufacturing";
    NAICS[NAICS["AdhesiveManufacturing"] = 632] = "AdhesiveManufacturing";
    NAICS[NAICS["ExplosivesManufacturing"] = 633] = "ExplosivesManufacturing";
    NAICS[NAICS["PrintingInkManufacturing"] = 634] = "PrintingInkManufacturing";
    NAICS[NAICS["PetroleumRefineries"] = 635] = "PetroleumRefineries";
    NAICS[NAICS["AsphaltPavingMixtureAndBlockManufacturing"] = 636] = "AsphaltPavingMixtureAndBlockManufacturing";
    NAICS[NAICS["AsphaltShingleAndCoatingMaterialsManufacturing"] = 637] = "AsphaltShingleAndCoatingMaterialsManufacturing";
    NAICS[NAICS["PetroleumLubricatingOilAndGreaseManufacturing"] = 638] = "PetroleumLubricatingOilAndGreaseManufacturing";
    NAICS[NAICS["TireManufacturing"] = 639] = "TireManufacturing";
    NAICS[NAICS["RubberAndPlasticsHosesAndBeltingManufacturing"] = 641] = "RubberAndPlasticsHosesAndBeltingManufacturing";
    NAICS[NAICS["GasketPackingAndSealingDeviceManufacturing"] = 642] = "GasketPackingAndSealingDeviceManufacturing";
    NAICS[NAICS["RubberProductManufacturingForMechanicalUse"] = 643] = "RubberProductManufacturingForMechanicalUse";
    NAICS[NAICS["RubberProductManufacturing"] = 644] = "RubberProductManufacturing";
    NAICS[NAICS["UnLaminatedPlasticsFilmAndSheetManufacturing"] = 645] = "UnLaminatedPlasticsFilmAndSheetManufacturing";
    NAICS[NAICS["LaminatedPlasticsPlateSheetAndShapeManufacturing"] = 646] = "LaminatedPlasticsPlateSheetAndShapeManufacturing";
    NAICS[NAICS["PlasticsBottleManufacturing"] = 647] = "PlasticsBottleManufacturing";
    NAICS[NAICS["PolystyreneFoamProductManufacturing"] = 648] = "PolystyreneFoamProductManufacturing";
    NAICS[NAICS["UrethaneAndOtherFoamProductManufacturing"] = 649] = "UrethaneAndOtherFoamProductManufacturing";
    NAICS[NAICS["CustomCompoundingOfPurchasedResins"] = 650] = "CustomCompoundingOfPurchasedResins";
    NAICS[NAICS["PlasticsPlumbingFixtureManufacturing"] = 651] = "PlasticsPlumbingFixtureManufacturing";
    NAICS[NAICS["FootwearManufacturing"] = 652] = "FootwearManufacturing";
    NAICS[NAICS["WomenHandbagAndPurseManufacturing"] = 657] = "WomenHandbagAndPurseManufacturing";
    NAICS[NAICS["GroundorTreatedMineralAndEarthManufacturing"] = 658] = "GroundorTreatedMineralAndEarthManufacturing";
    NAICS[NAICS["MineralWoolManufacturing"] = 659] = "MineralWoolManufacturing";
    NAICS[NAICS["LeatherProductsManufacturing"] = 661] = "LeatherProductsManufacturing";
    NAICS[NAICS["FlatGlassManufacturing"] = 662] = "FlatGlassManufacturing";
    NAICS[NAICS["GlassContainerManufacturing"] = 663] = "GlassContainerManufacturing";
    NAICS[NAICS["PressedAndBlownGlassAndGlasswareManufacturing"] = 664] = "PressedAndBlownGlassAndGlasswareManufacturing";
    NAICS[NAICS["GlassProductManufacturingMadeOfPurchasedGlass"] = 665] = "GlassProductManufacturingMadeOfPurchasedGlass";
    NAICS[NAICS["CementManufacturing"] = 666] = "CementManufacturing";
    NAICS[NAICS["ClayBuildingMaterialAndRefractoriesManufacturing"] = 670] = "ClayBuildingMaterialAndRefractoriesManufacturing";
    NAICS[NAICS["PotteryCeramicsAndPlumbingFixtureManufacturing"] = 672] = "PotteryCeramicsAndPlumbingFixtureManufacturing";
    NAICS[NAICS["ConcretePipeManufacturing"] = 673] = "ConcretePipeManufacturing";
    NAICS[NAICS["ConcreteProductManufacturing"] = 674] = "ConcreteProductManufacturing";
    NAICS[NAICS["ReadyMixConcreteManufacturing"] = 675] = "ReadyMixConcreteManufacturing";
    NAICS[NAICS["LimeManufacturing"] = 676] = "LimeManufacturing";
    NAICS[NAICS["CutStoneAndStoneProductManufacturing"] = 677] = "CutStoneAndStoneProductManufacturing";
    NAICS[NAICS["AbrasiveProductManufacturing"] = 678] = "AbrasiveProductManufacturing";
    NAICS[NAICS["IronAndSteelMillsAndFerroalloyManufacturing"] = 679] = "IronAndSteelMillsAndFerroalloyManufacturing";
    NAICS[NAICS["SteelWireDrawing"] = 680] = "SteelWireDrawing";
    NAICS[NAICS["IronAndSteelPipeAndTubeManufacturingFromPurchasedSteel"] = 681] = "IronAndSteelPipeAndTubeManufacturingFromPurchasedSteel";
    NAICS[NAICS["SteelInvestmentFoundries"] = 682] = "SteelInvestmentFoundries";
    NAICS[NAICS["SteelFoundries"] = 683] = "SteelFoundries";
    NAICS[NAICS["NonferrousMetalSmeltingAndRefining"] = 684] = "NonferrousMetalSmeltingAndRefining";
    NAICS[NAICS["AluminumSheetPlateAndFoilManufacturing"] = 688] = "AluminumSheetPlateAndFoilManufacturing";
    NAICS[NAICS["SecondarySmeltingAndAlloyingOfAluminum"] = 689] = "SecondarySmeltingAndAlloyingOfAluminum";
    NAICS[NAICS["CopperRollingDrawingExtrudingAndAlloying"] = 690] = "CopperRollingDrawingExtrudingAndAlloying";
    NAICS[NAICS["FiberOpticCableManufacturing"] = 691] = "FiberOpticCableManufacturing";
    NAICS[NAICS["CommunicationAndEnergyWireManufacturing"] = 692] = "CommunicationAndEnergyWireManufacturing";
    NAICS[NAICS["NonferrousMetalDieCastingFoundries"] = 694] = "NonferrousMetalDieCastingFoundries";
    NAICS[NAICS["AluminumFoundries"] = 695] = "AluminumFoundries";
    NAICS[NAICS["NonferrousMetalFoundries"] = 696] = "NonferrousMetalFoundries";
    NAICS[NAICS["MetalHeatTreating"] = 698] = "MetalHeatTreating";
    NAICS[NAICS["MetalCanManufacturing"] = 699] = "MetalCanManufacturing";
    NAICS[NAICS["SawBladeAndHandToolManufacturing"] = 700] = "SawBladeAndHandToolManufacturing";
    NAICS[NAICS["FabricatedMetalProductManufacturing"] = 701] = "FabricatedMetalProductManufacturing";
    NAICS[NAICS["PlumbingFixtureFittingAndTrimManufacturing"] = 702] = "PlumbingFixtureFittingAndTrimManufacturing";
    NAICS[NAICS["PlateWorkManufacturing"] = 703] = "PlateWorkManufacturing";
    NAICS[NAICS["MetalTankHeavyGaugeManufacturing"] = 704] = "MetalTankHeavyGaugeManufacturing";
    NAICS[NAICS["SheetMetalWorkManufacturing"] = 705] = "SheetMetalWorkManufacturing";
    NAICS[NAICS["PrefabricatedMetalBuildingAndComponentManufacturing"] = 706] = "PrefabricatedMetalBuildingAndComponentManufacturing";
    NAICS[NAICS["CustomRollForming"] = 707] = "CustomRollForming";
    NAICS[NAICS["PrecisionTurnedProductManufacturing"] = 708] = "PrecisionTurnedProductManufacturing";
    NAICS[NAICS["IronAndSteelForging"] = 709] = "IronAndSteelForging";
    NAICS[NAICS["NonferrousForging"] = 710] = "NonferrousForging";
    NAICS[NAICS["MotorVehicleMetalStamping"] = 711] = "MotorVehicleMetalStamping";
    NAICS[NAICS["MetalCrownClosureAndOtherMetalStamping"] = 712] = "MetalCrownClosureAndOtherMetalStamping";
    NAICS[NAICS["SmallArmsAmmunitionManufacturing"] = 714] = "SmallArmsAmmunitionManufacturing";
    NAICS[NAICS["AmmunitionManufacturing"] = 715] = "AmmunitionManufacturing";
    NAICS[NAICS["SmallArmsOrdnanceAndOrdnanceAccessoriesManufacturing"] = 716] = "SmallArmsOrdnanceAndOrdnanceAccessoriesManufacturing";
    NAICS[NAICS["IndustrialValveManufacturing"] = 717] = "IndustrialValveManufacturing";
    NAICS[NAICS["SpringManufacturing"] = 718] = "SpringManufacturing";
    NAICS[NAICS["FabricatedPipeAndPipeFittingManufacturing"] = 721] = "FabricatedPipeAndPipeFittingManufacturing";
    NAICS[NAICS["PowderMetallurgyPartManufacturing"] = 722] = "PowderMetallurgyPartManufacturing";
    NAICS[NAICS["TurbineAndTurbineGeneratorSetUnitsManufacturing"] = 723] = "TurbineAndTurbineGeneratorSetUnitsManufacturing";
    NAICS[NAICS["LawnAndGardenTractorAndHomeLawnAndGardenEquipmentManufacturing"] = 724] = "LawnAndGardenTractorAndHomeLawnAndGardenEquipmentManufacturing";
    NAICS[NAICS["ConstructionMachineryManufacturing"] = 725] = "ConstructionMachineryManufacturing";
    NAICS[NAICS["MiningMachineryAndEquipmentManufacturing"] = 726] = "MiningMachineryAndEquipmentManufacturing";
    NAICS[NAICS["OilAndGasFieldMachineryAndEquipmentManufacturing"] = 727] = "OilAndGasFieldMachineryAndEquipmentManufacturing";
    NAICS[NAICS["ElevatorAndMovingStairwayManufacturing"] = 728] = "ElevatorAndMovingStairwayManufacturing";
    NAICS[NAICS["MachineToolManufacturing"] = 730] = "MachineToolManufacturing";
    NAICS[NAICS["IndustrialMoldManufacturing"] = 732] = "IndustrialMoldManufacturing";
    NAICS[NAICS["SpecialDieAndToolDieSetJigAndFixtureManufacturing"] = 733] = "SpecialDieAndToolDieSetJigAndFixtureManufacturing";
    NAICS[NAICS["CuttingToolAndMachineToolAccessoryManufacturing"] = 734] = "CuttingToolAndMachineToolAccessoryManufacturing";
    NAICS[NAICS["PowerDrivenHandToolManufacturing"] = 735] = "PowerDrivenHandToolManufacturing";
    NAICS[NAICS["RollingMillAndOtherMetalworkingMachineryManufacturing"] = 736] = "RollingMillAndOtherMetalworkingMachineryManufacturing";
    NAICS[NAICS["SawmillWoodworkingAndPaperMachineryManufacturing"] = 740] = "SawmillWoodworkingAndPaperMachineryManufacturing";
    NAICS[NAICS["PrintingMachineryAndEquipmentManufacturing"] = 741] = "PrintingMachineryAndEquipmentManufacturing";
    NAICS[NAICS["FoodProductMachineryManufacturing"] = 742] = "FoodProductMachineryManufacturing";
    NAICS[NAICS["IndustrialMachineryManufacturing"] = 743] = "IndustrialMachineryManufacturing";
    NAICS[NAICS["SemiconductorMachineryManufacturing"] = 744] = "SemiconductorMachineryManufacturing";
    NAICS[NAICS["MotorVehicleGasolineEngineAndEnginePartsManufacturing"] = 745] = "MotorVehicleGasolineEngineAndEnginePartsManufacturing";
    NAICS[NAICS["BallAndRollerBearingManufacturing"] = 746] = "BallAndRollerBearingManufacturing";
    NAICS[NAICS["AirAndGasCompressorManufacturing"] = 747] = "AirAndGasCompressorManufacturing";
    NAICS[NAICS["IndustrialAndCommercialFanAndBlowerAndAirPurificationEquipmentManufacturing"] = 749] = "IndustrialAndCommercialFanAndBlowerAndAirPurificationEquipmentManufacturing";
    NAICS[NAICS["PackagingMachineryManufacturing"] = 750] = "PackagingMachineryManufacturing";
    NAICS[NAICS["SpeedChangerIndustrialHighSpeedDriveAndGearManufacturing"] = 751] = "SpeedChangerIndustrialHighSpeedDriveAndGearManufacturing";
    NAICS[NAICS["IndustrialProcessFurnaceAndOvenManufacturing"] = 752] = "IndustrialProcessFurnaceAndOvenManufacturing";
    NAICS[NAICS["MechanicalPowerTransmissionEquipmentManufacturing"] = 753] = "MechanicalPowerTransmissionEquipmentManufacturing";
    NAICS[NAICS["ElectronicComputerManufacturing"] = 754] = "ElectronicComputerManufacturing";
    NAICS[NAICS["ComputerStorageDeviceManufacturing"] = 755] = "ComputerStorageDeviceManufacturing";
    NAICS[NAICS["ComputerTerminalAndComputerPeripheralEquipmentManufacturing"] = 756] = "ComputerTerminalAndComputerPeripheralEquipmentManufacturing";
    NAICS[NAICS["CommercialAndServiceIndustryMachineryManufacturing"] = 757] = "CommercialAndServiceIndustryMachineryManufacturing";
    NAICS[NAICS["MotorVehiclePartsManufacturing"] = 758] = "MotorVehiclePartsManufacturing";
    NAICS[NAICS["MeasuringDispensingAndPumpingEquipmentManufacturing"] = 759] = "MeasuringDispensingAndPumpingEquipmentManufacturing";
    NAICS[NAICS["FluidPowerCylinderAndActuatorManufacturing"] = 760] = "FluidPowerCylinderAndActuatorManufacturing";
    NAICS[NAICS["FluidPowerPumpAndMotorManufacturing"] = 761] = "FluidPowerPumpAndMotorManufacturing";
    NAICS[NAICS["ScaleAndBalanceManufacturing"] = 762] = "ScaleAndBalanceManufacturing";
    NAICS[NAICS["MachineShops"] = 763] = "MachineShops";
    NAICS[NAICS["SwitchgearAndSwitchboardApparatusManufacturing"] = 764] = "SwitchgearAndSwitchboardApparatusManufacturing";
    NAICS[NAICS["CarbonAndGraphiteProductManufacturing"] = 765] = "CarbonAndGraphiteProductManufacturing";
    NAICS[NAICS["RelayAndIndustrialControlManufacturing"] = 766] = "RelayAndIndustrialControlManufacturing";
    NAICS[NAICS["MajorHouseholdApplianceManufacturing"] = 769] = "MajorHouseholdApplianceManufacturing";
    NAICS[NAICS["ElectricLampBulbAndPartManufacturing"] = 771] = "ElectricLampBulbAndPartManufacturing";
    NAICS[NAICS["CurrentCarryingWiringDeviceManufacturing"] = 772] = "CurrentCarryingWiringDeviceManufacturing";
    NAICS[NAICS["NonCurrentCarryingWiringDeviceManufacturing"] = 773] = "NonCurrentCarryingWiringDeviceManufacturing";
    NAICS[NAICS["CommercialIndustrialAndInstitutionalElectricLightingFixtureManufacturing"] = 774] = "CommercialIndustrialAndInstitutionalElectricLightingFixtureManufacturing";
    NAICS[NAICS["MotorVehicleElectricalAndElectronicEquipmentManufacturing"] = 775] = "MotorVehicleElectricalAndElectronicEquipmentManufacturing";
    NAICS[NAICS["RecordProductionAndDistribution"] = 776] = "RecordProductionAndDistribution";
    NAICS[NAICS["TelephoneApparatusManufacturing"] = 777] = "TelephoneApparatusManufacturing";
    NAICS[NAICS["CommunicationsEquipmentManufacturing"] = 778] = "CommunicationsEquipmentManufacturing";
    NAICS[NAICS["ElectronicComponentManufacturing"] = 779] = "ElectronicComponentManufacturing";
    NAICS[NAICS["BarePrintedCircuitBoardManufacturing"] = 780] = "BarePrintedCircuitBoardManufacturing";
    NAICS[NAICS["SemiconductorAndRelatedDeviceManufacturing"] = 781] = "SemiconductorAndRelatedDeviceManufacturing";
    NAICS[NAICS["CapacitorResistorCoilTransFormerAndInductorManufacturing"] = 783] = "CapacitorResistorCoilTransFormerAndInductorManufacturing";
    NAICS[NAICS["ElectronicConnectorManufacturing"] = 785] = "ElectronicConnectorManufacturing";
    NAICS[NAICS["StorageBatteryManufacturing"] = 787] = "StorageBatteryManufacturing";
    NAICS[NAICS["PrimaryBatteryManufacturing"] = 788] = "PrimaryBatteryManufacturing";
    NAICS[NAICS["AutomobileManufacturing"] = 789] = "AutomobileManufacturing";
    NAICS[NAICS["LightTruckAndUtilityVehicleManufacturing"] = 790] = "LightTruckAndUtilityVehicleManufacturing";
    NAICS[NAICS["HeavyDutyTruckManufacturing"] = 791] = "HeavyDutyTruckManufacturing";
    NAICS[NAICS["MotorVehicleSteeringAndSuspensionComponentsManufacturing"] = 793] = "MotorVehicleSteeringAndSuspensionComponentsManufacturing";
    NAICS[NAICS["TruckTrailerManufacturing"] = 794] = "TruckTrailerManufacturing";
    NAICS[NAICS["MotorHomeManufacturing"] = 795] = "MotorHomeManufacturing";
    NAICS[NAICS["AircraftEngineAndEnginePartsManufacturing"] = 796] = "AircraftEngineAndEnginePartsManufacturing";
    NAICS[NAICS["AircraftPartsAndAuxiliaryEquipmentManufacturing"] = 797] = "AircraftPartsAndAuxiliaryEquipmentManufacturing";
    NAICS[NAICS["ShipBuildingAndRepairing"] = 798] = "ShipBuildingAndRepairing";
    NAICS[NAICS["BoatBuilding"] = 799] = "BoatBuilding";
    NAICS[NAICS["GuidedMissileAndSpaceVehicleManufacturing"] = 800] = "GuidedMissileAndSpaceVehicleManufacturing";
    NAICS[NAICS["GuidedMissileAndSpaceVehiclePropulsionUnitAndPropulsionUnitPartsManufacturing"] = 801] = "GuidedMissileAndSpaceVehiclePropulsionUnitAndPropulsionUnitPartsManufacturing";
    NAICS[NAICS["OtherGuidedMissileAndSpaceVehiclePartsAndAuxiliaryEquipmentManufacturing"] = 802] = "OtherGuidedMissileAndSpaceVehiclePartsAndAuxiliaryEquipmentManufacturing";
    NAICS[NAICS["TransportationEquipmentManufacturing"] = 803] = "TransportationEquipmentManufacturing";
    NAICS[NAICS["SearchDetectionNavigationGuidanceAeronauticalAndNauticalSystemAndInstrumentManufacturing"] = 804] = "SearchDetectionNavigationGuidanceAeronauticalAndNauticalSystemAndInstrumentManufacturing";
    NAICS[NAICS["AutomaticEnvironmentalControlManufacturingForResidentialCommercialAndApplianceUse"] = 805] = "AutomaticEnvironmentalControlManufacturingForResidentialCommercialAndApplianceUse";
    NAICS[NAICS["InstrumentsAndRelatedProductsManufacturingForMeasuringDisplayingAndControllingIndustrialProcessVariables"] = 806] = "InstrumentsAndRelatedProductsManufacturingForMeasuringDisplayingAndControllingIndustrialProcessVariables";
    NAICS[NAICS["AnalyticalLaboratoryInstrumentManufacturing"] = 807] = "AnalyticalLaboratoryInstrumentManufacturing";
    NAICS[NAICS["OpticalInstrumentAndLensManufacturing"] = 808] = "OpticalInstrumentAndLensManufacturing";
    NAICS[NAICS["InstrumentManufacturingForMeasuringAndTestingElectricityAndElectricalSignals"] = 809] = "InstrumentManufacturingForMeasuringAndTestingElectricityAndElectricalSignals";
    NAICS[NAICS["DentalEquipmentAndSuppliesManufacturing"] = 810] = "DentalEquipmentAndSuppliesManufacturing";
    NAICS[NAICS["PhotographicFilmPaperPlateAndChemicalManufacturing"] = 811] = "PhotographicFilmPaperPlateAndChemicalManufacturing";
    NAICS[NAICS["PhotographicAndPhotocopyingEquipmentManufacturing"] = 812] = "PhotographicAndPhotocopyingEquipmentManufacturing";
    NAICS[NAICS["MusicalInstrumentManufacturing"] = 814] = "MusicalInstrumentManufacturing";
    NAICS[NAICS["DollToyAndGameManufacturing"] = 815] = "DollToyAndGameManufacturing";
    NAICS[NAICS["SignManufacturing"] = 819] = "SignManufacturing";
    NAICS[NAICS["BurialCasketManufacturing"] = 820] = "BurialCasketManufacturing";
    NAICS[NAICS["LineHaulRailroads"] = 821] = "LineHaulRailroads";
    NAICS[NAICS["ShortLineRailroads"] = 822] = "ShortLineRailroads";
    NAICS[NAICS["MixedModeTransitSystems"] = 823] = "MixedModeTransitSystems";
    NAICS[NAICS["CommuterRailSystems"] = 824] = "CommuterRailSystems";
    NAICS[NAICS["BusAndOtherMotorVehicleTransitSystems"] = 825] = "BusAndOtherMotorVehicleTransitSystems";
    NAICS[NAICS["UrbanTransitSystems"] = 826] = "UrbanTransitSystems";
    NAICS[NAICS["LimousineService"] = 827] = "LimousineService";
    NAICS[NAICS["SpecialNeedsTransportation"] = 828] = "SpecialNeedsTransportation";
    NAICS[NAICS["InterurbanAndRuralBusTransportation"] = 829] = "InterurbanAndRuralBusTransportation";
    NAICS[NAICS["SolidWasteCollection"] = 830] = "SolidWasteCollection";
    NAICS[NAICS["HazardousWasteCollection"] = 831] = "HazardousWasteCollection";
    NAICS[NAICS["WasteCollection"] = 832] = "WasteCollection";
    NAICS[NAICS["GeneralFreightTruckingLongDistanceTruckload"] = 833] = "GeneralFreightTruckingLongDistanceTruckload";
    NAICS[NAICS["GeneralFreightTruckingLongDistanceLessThanTruckload"] = 834] = "GeneralFreightTruckingLongDistanceLessThanTruckload";
    NAICS[NAICS["SpecializedFreightTruckingLongDistance"] = 835] = "SpecializedFreightTruckingLongDistance";
    NAICS[NAICS["LocalMessengersAndLocalDelivery"] = 836] = "LocalMessengersAndLocalDelivery";
    NAICS[NAICS["FarmProductWarehousingAndStorage"] = 837] = "FarmProductWarehousingAndStorage";
    NAICS[NAICS["LessorsOfMiniWarehousesAndSelfStorageUnits"] = 838] = "LessorsOfMiniWarehousesAndSelfStorageUnits";
    NAICS[NAICS["WarehousingAndStorage"] = 839] = "WarehousingAndStorage";
    NAICS[NAICS["DeepSeaFreightTransportation"] = 840] = "DeepSeaFreightTransportation";
    NAICS[NAICS["DeepSeaPassengerTransportation"] = 841] = "DeepSeaPassengerTransportation";
    NAICS[NAICS["MarineCargoHandling"] = 842] = "MarineCargoHandling";
    NAICS[NAICS["Marinas"] = 843] = "Marinas";
    NAICS[NAICS["ScheduledPassengerAirTransportation"] = 844] = "ScheduledPassengerAirTransportation";
    NAICS[NAICS["ScheduledFreightAirTransportation"] = 845] = "ScheduledFreightAirTransportation";
    NAICS[NAICS["NonscheduledCharteredPassengerAirTransportation"] = 846] = "NonscheduledCharteredPassengerAirTransportation";
    NAICS[NAICS["NonscheduledCharteredFreightAirTransportation"] = 847] = "NonscheduledCharteredFreightAirTransportation";
    NAICS[NAICS["SupportActivitiesForAirTransportation"] = 848] = "SupportActivitiesForAirTransportation";
    NAICS[NAICS["PipelineTransportationOfCrudeOil"] = 849] = "PipelineTransportationOfCrudeOil";
    NAICS[NAICS["PipelineTransportationOfRefinedPetroleumProducts"] = 850] = "PipelineTransportationOfRefinedPetroleumProducts";
    NAICS[NAICS["PipelineTransportation"] = 851] = "PipelineTransportation";
    NAICS[NAICS["TravelAgencies"] = 852] = "TravelAgencies";
    NAICS[NAICS["TourOperators"] = 853] = "TourOperators";
    NAICS[NAICS["FreightTransportationArrangement"] = 854] = "FreightTransportationArrangement";
    NAICS[NAICS["PackingAndCrating"] = 855] = "PackingAndCrating";
    NAICS[NAICS["WirelessTelecommunicationsCarriersExceptSatellite"] = 856] = "WirelessTelecommunicationsCarriersExceptSatellite";
    NAICS[NAICS["RadioNetworks"] = 857] = "RadioNetworks";
    NAICS[NAICS["RadioStations"] = 858] = "RadioStations";
    NAICS[NAICS["TelevisionBroadcasting"] = 859] = "TelevisionBroadcasting";
    NAICS[NAICS["CableAndSubscriptionProgramming"] = 860] = "CableAndSubscriptionProgramming";
    NAICS[NAICS["WiredTelecommunicationsCarriers"] = 861] = "WiredTelecommunicationsCarriers";
    NAICS[NAICS["SatelliteTelecommunications"] = 862] = "SatelliteTelecommunications";
    NAICS[NAICS["SewageTreatmentFacilities"] = 864] = "SewageTreatmentFacilities";
    NAICS[NAICS["HazardousWasteTreatmentAndDisposal"] = 865] = "HazardousWasteTreatmentAndDisposal";
    NAICS[NAICS["SolidWasteLandfill"] = 866] = "SolidWasteLandfill";
    NAICS[NAICS["SolidWasteCombustorsAndIncinerators"] = 867] = "SolidWasteCombustorsAndIncinerators";
    NAICS[NAICS["NonhazardousWasteTreatmentAndDisposal"] = 868] = "NonhazardousWasteTreatmentAndDisposal";
    NAICS[NAICS["MaterialsRecoveryFacilities"] = 869] = "MaterialsRecoveryFacilities";
    NAICS[NAICS["SteamAndAirConditioningSupply"] = 870] = "SteamAndAirConditioningSupply";
    NAICS[NAICS["AutomobileAndMotorVehicleMerchantWholesalers"] = 871] = "AutomobileAndMotorVehicleMerchantWholesalers";
    NAICS[NAICS["MotorVehicleSuppliesAndNewPartsMerchantWholesalers"] = 872] = "MotorVehicleSuppliesAndNewPartsMerchantWholesalers";
    NAICS[NAICS["TireAndTubeMerchantWholesalers"] = 873] = "TireAndTubeMerchantWholesalers";
    NAICS[NAICS["MotorVehiclePartsUsedMerchantWholesalers"] = 874] = "MotorVehiclePartsUsedMerchantWholesalers";
    NAICS[NAICS["FurnitureMerchantWholesalers"] = 875] = "FurnitureMerchantWholesalers";
    NAICS[NAICS["HomeFurnishingMerchantWholesalers"] = 876] = "HomeFurnishingMerchantWholesalers";
    NAICS[NAICS["BrickStoneAndRelatedConstructionMaterialMerchantWholesalers"] = 877] = "BrickStoneAndRelatedConstructionMaterialMerchantWholesalers";
    NAICS[NAICS["RoofingSidingAndInsulationMaterialMerchantWholesalers"] = 878] = "RoofingSidingAndInsulationMaterialMerchantWholesalers";
    NAICS[NAICS["ConstructionMaterialMerchantWholesalers"] = 879] = "ConstructionMaterialMerchantWholesalers";
    NAICS[NAICS["PhotographicEquipmentAndSuppliesMerchantWholesalers"] = 880] = "PhotographicEquipmentAndSuppliesMerchantWholesalers";
    NAICS[NAICS["OfficeEquipmentMerchantWholesalers"] = 881] = "OfficeEquipmentMerchantWholesalers";
    NAICS[NAICS["ComputerAndSoftwareWholesalers"] = 882] = "ComputerAndSoftwareWholesalers";
    NAICS[NAICS["CommercialEquipmentMerchantWholesalers"] = 883] = "CommercialEquipmentMerchantWholesalers";
    NAICS[NAICS["MedicalDentalAndHospitalEquipmentAndSuppliesMerchantWholesalers"] = 884] = "MedicalDentalAndHospitalEquipmentAndSuppliesMerchantWholesalers";
    NAICS[NAICS["OphthalmicGoodsMerchantWholesalers"] = 885] = "OphthalmicGoodsMerchantWholesalers";
    NAICS[NAICS["ProfessionalEquipmentAndSuppliesMerchantWholesalers"] = 886] = "ProfessionalEquipmentAndSuppliesMerchantWholesalers";
    NAICS[NAICS["MetalServiceCentersAndMetalMerchantWholesalers"] = 887] = "MetalServiceCentersAndMetalMerchantWholesalers";
    NAICS[NAICS["CoalAndMineralAndOreMerchantWholesalers"] = 888] = "CoalAndMineralAndOreMerchantWholesalers";
    NAICS[NAICS["ElectricalApparatusAndEquipmentWiringSuppliesAndRelatedEquipmentMerchantWholesalers"] = 889] = "ElectricalApparatusAndEquipmentWiringSuppliesAndRelatedEquipmentMerchantWholesalers";
    NAICS[NAICS["HouseholdAppliancesElectricHousewaresAndConsumerElectronicsMerchantWholesalers"] = 890] = "HouseholdAppliancesElectricHousewaresAndConsumerElectronicsMerchantWholesalers";
    NAICS[NAICS["ElectronicPartsAndEquipmentMerchantWholesalers"] = 891] = "ElectronicPartsAndEquipmentMerchantWholesalers";
    NAICS[NAICS["HardwareMerchantWholesalers"] = 892] = "HardwareMerchantWholesalers";
    NAICS[NAICS["PlumbingAndHeatingEquipmentAndSuppliesMerchantWholesalers"] = 893] = "PlumbingAndHeatingEquipmentAndSuppliesMerchantWholesalers";
    NAICS[NAICS["WarmAirHeatingAndAirConditioningEquipmentAndSuppliesMerchantWholesalers"] = 894] = "WarmAirHeatingAndAirConditioningEquipmentAndSuppliesMerchantWholesalers";
    NAICS[NAICS["RefrigerationEquipmentAndSuppliesMerchantWholesalers"] = 895] = "RefrigerationEquipmentAndSuppliesMerchantWholesalers";
    NAICS[NAICS["ConstructionAndMiningMachineryAndEquipmentMerchantWholesalers"] = 896] = "ConstructionAndMiningMachineryAndEquipmentMerchantWholesalers";
    NAICS[NAICS["FarmAndGardenMachineryAndEquipmentMerchantWholesalers"] = 897] = "FarmAndGardenMachineryAndEquipmentMerchantWholesalers";
    NAICS[NAICS["IndustrialSuppliesMerchantWholesalers"] = 898] = "IndustrialSuppliesMerchantWholesalers";
    NAICS[NAICS["ServiceEstablishmentEquipmentAndSuppliesMerchantWholesalers"] = 899] = "ServiceEstablishmentEquipmentAndSuppliesMerchantWholesalers";
    NAICS[NAICS["TransportationEquipmentAndSuppliesMerchantWholesalers"] = 900] = "TransportationEquipmentAndSuppliesMerchantWholesalers";
    NAICS[NAICS["ToyAndHobbyGoodsAndSuppliesMerchantWholesalers"] = 901] = "ToyAndHobbyGoodsAndSuppliesMerchantWholesalers";
    NAICS[NAICS["RecyclableMaterialMerchantWholesalers"] = 902] = "RecyclableMaterialMerchantWholesalers";
    NAICS[NAICS["JewelryWatchPreciousStoneAndPreciousMetalMerchantWholesalers"] = 903] = "JewelryWatchPreciousStoneAndPreciousMetalMerchantWholesalers";
    NAICS[NAICS["PrintingAndWritingPaperMerchantWholesalers"] = 904] = "PrintingAndWritingPaperMerchantWholesalers";
    NAICS[NAICS["StationeryAndOfficeSuppliesMerchantWholesalers"] = 905] = "StationeryAndOfficeSuppliesMerchantWholesalers";
    NAICS[NAICS["IndustrialAndPersonalServicePaperMerchantWholesalers"] = 906] = "IndustrialAndPersonalServicePaperMerchantWholesalers";
    NAICS[NAICS["DrugsAndDruggistsSundriesMerchantWholesalers"] = 907] = "DrugsAndDruggistsSundriesMerchantWholesalers";
    NAICS[NAICS["MenAndBoysClothingAndFurnishingsMerchantWholesalers"] = 908] = "MenAndBoysClothingAndFurnishingsMerchantWholesalers";
    NAICS[NAICS["WomenChildrenAndInfantsClothingAndAccessoriesMerchantWholesalers"] = 909] = "WomenChildrenAndInfantsClothingAndAccessoriesMerchantWholesalers";
    NAICS[NAICS["GeneralLineGroceryMerchantWholesalers"] = 910] = "GeneralLineGroceryMerchantWholesalers";
    NAICS[NAICS["PackagedFrozenFoodMerchantWholesalers"] = 911] = "PackagedFrozenFoodMerchantWholesalers";
    NAICS[NAICS["DairyProductMerchantWholesalers"] = 912] = "DairyProductMerchantWholesalers";
    NAICS[NAICS["PoultryAndPoultryProductMerchantWholesalers"] = 913] = "PoultryAndPoultryProductMerchantWholesalers";
    NAICS[NAICS["ConfectioneryMerchantWholesalers"] = 914] = "ConfectioneryMerchantWholesalers";
    NAICS[NAICS["FishAndSeafoodMerchantWholesalers"] = 915] = "FishAndSeafoodMerchantWholesalers";
    NAICS[NAICS["FreshFruitAndVegetableMerchantWholesalers"] = 916] = "FreshFruitAndVegetableMerchantWholesalers";
    NAICS[NAICS["MeatAndMeatProductMerchantWholesalers"] = 917] = "MeatAndMeatProductMerchantWholesalers";
    NAICS[NAICS["GroceryAndRelatedProductsMerchantWholesalers"] = 918] = "GroceryAndRelatedProductsMerchantWholesalers";
    NAICS[NAICS["GrainAndFieldBeanMerchantWholesalers"] = 919] = "GrainAndFieldBeanMerchantWholesalers";
    NAICS[NAICS["LivestockMerchantWholesalers"] = 920] = "LivestockMerchantWholesalers";
    NAICS[NAICS["FarmProductRawMaterialMerchantWholesalers"] = 921] = "FarmProductRawMaterialMerchantWholesalers";
    NAICS[NAICS["ChemicalAndAlliedProductsMerchantWholesalers"] = 922] = "ChemicalAndAlliedProductsMerchantWholesalers";
    NAICS[NAICS["PetroleumBulkStationsAndTerminals"] = 923] = "PetroleumBulkStationsAndTerminals";
    NAICS[NAICS["PetroleumAndPetroleumProductsMerchantWholesalers"] = 924] = "PetroleumAndPetroleumProductsMerchantWholesalers";
    NAICS[NAICS["BeerAndAleMerchantWholesalers"] = 925] = "BeerAndAleMerchantWholesalers";
    NAICS[NAICS["WineAndDistilledAlcoholicBeverageMerchantWholesalers"] = 926] = "WineAndDistilledAlcoholicBeverageMerchantWholesalers";
    NAICS[NAICS["FarmSuppliesMerchantWholesalers"] = 927] = "FarmSuppliesMerchantWholesalers";
    NAICS[NAICS["BookPeriodicalAndNewspaperMerchantWholesalers"] = 928] = "BookPeriodicalAndNewspaperMerchantWholesalers";
    NAICS[NAICS["FlowerNurseryStockAndFloristsSuppliesMerchantWholesalers"] = 929] = "FlowerNurseryStockAndFloristsSuppliesMerchantWholesalers";
    NAICS[NAICS["TobaccoAndTobaccoProductMerchantWholesalers"] = 930] = "TobaccoAndTobaccoProductMerchantWholesalers";
    NAICS[NAICS["PaintVarnishAndSuppliesMerchantWholesalers"] = 931] = "PaintVarnishAndSuppliesMerchantWholesalers";
    NAICS[NAICS["NonDurableGoodsMerchantWholesalers"] = 932] = "NonDurableGoodsMerchantWholesalers";
    NAICS[NAICS["PaintAndWallpaperStores"] = 933] = "PaintAndWallpaperStores";
    NAICS[NAICS["ManufacturedMobileHomeDealers"] = 934] = "ManufacturedMobileHomeDealers";
    NAICS[NAICS["DepartmentStores"] = 936] = "DepartmentStores";
    NAICS[NAICS["ConvenienceStores"] = 937] = "ConvenienceStores";
    NAICS[NAICS["RetailBakeries"] = 938] = "RetailBakeries";
    NAICS[NAICS["BakedGoodsStores"] = 939] = "BakedGoodsStores";
    NAICS[NAICS["NewCarDealers"] = 940] = "NewCarDealers";
    NAICS[NAICS["UsedCarDealers"] = 941] = "UsedCarDealers";
    NAICS[NAICS["GasolineStations"] = 942] = "GasolineStations";
    NAICS[NAICS["BoatDealers"] = 943] = "BoatDealers";
    NAICS[NAICS["RecreationalVehicleDealers"] = 944] = "RecreationalVehicleDealers";
    NAICS[NAICS["MotorcycleATVAndAllOtherMotorVehicleDealers"] = 945] = "MotorcycleATVAndAllOtherMotorVehicleDealers";
    NAICS[NAICS["FamilyClothingStores"] = 947] = "FamilyClothingStores";
    NAICS[NAICS["MusicalInstrumentAndSuppliesStores"] = 948] = "MusicalInstrumentAndSuppliesStores";
    NAICS[NAICS["DineInRestaurants"] = 949] = "DineInRestaurants";
    NAICS[NAICS["FastFoodRestaurants"] = 950] = "FastFoodRestaurants";
    NAICS[NAICS["CafeteriasGrillBuffetsAndBuffets"] = 951] = "CafeteriasGrillBuffetsAndBuffets";
    NAICS[NAICS["Caterers"] = 952] = "Caterers";
    NAICS[NAICS["DrinkingPlacesAlcoholicBeverages"] = 953] = "DrinkingPlacesAlcoholicBeverages";
    NAICS[NAICS["UsedMerchandiseStores"] = 954] = "UsedMerchandiseStores";
    NAICS[NAICS["ElectronicsStores"] = 955] = "ElectronicsStores";
    NAICS[NAICS["LuggageAndLeatherGoodsStores"] = 956] = "LuggageAndLeatherGoodsStores";
    NAICS[NAICS["OnlineShopping"] = 958] = "OnlineShopping";
    NAICS[NAICS["VendingMachineOperators"] = 960] = "VendingMachineOperators";
    NAICS[NAICS["MobileFoodServices"] = 961] = "MobileFoodServices";
    NAICS[NAICS["Florists"] = 963] = "Florists";
    NAICS[NAICS["NewsDealersAndNewsstAnds"] = 964] = "NewsDealersAndNewsstAnds";
    NAICS[NAICS["OpticalGoodsStores"] = 965] = "OpticalGoodsStores";
    NAICS[NAICS["ArtDealers"] = 966] = "ArtDealers";
    NAICS[NAICS["MonetaryAuthoritiesCentralBank"] = 967] = "MonetaryAuthoritiesCentralBank";
    NAICS[NAICS["DepositoryCreditIntermediation"] = 968] = "DepositoryCreditIntermediation";
    NAICS[NAICS["ConsumerLending"] = 969] = "ConsumerLending";
    NAICS[NAICS["MortgageAndNonmortgageLoanBrokers"] = 970] = "MortgageAndNonmortgageLoanBrokers";
    NAICS[NAICS["InvestmentBankingAndSecuritiesDealing"] = 971] = "InvestmentBankingAndSecuritiesDealing";
    NAICS[NAICS["SecuritiesBrokerage"] = 972] = "SecuritiesBrokerage";
    NAICS[NAICS["CommodityContractsBrokerage"] = 973] = "CommodityContractsBrokerage";
    NAICS[NAICS["SecuritiesAndCommodityExchanges"] = 974] = "SecuritiesAndCommodityExchanges";
    NAICS[NAICS["InvestmentAdvice"] = 975] = "InvestmentAdvice";
    NAICS[NAICS["DirectTitleInsuranceCarriers"] = 976] = "DirectTitleInsuranceCarriers";
    NAICS[NAICS["PensionFunds"] = 977] = "PensionFunds";
    NAICS[NAICS["HealthAndWelfareFunds"] = 978] = "HealthAndWelfareFunds";
    NAICS[NAICS["InsuranceAgenciesAndBrokerages"] = 979] = "InsuranceAgenciesAndBrokerages";
    NAICS[NAICS["ClaimsAdjusting"] = 980] = "ClaimsAdjusting";
    NAICS[NAICS["InsuranceRelatedActivities"] = 981] = "InsuranceRelatedActivities";
    NAICS[NAICS["LessorsOfCommercialProperty"] = 982] = "LessorsOfCommercialProperty";
    NAICS[NAICS["OfficesOfRealEstateAgentsAndBrokers"] = 983] = "OfficesOfRealEstateAgentsAndBrokers";
    NAICS[NAICS["ResidentialPropertyManagers"] = 984] = "ResidentialPropertyManagers";
    NAICS[NAICS["NonresidentialPropertyManagers"] = 985] = "NonresidentialPropertyManagers";
    NAICS[NAICS["OfficesOfRealEstateAppraisers"] = 986] = "OfficesOfRealEstateAppraisers";
    NAICS[NAICS["ActivitiesRelatedToRealEstate"] = 987] = "ActivitiesRelatedToRealEstate";
    NAICS[NAICS["TitleAbstractAndSettlementOffices"] = 988] = "TitleAbstractAndSettlementOffices";
    NAICS[NAICS["LAndSubdivision"] = 989] = "LAndSubdivision";
    NAICS[NAICS["OfficesOfBankHoldingCompanies"] = 990] = "OfficesOfBankHoldingCompanies";
    NAICS[NAICS["OfficesOfHoldingCompanies"] = 991] = "OfficesOfHoldingCompanies";
    NAICS[NAICS["OpenEndInvestmentFunds"] = 992] = "OpenEndInvestmentFunds";
    NAICS[NAICS["GrantMakingFoundations"] = 993] = "GrantMakingFoundations";
    NAICS[NAICS["TrustsEstatesAndAgencyAccounts"] = 994] = "TrustsEstatesAndAgencyAccounts";
    NAICS[NAICS["RealEstateInvestmentTrusts"] = 995] = "RealEstateInvestmentTrusts";
    NAICS[NAICS["CasinoHotels"] = 996] = "CasinoHotels";
    NAICS[NAICS["BedAndBreakfastInns"] = 997] = "BedAndBreakfastInns";
    NAICS[NAICS["TravelerAccommodation"] = 998] = "TravelerAccommodation";
    NAICS[NAICS["RecreationalAndVacationCamps"] = 999] = "RecreationalAndVacationCamps";
    NAICS[NAICS["RVRecreationalVehicleParksAndCampgrounds"] = 1000] = "RVRecreationalVehicleParksAndCampgrounds";
    NAICS[NAICS["CoinOperatedLaundriesAndDryCleaners"] = 1001] = "CoinOperatedLaundriesAndDryCleaners";
    NAICS[NAICS["CarpetAndUpholsteryCleaningServices"] = 1002] = "CarpetAndUpholsteryCleaningServices";
    NAICS[NAICS["IndustrialLaunderers"] = 1003] = "IndustrialLaunderers";
    NAICS[NAICS["PhotographyStudiosPortrait"] = 1004] = "PhotographyStudiosPortrait";
    NAICS[NAICS["BeautySalons"] = 1005] = "BeautySalons";
    NAICS[NAICS["NailSalons"] = 1006] = "NailSalons";
    NAICS[NAICS["BarberShops"] = 1007] = "BarberShops";
    NAICS[NAICS["FuneralHomesAndFuneralServices"] = 1008] = "FuneralHomesAndFuneralServices";
    NAICS[NAICS["TaxPreparationServices"] = 1009] = "TaxPreparationServices";
    NAICS[NAICS["DietAndWeightReducingCenters"] = 1010] = "DietAndWeightReducingCenters";
    NAICS[NAICS["PersonalCareServices"] = 1011] = "PersonalCareServices";
    NAICS[NAICS["AdvertisingAgencies"] = 1012] = "AdvertisingAgencies";
    NAICS[NAICS["MediaRepresentatives"] = 1013] = "MediaRepresentatives";
    NAICS[NAICS["MediaBuyingAgencies"] = 1014] = "MediaBuyingAgencies";
    NAICS[NAICS["CreditBureaus"] = 1015] = "CreditBureaus";
    NAICS[NAICS["DirectMailAdvertising"] = 1016] = "DirectMailAdvertising";
    NAICS[NAICS["CourtReportingAndStenotypeServices"] = 1017] = "CourtReportingAndStenotypeServices";
    NAICS[NAICS["HomeHealthEquipmentRental"] = 1018] = "HomeHealthEquipmentRental";
    NAICS[NAICS["ConsumerElectronicsAndAppliancesRental"] = 1019] = "ConsumerElectronicsAndAppliancesRental";
    NAICS[NAICS["OneHourPhotofinishing"] = 1020] = "OneHourPhotofinishing";
    NAICS[NAICS["ConsumerGoodsRental"] = 1021] = "ConsumerGoodsRental";
    NAICS[NAICS["GeneralRentalCenters"] = 1022] = "GeneralRentalCenters";
    NAICS[NAICS["TemporaryHelpServices"] = 1023] = "TemporaryHelpServices";
    NAICS[NAICS["ProfessionalEmployerOrganizations"] = 1024] = "ProfessionalEmployerOrganizations";
    NAICS[NAICS["CustomComputerProgrammingServices"] = 1025] = "CustomComputerProgrammingServices";
    NAICS[NAICS["SoftwarePublishers"] = 1027] = "SoftwarePublishers";
    NAICS[NAICS["Telecommunications"] = 1028] = "Telecommunications";
    NAICS[NAICS["ComputerFacilitiesManagementServices"] = 1029] = "ComputerFacilitiesManagementServices";
    NAICS[NAICS["ComputerRelatedServices"] = 1030] = "ComputerRelatedServices";
    NAICS[NAICS["InvestigationServices"] = 1031] = "InvestigationServices";
    NAICS[NAICS["SecurityGuardsAndPatrolServices"] = 1032] = "SecurityGuardsAndPatrolServices";
    NAICS[NAICS["ArmoredCarServices"] = 1033] = "ArmoredCarServices";
    NAICS[NAICS["SecuritySystemsServices"] = 1034] = "SecuritySystemsServices";
    NAICS[NAICS["NewsSyndicates"] = 1035] = "NewsSyndicates";
    NAICS[NAICS["PhotofinishingLaboratories"] = 1036] = "PhotofinishingLaboratories";
    NAICS[NAICS["SoundRecordingStudios"] = 1037] = "SoundRecordingStudios";
    NAICS[NAICS["InFormationServices"] = 1038] = "InFormationServices";
    NAICS[NAICS["LegalServices"] = 1039] = "LegalServices";
    NAICS[NAICS["DraftingServices"] = 1040] = "DraftingServices";
    NAICS[NAICS["BuildingInspectionServices"] = 1041] = "BuildingInspectionServices";
    NAICS[NAICS["InteriorDesignServices"] = 1042] = "InteriorDesignServices";
    NAICS[NAICS["IndustrialDesignServices"] = 1043] = "IndustrialDesignServices";
    NAICS[NAICS["SpecializedDesignServices"] = 1044] = "SpecializedDesignServices";
    NAICS[NAICS["TranslationAndInterpretationServices"] = 1045] = "TranslationAndInterpretationServices";
    NAICS[NAICS["TelephoneAnsweringServices"] = 1046] = "TelephoneAnsweringServices";
    NAICS[NAICS["TelemarketingBureausAndContactCenters"] = 1047] = "TelemarketingBureausAndContactCenters";
    NAICS[NAICS["PrivateMailCenters"] = 1048] = "PrivateMailCenters";
    NAICS[NAICS["RepossessionServices"] = 1049] = "RepossessionServices";
    NAICS[NAICS["BusinessSupportServices"] = 1050] = "BusinessSupportServices";
    NAICS[NAICS["ConventionAndVisitorsBureaus"] = 1051] = "ConventionAndVisitorsBureaus";
    NAICS[NAICS["PackagingAndLabelingServices"] = 1052] = "PackagingAndLabelingServices";
    NAICS[NAICS["ConventionAndTradeShowOrganizers"] = 1053] = "ConventionAndTradeShowOrganizers";
    NAICS[NAICS["PassengerCarRental"] = 1054] = "PassengerCarRental";
    NAICS[NAICS["PassengerCarLeasing"] = 1055] = "PassengerCarLeasing";
    NAICS[NAICS["AutomotiveBodyPaintAndInteriorRepairAndMaintenance"] = 1056] = "AutomotiveBodyPaintAndInteriorRepairAndMaintenance";
    NAICS[NAICS["AutomotiveExhaustSystemRepair"] = 1057] = "AutomotiveExhaustSystemRepair";
    NAICS[NAICS["TireRetreading"] = 1058] = "TireRetreading";
    NAICS[NAICS["AutomotiveTransmissionRepair"] = 1059] = "AutomotiveTransmissionRepair";
    NAICS[NAICS["GeneralAutomotiveRepair"] = 1060] = "GeneralAutomotiveRepair";
    NAICS[NAICS["AutomotiveMechanicalAndElectricalRepairAndMaintenance"] = 1061] = "AutomotiveMechanicalAndElectricalRepairAndMaintenance";
    NAICS[NAICS["CarWashes"] = 1062] = "CarWashes";
    NAICS[NAICS["MotorVehicleTowing"] = 1063] = "MotorVehicleTowing";
    NAICS[NAICS["AutomotiveOilChangeAndLubricationShops"] = 1064] = "AutomotiveOilChangeAndLubricationShops";
    NAICS[NAICS["Locksmiths"] = 1065] = "Locksmiths";
    NAICS[NAICS["HomeAndGardenEquipmentRepairAndMaintenance"] = 1066] = "HomeAndGardenEquipmentRepairAndMaintenance";
    NAICS[NAICS["MotionPictureAndVideoProduction"] = 1067] = "MotionPictureAndVideoProduction";
    NAICS[NAICS["TeleproductionAndPostproductionServices"] = 1068] = "TeleproductionAndPostproductionServices";
    NAICS[NAICS["MotionPictureTheaters"] = 1069] = "MotionPictureTheaters";
    NAICS[NAICS["DriveInMotionPictureTheaters"] = 1070] = "DriveInMotionPictureTheaters";
    NAICS[NAICS["VideoTapeAndDiscRental"] = 1071] = "VideoTapeAndDiscRental";
    NAICS[NAICS["DanceCompanies"] = 1072] = "DanceCompanies";
    NAICS[NAICS["MusicalGroupsAndArtists"] = 1073] = "MusicalGroupsAndArtists";
    NAICS[NAICS["BowlingCenters"] = 1074] = "BowlingCenters";
    NAICS[NAICS["SportsTeamsAndClubs"] = 1075] = "SportsTeamsAndClubs";
    NAICS[NAICS["Racetracks"] = 1076] = "Racetracks";
    NAICS[NAICS["AmusementArcades"] = 1077] = "AmusementArcades";
    NAICS[NAICS["AmusementAndThemeParks"] = 1078] = "AmusementAndThemeParks";
    NAICS[NAICS["RecreationalGoodsRental"] = 1079] = "RecreationalGoodsRental";
    NAICS[NAICS["Casinos"] = 1080] = "Casinos";
    NAICS[NAICS["SkiingFacilities"] = 1081] = "SkiingFacilities";
    NAICS[NAICS["HMOMedicalCenters"] = 1082] = "HMOMedicalCenters";
    NAICS[NAICS["FreestandingAmbulatorySurgicalAndEmergencyCenters"] = 1083] = "FreestandingAmbulatorySurgicalAndEmergencyCenters";
    NAICS[NAICS["OfficesOfDentists"] = 1084] = "OfficesOfDentists";
    NAICS[NAICS["OfficesOfChiropractors"] = 1085] = "OfficesOfChiropractors";
    NAICS[NAICS["OfficesOfOptometrists"] = 1086] = "OfficesOfOptometrists";
    NAICS[NAICS["OfficesOfPodiatrists"] = 1087] = "OfficesOfPodiatrists";
    NAICS[NAICS["OfficesOfMentalHealthPractitioners"] = 1088] = "OfficesOfMentalHealthPractitioners";
    NAICS[NAICS["OfficesOfPhysicalOccupationalAndSpeechTherapistsAndAudiologists"] = 1089] = "OfficesOfPhysicalOccupationalAndSpeechTherapistsAndAudiologists";
    NAICS[NAICS["SpecialtyHospitals"] = 1090] = "SpecialtyHospitals";
    NAICS[NAICS["MedicalLaboratories"] = 1091] = "MedicalLaboratories";
    NAICS[NAICS["DiagnosticImagingCenters"] = 1092] = "DiagnosticImagingCenters";
    NAICS[NAICS["DentalLaboratories"] = 1093] = "DentalLaboratories";
    NAICS[NAICS["HomeHealthCareServices"] = 1094] = "HomeHealthCareServices";
    NAICS[NAICS["KidneyDialysisCenters"] = 1095] = "KidneyDialysisCenters";
    NAICS[NAICS["OutpatientMentalHealthAndSubstanceAbuseCenters"] = 1096] = "OutpatientMentalHealthAndSubstanceAbuseCenters";
    NAICS[NAICS["OutpatientCareCenters"] = 1097] = "OutpatientCareCenters";
    NAICS[NAICS["BloodAndOrganBanks"] = 1098] = "BloodAndOrganBanks";
    NAICS[NAICS["MiscellaneousAmbulatoryHealthCareServices"] = 1099] = "MiscellaneousAmbulatoryHealthCareServices";
    NAICS[NAICS["OfficesOfLawyers"] = 1100] = "OfficesOfLawyers";
    NAICS[NAICS["ElementaryAndSecondarySchools"] = 1101] = "ElementaryAndSecondarySchools";
    NAICS[NAICS["CollegesUniversitiesAndProfessionalSchools"] = 1102] = "CollegesUniversitiesAndProfessionalSchools";
    NAICS[NAICS["JuniorColleges"] = 1103] = "JuniorColleges";
    NAICS[NAICS["ComputerTraining"] = 1104] = "ComputerTraining";
    NAICS[NAICS["BusinessAndSecretarialSchools"] = 1105] = "BusinessAndSecretarialSchools";
    NAICS[NAICS["ApprenticeshipTraining"] = 1106] = "ApprenticeshipTraining";
    NAICS[NAICS["ProfessionalAndManagementDevelopmentTraining"] = 1107] = "ProfessionalAndManagementDevelopmentTraining";
    NAICS[NAICS["LanguageSchools"] = 1108] = "LanguageSchools";
    NAICS[NAICS["ExamPreparationAndTutoring"] = 1109] = "ExamPreparationAndTutoring";
    NAICS[NAICS["AutomobileDrivingSchools"] = 1110] = "AutomobileDrivingSchools";
    NAICS[NAICS["ChildAndYouthServices"] = 1111] = "ChildAndYouthServices";
    NAICS[NAICS["ServicesForTheElderlyAndPersonsWithDisabilities"] = 1112] = "ServicesForTheElderlyAndPersonsWithDisabilities";
    NAICS[NAICS["CommunityFoodServices"] = 1113] = "CommunityFoodServices";
    NAICS[NAICS["IndividualAndFamilyServices"] = 1114] = "IndividualAndFamilyServices";
    NAICS[NAICS["TemporaryShelters"] = 1115] = "TemporaryShelters";
    NAICS[NAICS["CommunityHousingServices"] = 1116] = "CommunityHousingServices";
    NAICS[NAICS["EmergencyAndReliefServices"] = 1117] = "EmergencyAndReliefServices";
    NAICS[NAICS["ParoleOfficesAndProbationOffices"] = 1118] = "ParoleOfficesAndProbationOffices";
    NAICS[NAICS["VocationalRehabilitationServices"] = 1119] = "VocationalRehabilitationServices";
    NAICS[NAICS["ChildDayCareServices"] = 1120] = "ChildDayCareServices";
    NAICS[NAICS["ResidentialMentalHealthAndSubstanceAbuseFacilities"] = 1121] = "ResidentialMentalHealthAndSubstanceAbuseFacilities";
    NAICS[NAICS["AssistedLivingFacilitiesForTheElderly"] = 1122] = "AssistedLivingFacilitiesForTheElderly";
    NAICS[NAICS["ResidentialCareFacilities"] = 1123] = "ResidentialCareFacilities";
    NAICS[NAICS["VoluntaryHealthOrganizations"] = 1124] = "VoluntaryHealthOrganizations";
    NAICS[NAICS["GrantMakingAndGivingServices"] = 1125] = "GrantMakingAndGivingServices";
    NAICS[NAICS["HumanRightsOrganizations"] = 1126] = "HumanRightsOrganizations";
    NAICS[NAICS["Museums"] = 1127] = "Museums";
    NAICS[NAICS["HistoricalSites"] = 1128] = "HistoricalSites";
    NAICS[NAICS["ZoosAndBotanicalGardens"] = 1129] = "ZoosAndBotanicalGardens";
    NAICS[NAICS["ProfessionalOrganizations"] = 1130] = "ProfessionalOrganizations";
    NAICS[NAICS["LaborUnionsAndSimilarLaborOrganizations"] = 1131] = "LaborUnionsAndSimilarLaborOrganizations";
    NAICS[NAICS["JusticePublicOrderAndSafetyActivities"] = 1132] = "JusticePublicOrderAndSafetyActivities";
    NAICS[NAICS["PublicFinanceActivities"] = 1133] = "PublicFinanceActivities";
    NAICS[NAICS["AdministrationOfEducationPrograms"] = 1134] = "AdministrationOfEducationPrograms";
    NAICS[NAICS["AdministrationOfPublicHealthPrograms"] = 1135] = "AdministrationOfPublicHealthPrograms";
    NAICS[NAICS["AmericanIndianAndAlaskaNativeTribalGovernments"] = 1136] = "AmericanIndianAndAlaskaNativeTribalGovernments";
    NAICS[NAICS["PoliticalOrganizations"] = 1137] = "PoliticalOrganizations";
    NAICS[NAICS["ReligiousOrganizations"] = 1138] = "ReligiousOrganizations";
    NAICS[NAICS["ArchitecturalServices"] = 1139] = "ArchitecturalServices";
    NAICS[NAICS["OfficesOfCertifiedPublicAccountants"] = 1140] = "OfficesOfCertifiedPublicAccountants";
    NAICS[NAICS["AccountingServices"] = 1141] = "AccountingServices";
    NAICS[NAICS["MarketingResearchAndPublicOpinionPolling"] = 1142] = "MarketingResearchAndPublicOpinionPolling";
    NAICS[NAICS["TestingLaboratories"] = 1143] = "TestingLaboratories";
    NAICS[NAICS["OfficeAdministrativeServices"] = 1144] = "OfficeAdministrativeServices";
    NAICS[NAICS["AdministrativeManagementAndGeneralManagementConsultingServices"] = 1145] = "AdministrativeManagementAndGeneralManagementConsultingServices";
    NAICS[NAICS["MarketingConsultingServices"] = 1146] = "MarketingConsultingServices";
    NAICS[NAICS["PublicRelationsAgencies"] = 1147] = "PublicRelationsAgencies";
    NAICS[NAICS["FacilitiesSupportServices"] = 1148] = "FacilitiesSupportServices";
    NAICS[NAICS["ManagementConsultingServices"] = 1149] = "ManagementConsultingServices";
    NAICS[NAICS["PrivateHouseholds"] = 1150] = "PrivateHouseholds";
    NAICS[NAICS["InternetPublishingAndBroadcastingAndWebSearchPortals"] = 1152] = "InternetPublishingAndBroadcastingAndWebSearchPortals";
    NAICS[NAICS["EnvironmentalConsultingServices"] = 1153] = "EnvironmentalConsultingServices";
    NAICS[NAICS["ExecutiveOffices"] = 1154] = "ExecutiveOffices";
    NAICS[NAICS["LegislativeBodies"] = 1155] = "LegislativeBodies";
    NAICS[NAICS["ExecutiveAndLegislativeOfficesCombined"] = 1156] = "ExecutiveAndLegislativeOfficesCombined";
    NAICS[NAICS["GeneralGovernmentSupport"] = 1157] = "GeneralGovernmentSupport";
    NAICS[NAICS["Courts"] = 1158] = "Courts";
    NAICS[NAICS["PoliceProtection"] = 1159] = "PoliceProtection";
    NAICS[NAICS["LegalCounselAndProsecution"] = 1160] = "LegalCounselAndProsecution";
    NAICS[NAICS["CorrectionalInstitutions"] = 1161] = "CorrectionalInstitutions";
    NAICS[NAICS["FireProtection"] = 1162] = "FireProtection";
    NAICS[NAICS["AdministrationOfHumanResourceProgramsExceptEducationPublicHealthAndVeteransAffairsPrograms"] = 1163] = "AdministrationOfHumanResourceProgramsExceptEducationPublicHealthAndVeteransAffairsPrograms";
    NAICS[NAICS["AdministrationOfVeteransAffairs"] = 1164] = "AdministrationOfVeteransAffairs";
    NAICS[NAICS["AdministrationOfAirAndWaterResourceAndSolidWasteManagementPrograms"] = 1165] = "AdministrationOfAirAndWaterResourceAndSolidWasteManagementPrograms";
    NAICS[NAICS["AdministrationOfConservationPrograms"] = 1166] = "AdministrationOfConservationPrograms";
    NAICS[NAICS["AdministrationOfHousingPrograms"] = 1167] = "AdministrationOfHousingPrograms";
    NAICS[NAICS["AdministrationOfUrbanPlanningAndCommunityAndRuralDevelopment"] = 1168] = "AdministrationOfUrbanPlanningAndCommunityAndRuralDevelopment";
    NAICS[NAICS["AdministrationOfGeneralEconomicPrograms"] = 1169] = "AdministrationOfGeneralEconomicPrograms";
    NAICS[NAICS["RegulationAndAdministrationOfTransportationPrograms"] = 1170] = "RegulationAndAdministrationOfTransportationPrograms";
    NAICS[NAICS["RegulationAndAdministrationOfCommunicationsElectricGasAndOtherUtilities"] = 1171] = "RegulationAndAdministrationOfCommunicationsElectricGasAndOtherUtilities";
    NAICS[NAICS["RegulationOfAgriculturalMarketingAndCommodities"] = 1172] = "RegulationOfAgriculturalMarketingAndCommodities";
    NAICS[NAICS["RegulationLicensingAndInspectionOfCommercialSectors"] = 1173] = "RegulationLicensingAndInspectionOfCommercialSectors";
    NAICS[NAICS["SpaceResearchAndTechnology"] = 1174] = "SpaceResearchAndTechnology";
    NAICS[NAICS["NationalSecurity"] = 1175] = "NationalSecurity";
    NAICS[NAICS["InternationalAffairs"] = 1176] = "InternationalAffairs";
    NAICS[NAICS["DualPurposeCattleRanchingAndFarming"] = 1177] = "DualPurposeCattleRanchingAndFarming";
    NAICS[NAICS["SolarElectricPowerGeneration"] = 1178] = "SolarElectricPowerGeneration";
    NAICS[NAICS["WindElectricPowerGeneration"] = 1179] = "WindElectricPowerGeneration";
    NAICS[NAICS["GeothermalElectricPowerGeneration"] = 1180] = "GeothermalElectricPowerGeneration";
    NAICS[NAICS["BiomassElectricPowerGeneration"] = 1181] = "BiomassElectricPowerGeneration";
    NAICS[NAICS["CutAndSewApparelContractors"] = 1183] = "CutAndSewApparelContractors";
    NAICS[NAICS["OfficesOfNotaries"] = 1184] = "OfficesOfNotaries";
    NAICS[NAICS["ResearchAndDevelopmentInNanotechnology"] = 1185] = "ResearchAndDevelopmentInNanotechnology";
    NAICS[NAICS["ResearchAndDevelopmentInBiotechnology"] = 1186] = "ResearchAndDevelopmentInBiotechnology";
    NAICS[NAICS["CorporateSubsidiaryAndRegionalManagingOffices"] = 1187] = "CorporateSubsidiaryAndRegionalManagingOffices";
    NAICS[NAICS["ExecutiveSearchServices"] = 1188] = "ExecutiveSearchServices";
})(NAICS || (NAICS = {}));
/** CoStar.Api.SuiteDetail.Types.OfficeType */
export var OfficeType;
(function (OfficeType) {
    OfficeType[OfficeType["None"] = 0] = "None";
    OfficeType[OfficeType["MainHeadQuarters"] = 1] = "MainHeadQuarters";
    OfficeType[OfficeType["DivisionalHeadQuarters"] = 2] = "DivisionalHeadQuarters";
    OfficeType[OfficeType["CorporateOffice"] = 3] = "CorporateOffice";
    OfficeType[OfficeType["Franchise"] = 4] = "Franchise";
    OfficeType[OfficeType["SingleLocation"] = 5] = "SingleLocation";
    OfficeType[OfficeType["RetailStoreBranch"] = 6] = "RetailStoreBranch";
    OfficeType[OfficeType["Warehouse"] = 7] = "Warehouse";
    OfficeType[OfficeType["OnSitePropertyManagementNoOccupancy"] = 8] = "OnSitePropertyManagementNoOccupancy";
})(OfficeType || (OfficeType = {}));
import { CompanyType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteDetail.Types.CompanyType */
export { CompanyType };
import { AreaType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteDetail.Types.AreaType */
export { AreaType };
/** CoStar.Api.SuiteDetail.Types.OrganizationType */
export var OrganizationType;
(function (OrganizationType) {
    OrganizationType[OrganizationType["None"] = 0] = "None";
    OrganizationType[OrganizationType["CorpLlc"] = 1] = "CorpLlc";
    OrganizationType[OrganizationType["PartnershipLlp"] = 2] = "PartnershipLlp";
    OrganizationType[OrganizationType["Nonprofit"] = 3] = "Nonprofit";
    OrganizationType[OrganizationType["SoleProp"] = 4] = "SoleProp";
    OrganizationType[OrganizationType["Government"] = 5] = "Government";
    OrganizationType[OrganizationType["Association"] = 6] = "Association";
})(OrganizationType || (OrganizationType = {}));
/** CoStar.Api.SuiteDetail.Types.SpaceType */
export var SpaceType;
(function (SpaceType) {
    SpaceType[SpaceType["Default"] = 0] = "Default";
    SpaceType[SpaceType["Relet"] = 1] = "Relet";
    SpaceType[SpaceType["New"] = 2] = "New";
    SpaceType[SpaceType["Sublet"] = 3] = "Sublet";
    SpaceType[SpaceType["Assignment"] = 4] = "Assignment";
    SpaceType[SpaceType["Coworking"] = 9] = "Coworking";
})(SpaceType || (SpaceType = {}));
/** CoStar.Api.SuiteDetail.Types.LeaseDealType */
export var LeaseDealType;
(function (LeaseDealType) {
    LeaseDealType[LeaseDealType["Original"] = 1] = "Original";
    LeaseDealType[LeaseDealType["Renewed"] = 2] = "Renewed";
})(LeaseDealType || (LeaseDealType = {}));
/** CoStar.Api.SuiteDetail.Types.LeaseDealSourceType */
export var LeaseDealSourceType;
(function (LeaseDealSourceType) {
    LeaseDealSourceType[LeaseDealSourceType["None"] = 0] = "None";
    LeaseDealSourceType[LeaseDealSourceType["PublicRecordFOIA"] = 1] = "PublicRecordFOIA";
    LeaseDealSourceType[LeaseDealSourceType["PublicRecordSECfiling"] = 2] = "PublicRecordSECfiling";
    LeaseDealSourceType[LeaseDealSourceType["PublicRecordCMBSfiling"] = 3] = "PublicRecordCMBSfiling";
    LeaseDealSourceType[LeaseDealSourceType["DirectNewsOutlets"] = 6] = "DirectNewsOutlets";
    LeaseDealSourceType[LeaseDealSourceType["MediaLandlordRep"] = 7] = "MediaLandlordRep";
    LeaseDealSourceType[LeaseDealSourceType["PublicRecordLandlord"] = 8] = "PublicRecordLandlord";
    LeaseDealSourceType[LeaseDealSourceType["MediaTenantRep"] = 9] = "MediaTenantRep";
    LeaseDealSourceType[LeaseDealSourceType["PublicRecordTenant"] = 12] = "PublicRecordTenant";
    LeaseDealSourceType[LeaseDealSourceType["PublicRecordPressRelease"] = 14] = "PublicRecordPressRelease";
    LeaseDealSourceType[LeaseDealSourceType["ThrirdPartyCountyFiling"] = 15] = "ThrirdPartyCountyFiling";
    LeaseDealSourceType[LeaseDealSourceType["ThirdPartyOther"] = 16] = "ThirdPartyOther";
    LeaseDealSourceType[LeaseDealSourceType["MediaAppraiser"] = 17] = "MediaAppraiser";
    LeaseDealSourceType[LeaseDealSourceType["MediaPressRelease"] = 18] = "MediaPressRelease";
    LeaseDealSourceType[LeaseDealSourceType["MediaPropertyManager"] = 19] = "MediaPropertyManager";
    LeaseDealSourceType[LeaseDealSourceType["MediaOther"] = 20] = "MediaOther";
    LeaseDealSourceType[LeaseDealSourceType["PublicRecordPowerBrokerSubmission"] = 21] = "PublicRecordPowerBrokerSubmission";
    LeaseDealSourceType[LeaseDealSourceType["ThirdPartyHMLandRegistry"] = 26] = "ThirdPartyHMLandRegistry";
})(LeaseDealSourceType || (LeaseDealSourceType = {}));
/** CoStar.Api.SuiteDetail.Types.ListingType */
export var ListingType;
(function (ListingType) {
    ListingType[ListingType["None"] = 0] = "None";
    ListingType[ListingType["PropertyForSale"] = 9] = "PropertyForSale";
    ListingType[ListingType["ResidentialPropertyForSale"] = 10] = "ResidentialPropertyForSale";
    ListingType[ListingType["CondoForSale"] = 11] = "CondoForSale";
    ListingType[ListingType["LandForSale"] = 12] = "LandForSale";
    ListingType[ListingType["CommercialPortfolioForSale"] = 13] = "CommercialPortfolioForSale";
    ListingType[ListingType["PropertyDirectSpaceForLease"] = 14] = "PropertyDirectSpaceForLease";
    ListingType[ListingType["ConsolidatedCondoForSale"] = 15] = "ConsolidatedCondoForSale";
    ListingType[ListingType["BuildingParkDirectSpaceLease"] = 16] = "BuildingParkDirectSpaceLease";
    ListingType[ListingType["ShoppingCenterDirectSpaceForLease"] = 17] = "ShoppingCenterDirectSpaceForLease";
    ListingType[ListingType["LandDirectForLease"] = 18] = "LandDirectForLease";
    ListingType[ListingType["CommercialSublease"] = 19] = "CommercialSublease";
    ListingType[ListingType["CommercialLeaseAssignment"] = 20] = "CommercialLeaseAssignment";
    ListingType[ListingType["PropertyCoworking"] = 21] = "PropertyCoworking";
    ListingType[ListingType["PropertyForAuction"] = 22] = "PropertyForAuction";
    ListingType[ListingType["LandForAuction"] = 23] = "LandForAuction";
    ListingType[ListingType["CondoForAuction"] = 24] = "CondoForAuction";
    ListingType[ListingType["PropertyLoanForAuction"] = 25] = "PropertyLoanForAuction";
    ListingType[ListingType["CommercialPortfolioForAuction"] = 26] = "CommercialPortfolioForAuction";
    ListingType[ListingType["DisconnectedForSale"] = 27] = "DisconnectedForSale";
    ListingType[ListingType["DisconnectedSpaceForLease"] = 28] = "DisconnectedSpaceForLease";
})(ListingType || (ListingType = {}));
/** CoStar.Api.SuiteDetail.Types.Exposure */
export var Exposure;
(function (Exposure) {
    Exposure[Exposure["Base"] = 1] = "Base";
    Exposure[Exposure["Obfuscated"] = 2] = "Obfuscated";
    Exposure[Exposure["Disconnected"] = 3] = "Disconnected";
})(Exposure || (Exposure = {}));
/** CoStar.Api.SuiteDetail.Types.AttachmentType */
export var AttachmentType;
(function (AttachmentType) {
    AttachmentType[AttachmentType["None"] = 0] = "None";
    AttachmentType[AttachmentType["Aerial"] = 1] = "Aerial";
    AttachmentType[AttachmentType["Financial"] = 2] = "Financial";
    AttachmentType[AttachmentType["PrimaryPhoto"] = 3] = "PrimaryPhoto";
    AttachmentType[AttachmentType["BuildingPhoto"] = 4] = "BuildingPhoto";
    AttachmentType[AttachmentType["VirtualTour"] = 5] = "VirtualTour";
    AttachmentType[AttachmentType["Lobby"] = 6] = "Lobby";
    AttachmentType[AttachmentType["Other"] = 7] = "Other";
    AttachmentType[AttachmentType["MarketingBrochureFlyer"] = 8] = "MarketingBrochureFlyer";
    AttachmentType[AttachmentType["PlatMap"] = 9] = "PlatMap";
    AttachmentType[AttachmentType["FloorPlan"] = 10] = "FloorPlan";
    AttachmentType[AttachmentType["SitePlan"] = 11] = "SitePlan";
    AttachmentType[AttachmentType["TypicalFloorPlan"] = 12] = "TypicalFloorPlan";
    AttachmentType[AttachmentType["Slate"] = 13] = "Slate";
    AttachmentType[AttachmentType["PrimaryContactPhoto"] = 14] = "PrimaryContactPhoto";
    AttachmentType[AttachmentType["Logo"] = 15] = "Logo";
    AttachmentType[AttachmentType["Map"] = 16] = "Map";
    AttachmentType[AttachmentType["SixteenBySixteenPNG"] = 17] = "SixteenBySixteenPNG";
    AttachmentType[AttachmentType["TwentyFourByTwentyFourPNG"] = 18] = "TwentyFourByTwentyFourPNG";
    AttachmentType[AttachmentType["TenantPhoto"] = 19] = "TenantPhoto";
    AttachmentType[AttachmentType["LeaseDocument"] = 20] = "LeaseDocument";
    AttachmentType[AttachmentType["PublicFiling"] = 21] = "PublicFiling";
    AttachmentType[AttachmentType["Deed"] = 22] = "Deed";
    AttachmentType[AttachmentType["TransferTaxDeclaration"] = 23] = "TransferTaxDeclaration";
    AttachmentType[AttachmentType["PropertyRecordCard"] = 24] = "PropertyRecordCard";
    AttachmentType[AttachmentType["AssignmentOfRentsAndLeases"] = 25] = "AssignmentOfRentsAndLeases";
    AttachmentType[AttachmentType["Loan"] = 26] = "Loan";
    AttachmentType[AttachmentType["Article"] = 27] = "Article";
    AttachmentType[AttachmentType["PressRelease"] = 28] = "PressRelease";
    AttachmentType[AttachmentType["SECFiling"] = 29] = "SECFiling";
    AttachmentType[AttachmentType["CompanyReport"] = 30] = "CompanyReport";
    AttachmentType[AttachmentType["MediaSource"] = 31] = "MediaSource";
    AttachmentType[AttachmentType["DirectoryPhoto"] = 32] = "DirectoryPhoto";
    AttachmentType[AttachmentType["InteriorPhoto"] = 33] = "InteriorPhoto";
    AttachmentType[AttachmentType["GoadMap"] = 34] = "GoadMap";
    AttachmentType[AttachmentType["CommunityBrochure"] = 35] = "CommunityBrochure";
    AttachmentType[AttachmentType["PlacardLogo"] = 36] = "PlacardLogo";
    AttachmentType[AttachmentType["PropertyLogo"] = 37] = "PropertyLogo";
    AttachmentType[AttachmentType["ConstructionPhoto"] = 38] = "ConstructionPhoto";
    AttachmentType[AttachmentType["ReinforcingAdvertisement"] = 39] = "ReinforcingAdvertisement";
    AttachmentType[AttachmentType["ProVideoApartments"] = 40] = "ProVideoApartments";
    AttachmentType[AttachmentType["CityPhoto"] = 41] = "CityPhoto";
    AttachmentType[AttachmentType["NeighborhoodPhoto"] = 42] = "NeighborhoodPhoto";
    AttachmentType[AttachmentType["Matterport3DScan"] = 43] = "Matterport3DScan";
    AttachmentType[AttachmentType["ProVideoApartmentFinder"] = 44] = "ProVideoApartmentFinder";
    AttachmentType[AttachmentType["ConfidentialityAgreement"] = 45] = "ConfidentialityAgreement";
    AttachmentType[AttachmentType["ProVideoApartamentos"] = 46] = "ProVideoApartamentos";
    AttachmentType[AttachmentType["CommercialListingVideo"] = 47] = "CommercialListingVideo";
    AttachmentType[AttachmentType["MarketingLogo"] = 48] = "MarketingLogo";
    AttachmentType[AttachmentType["ProVideoLoopNet"] = 49] = "ProVideoLoopNet";
    AttachmentType[AttachmentType["State"] = 50] = "State";
    AttachmentType[AttachmentType["County"] = 51] = "County";
    AttachmentType[AttachmentType["MilitaryBase"] = 52] = "MilitaryBase";
    AttachmentType[AttachmentType["CollegeUniversity"] = 53] = "CollegeUniversity";
    AttachmentType[AttachmentType["ArticleVideo"] = 54] = "ArticleVideo";
    AttachmentType[AttachmentType["AerialVideo"] = 55] = "AerialVideo";
    AttachmentType[AttachmentType["ThermalVideo"] = 56] = "ThermalVideo";
    AttachmentType[AttachmentType["UAVVideo"] = 57] = "UAVVideo";
    AttachmentType[AttachmentType["ProVideoForRent"] = 58] = "ProVideoForRent";
    AttachmentType[AttachmentType["PlacardPrimaryPhoto"] = 59] = "PlacardPrimaryPhoto";
    AttachmentType[AttachmentType["ShortUAVVideo"] = 60] = "ShortUAVVideo";
    AttachmentType[AttachmentType["PlacardLogoVector"] = 61] = "PlacardLogoVector";
    AttachmentType[AttachmentType["CoStarPlaneView"] = 62] = "CoStarPlaneView";
    AttachmentType[AttachmentType["DesktopCoverPhotoResidential"] = 63] = "DesktopCoverPhotoResidential";
    AttachmentType[AttachmentType["PlacardHighlightPhoto"] = 64] = "PlacardHighlightPhoto";
    AttachmentType[AttachmentType["PlacardHighlightVideo"] = 65] = "PlacardHighlightVideo";
    AttachmentType[AttachmentType["AmenityPhoto"] = 66] = "AmenityPhoto";
    AttachmentType[AttachmentType["AmenityVideo"] = 67] = "AmenityVideo";
    AttachmentType[AttachmentType["MobileCoverPhotoResidential"] = 68] = "MobileCoverPhotoResidential";
    AttachmentType[AttachmentType["DesktopCoverPhotoCommercial"] = 69] = "DesktopCoverPhotoCommercial";
    AttachmentType[AttachmentType["MobileCoverPhotoCommercial"] = 70] = "MobileCoverPhotoCommercial";
    AttachmentType[AttachmentType["LandRegistry"] = 71] = "LandRegistry";
    AttachmentType[AttachmentType["CollegeLogo"] = 72] = "CollegeLogo";
    AttachmentType[AttachmentType["TenantExternalPhoto"] = 73] = "TenantExternalPhoto";
    AttachmentType[AttachmentType["TenantInternalPhoto"] = 74] = "TenantInternalPhoto";
    AttachmentType[AttachmentType["PylonPhoto"] = 75] = "PylonPhoto";
    AttachmentType[AttachmentType["StockPhoto"] = 76] = "StockPhoto";
    AttachmentType[AttachmentType["CoverPagePhoto"] = 77] = "CoverPagePhoto";
    AttachmentType[AttachmentType["SpaceManagerPhoto"] = 78] = "SpaceManagerPhoto";
    AttachmentType[AttachmentType["ResidentialListingVideo"] = 79] = "ResidentialListingVideo";
    AttachmentType[AttachmentType["OfferingMemorandum"] = 80] = "OfferingMemorandum";
    AttachmentType[AttachmentType["BrandExteriorPhoto"] = 81] = "BrandExteriorPhoto";
    AttachmentType[AttachmentType["BrandInteriorPhoto"] = 82] = "BrandInteriorPhoto";
    AttachmentType[AttachmentType["NeighborhoodVideo"] = 83] = "NeighborhoodVideo";
    AttachmentType[AttachmentType["NeighborhoodVideoClip"] = 84] = "NeighborhoodVideoClip";
    AttachmentType[AttachmentType["ParkVideo"] = 85] = "ParkVideo";
    AttachmentType[AttachmentType["ParkVideoClip"] = 86] = "ParkVideoClip";
    AttachmentType[AttachmentType["SchoolVideo"] = 87] = "SchoolVideo";
    AttachmentType[AttachmentType["SchoolVideoClip"] = 88] = "SchoolVideoClip";
    AttachmentType[AttachmentType["CondoBuildingVideo"] = 89] = "CondoBuildingVideo";
    AttachmentType[AttachmentType["CondoBuildingVideoClip"] = 90] = "CondoBuildingVideoClip";
    AttachmentType[AttachmentType["VideoProjectFile"] = 91] = "VideoProjectFile";
    AttachmentType[AttachmentType["AudioFile"] = 92] = "AudioFile";
    AttachmentType[AttachmentType["ProductionScript"] = 93] = "ProductionScript";
    AttachmentType[AttachmentType["ParkPhoto"] = 94] = "ParkPhoto";
    AttachmentType[AttachmentType["SchoolPhoto"] = 95] = "SchoolPhoto";
    AttachmentType[AttachmentType["CaseDocument"] = 96] = "CaseDocument";
    AttachmentType[AttachmentType["ViewFromUnit"] = 97] = "ViewFromUnit";
    AttachmentType[AttachmentType["AgentVideo"] = 98] = "AgentVideo";
    AttachmentType[AttachmentType["AgentVideoClip"] = 99] = "AgentVideoClip";
    AttachmentType[AttachmentType["StockVideo"] = 100] = "StockVideo";
    AttachmentType[AttachmentType["RetailBrandRequirement"] = 101] = "RetailBrandRequirement";
    AttachmentType[AttachmentType["NeighborhoodEventPhoto"] = 102] = "NeighborhoodEventPhoto";
})(AttachmentType || (AttachmentType = {}));
/** CoStar.Api.SuiteDetail.Types.ListingLinkType */
export var ListingLinkType;
(function (ListingLinkType) {
    ListingLinkType[ListingLinkType["None"] = 0] = "None";
    ListingLinkType[ListingLinkType["ExternalListing"] = 1] = "ExternalListing";
    ListingLinkType[ListingLinkType["PropertyManager"] = 2] = "PropertyManager";
    ListingLinkType[ListingLinkType["VanityUrl"] = 3] = "VanityUrl";
    ListingLinkType[ListingLinkType["FinderSitesUrl"] = 4] = "FinderSitesUrl";
})(ListingLinkType || (ListingLinkType = {}));
/** CoStar.Api.SuiteDetail.Types.SpaceRateType */
export var SpaceRateType;
(function (SpaceRateType) {
    SpaceRateType[SpaceRateType["None"] = 0] = "None";
    SpaceRateType[SpaceRateType["Office"] = 1] = "Office";
    SpaceRateType[SpaceRateType["Industrial"] = 2] = "Industrial";
    SpaceRateType[SpaceRateType["Laboratory"] = 3] = "Laboratory";
    SpaceRateType[SpaceRateType["Showroom"] = 4] = "Showroom";
    SpaceRateType[SpaceRateType["Shell"] = 5] = "Shell";
    SpaceRateType[SpaceRateType["OtherSalesArea"] = 6] = "OtherSalesArea";
    SpaceRateType[SpaceRateType["AncillarySpace"] = 7] = "AncillarySpace";
    SpaceRateType[SpaceRateType["MainSalesArea"] = 8] = "MainSalesArea";
})(SpaceRateType || (SpaceRateType = {}));
import { AvailabilityType } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.AvailabilityType */
export { AvailabilityType };
/** CoStar.Api.SuiteDetail.Types.LeaseTermType */
export var LeaseTermType;
(function (LeaseTermType) {
    LeaseTermType[LeaseTermType["None"] = 0] = "None";
    LeaseTermType[LeaseTermType["Years"] = 1] = "Years";
    LeaseTermType[LeaseTermType["Months"] = 2] = "Months";
    LeaseTermType[LeaseTermType["Days"] = 3] = "Days";
    LeaseTermType[LeaseTermType["ToBeDetermined"] = 4] = "ToBeDetermined";
    LeaseTermType[LeaseTermType["Negotiable"] = 5] = "Negotiable";
})(LeaseTermType || (LeaseTermType = {}));
/** CoStar.Api.SuiteDetail.Types.ValueAddedTaxType */
export var ValueAddedTaxType;
(function (ValueAddedTaxType) {
    ValueAddedTaxType[ValueAddedTaxType["None"] = 0] = "None";
    ValueAddedTaxType[ValueAddedTaxType["ChargesIncluded"] = 1] = "ChargesIncluded";
    ValueAddedTaxType[ValueAddedTaxType["ChargesTaxesExcluded"] = 2] = "ChargesTaxesExcluded";
    ValueAddedTaxType[ValueAddedTaxType["ChargesTaxesIncluded"] = 3] = "ChargesTaxesIncluded";
})(ValueAddedTaxType || (ValueAddedTaxType = {}));
/** CoStar.Api.SuiteDetail.Types.BuildingClass */
export var BuildingClass;
(function (BuildingClass) {
    BuildingClass[BuildingClass["None"] = 0] = "None";
    BuildingClass[BuildingClass["A"] = 1] = "A";
    BuildingClass[BuildingClass["B"] = 2] = "B";
    BuildingClass[BuildingClass["C"] = 3] = "C";
    BuildingClass[BuildingClass["F"] = 4] = "F";
})(BuildingClass || (BuildingClass = {}));
/** CoStar.Api.SuiteDetail.Types.MandateType */
export var MandateType;
(function (MandateType) {
    MandateType[MandateType["None"] = 0] = "None";
    MandateType[MandateType["Exclusive"] = 1] = "Exclusive";
    MandateType[MandateType["CoExclusive"] = 2] = "CoExclusive";
    MandateType[MandateType["Simple"] = 3] = "Simple";
})(MandateType || (MandateType = {}));
/** CoStar.Api.SuiteDetail.Types.MultipleSourceFields */
export var MultipleSourceFields;
(function (MultipleSourceFields) {
    MultipleSourceFields[MultipleSourceFields["City"] = 1] = "City";
    MultipleSourceFields[MultipleSourceFields["BuildingClassCode"] = 2] = "BuildingClassCode";
    MultipleSourceFields[MultipleSourceFields["TrueOwnerName"] = 3] = "TrueOwnerName";
    MultipleSourceFields[MultipleSourceFields["PropertyManagerName"] = 4] = "PropertyManagerName";
    MultipleSourceFields[MultipleSourceFields["ConstructionStatus"] = 5] = "ConstructionStatus";
    MultipleSourceFields[MultipleSourceFields["Terms"] = 6] = "Terms";
    MultipleSourceFields[MultipleSourceFields["ForSaleStatus"] = 7] = "ForSaleStatus";
})(MultipleSourceFields || (MultipleSourceFields = {}));
import { ApartmentMeteringType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.ApartmentMeteringType */
export { ApartmentMeteringType };
import { ApartmentOwnershipType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.ApartmentOwnershipType */
export { ApartmentOwnershipType };
import { ApartmentRoofType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.ApartmentRoofType */
export { ApartmentRoofType };
import { SidingType } from "../../../../CoStar/Api/ExternalApi/ViewModels/Suite/index.js";
/** CoStar.Api.SuiteDetail.Types.SidingType */
export { SidingType };
/** CoStar.Api.SuiteDetail.Types.NoteType */
export var NoteType;
(function (NoteType) {
    NoteType[NoteType["None"] = 0] = "None";
    NoteType[NoteType["PropertyInternal"] = 1] = "PropertyInternal";
    NoteType[NoteType["PropertyExternal"] = 2] = "PropertyExternal";
    NoteType[NoteType["SaleExternal"] = 3] = "SaleExternal";
    NoteType[NoteType["CommissionNote"] = 4] = "CommissionNote";
    NoteType[NoteType["TenantExternal"] = 5] = "TenantExternal";
    NoteType[NoteType["TenantInternal"] = 6] = "TenantInternal";
    NoteType[NoteType["TenantTransactionInternal"] = 7] = "TenantTransactionInternal";
    NoteType[NoteType["SpaceNote"] = 8] = "SpaceNote";
    NoteType[NoteType["SpaceVacantInternal"] = 9] = "SpaceVacantInternal";
    NoteType[NoteType["SupplementalExternal"] = 10] = "SupplementalExternal";
    NoteType[NoteType["LocationInternal"] = 14] = "LocationInternal";
    NoteType[NoteType["LocationExternal"] = 15] = "LocationExternal";
    NoteType[NoteType["LocationBilling"] = 16] = "LocationBilling";
    NoteType[NoteType["CompExternal"] = 25] = "CompExternal";
    NoteType[NoteType["CompInternal"] = 26] = "CompInternal";
    NoteType[NoteType["CompSeller"] = 27] = "CompSeller";
    NoteType[NoteType["CompBuyer"] = 28] = "CompBuyer";
    NoteType[NoteType["CompManager"] = 29] = "CompManager";
    NoteType[NoteType["PropertyGroupExternal"] = 30] = "PropertyGroupExternal";
    NoteType[NoteType["PropertyGroupInternal"] = 31] = "PropertyGroupInternal";
    NoteType[NoteType["LeaseDealInternal"] = 32] = "LeaseDealInternal";
    NoteType[NoteType["LeaseDealExternal"] = 33] = "LeaseDealExternal";
    NoteType[NoteType["LandLease"] = 34] = "LandLease";
    NoteType[NoteType["LandLeaseCommission"] = 35] = "LandLeaseCommission";
    NoteType[NoteType["CompEntityInternal"] = 36] = "CompEntityInternal";
    NoteType[NoteType["CompEntityExternal"] = 37] = "CompEntityExternal";
    NoteType[NoteType["PropertyLoan"] = 38] = "PropertyLoan";
    NoteType[NoteType["PropertyResidentialExternal"] = 39] = "PropertyResidentialExternal";
    NoteType[NoteType["ListingExternal"] = 40] = "ListingExternal";
    NoteType[NoteType["AptsSalesForceNote"] = 41] = "AptsSalesForceNote";
    NoteType[NoteType["WhyYouLoveUs"] = 42] = "WhyYouLoveUs";
    NoteType[NoteType["CheckICheckOutPolicy"] = 43] = "CheckICheckOutPolicy";
    NoteType[NoteType["PaymentPolicy"] = 44] = "PaymentPolicy";
    NoteType[NoteType["AdvancedPaymentPolicy"] = 45] = "AdvancedPaymentPolicy";
    NoteType[NoteType["CancellationPolicy"] = 46] = "CancellationPolicy";
    NoteType[NoteType["ListingLocationDescription"] = 47] = "ListingLocationDescription";
    NoteType[NoteType["ContactExternal"] = 48] = "ContactExternal";
    NoteType[NoteType["ContactInternal"] = 49] = "ContactInternal";
    NoteType[NoteType["ListingExternalGenerated"] = 50] = "ListingExternalGenerated";
    NoteType[NoteType["DrivingDirections"] = 51] = "DrivingDirections";
    NoteType[NoteType["StudentHousingDescription"] = 52] = "StudentHousingDescription";
    NoteType[NoteType["RenterQualification"] = 53] = "RenterQualification";
    NoteType[NoteType["MarketingStakeholder1"] = 54] = "MarketingStakeholder1";
    NoteType[NoteType["MarketingStakeholder2"] = 55] = "MarketingStakeholder2";
    NoteType[NoteType["SpaceManagerDescription"] = 56] = "SpaceManagerDescription";
    NoteType[NoteType["ApartmentUnitMarketingNote"] = 57] = "ApartmentUnitMarketingNote";
    NoteType[NoteType["CMBSLoanCommentary"] = 58] = "CMBSLoanCommentary";
    NoteType[NoteType["CMBSLoanModification"] = 59] = "CMBSLoanModification";
    NoteType[NoteType["CMBSLoanDelinquency"] = 60] = "CMBSLoanDelinquency";
    NoteType[NoteType["CMBSLoanRealEstateOwned"] = 61] = "CMBSLoanRealEstateOwned";
    NoteType[NoteType["CMBSLoanWatchlist"] = 62] = "CMBSLoanWatchlist";
})(NoteType || (NoteType = {}));
import { RentBasis } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.RentBasis */
export { RentBasis };
/** CoStar.Api.SuiteDetail.Types.MoveType */
export var MoveType;
(function (MoveType) {
    MoveType[MoveType["None"] = 0] = "None";
    MoveType[MoveType["MovingIn"] = 1] = "MovingIn";
    MoveType[MoveType["MovingOut"] = 2] = "MovingOut";
    MoveType[MoveType["InBuildingMove"] = 3] = "InBuildingMove";
})(MoveType || (MoveType = {}));
import { CorridorType } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.CorridorType */
export { CorridorType };
import { HotelClass } from "../../../../CoStar/Api/Listings/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.HotelClass */
export { HotelClass };
/** CoStar.Api.SuiteDetail.Types.HotelLocationType */
export var HotelLocationType;
(function (HotelLocationType) {
    HotelLocationType[HotelLocationType["None"] = 0] = "None";
    HotelLocationType[HotelLocationType["Suburban"] = 1] = "Suburban";
    HotelLocationType[HotelLocationType["Airport"] = 2] = "Airport";
    HotelLocationType[HotelLocationType["Interstate"] = 3] = "Interstate";
    HotelLocationType[HotelLocationType["Resort"] = 4] = "Resort";
    HotelLocationType[HotelLocationType["SmallMetroTown"] = 5] = "SmallMetroTown";
})(HotelLocationType || (HotelLocationType = {}));
/** CoStar.Api.SuiteDetail.Types.HotelOperatingStatus */
export var HotelOperatingStatus;
(function (HotelOperatingStatus) {
    HotelOperatingStatus[HotelOperatingStatus["None"] = 0] = "None";
    HotelOperatingStatus[HotelOperatingStatus["Open"] = 1] = "Open";
    HotelOperatingStatus[HotelOperatingStatus["TemporarilyClosed"] = 2] = "TemporarilyClosed";
    HotelOperatingStatus[HotelOperatingStatus["PermanentlyClosed"] = 3] = "PermanentlyClosed";
})(HotelOperatingStatus || (HotelOperatingStatus = {}));
/** CoStar.Api.SuiteDetail.Types.HotelRating */
export var HotelRating;
(function (HotelRating) {
    HotelRating[HotelRating["None"] = 0] = "None";
    HotelRating[HotelRating["OneStar"] = 1] = "OneStar";
    HotelRating[HotelRating["TwoStar"] = 2] = "TwoStar";
    HotelRating[HotelRating["ThreeStar"] = 3] = "ThreeStar";
    HotelRating[HotelRating["FourStar"] = 4] = "FourStar";
    HotelRating[HotelRating["FiveStar"] = 5] = "FiveStar";
})(HotelRating || (HotelRating = {}));
/** CoStar.Api.SuiteDetail.Types.HotelScale */
export var HotelScale;
(function (HotelScale) {
    HotelScale[HotelScale["None"] = 0] = "None";
    HotelScale[HotelScale["Luxury"] = 1] = "Luxury";
    HotelScale[HotelScale["UpperUpscale"] = 2] = "UpperUpscale";
    HotelScale[HotelScale["Upscale"] = 3] = "Upscale";
    HotelScale[HotelScale["UpperMidscale"] = 4] = "UpperMidscale";
    HotelScale[HotelScale["Midscale"] = 5] = "Midscale";
    HotelScale[HotelScale["Economy"] = 6] = "Economy";
})(HotelScale || (HotelScale = {}));
/** CoStar.Api.SuiteDetail.Types.HotelOperationType */
export var HotelOperationType;
(function (HotelOperationType) {
    HotelOperationType[HotelOperationType["None"] = 0] = "None";
    HotelOperationType[HotelOperationType["ChainManagement"] = 1] = "ChainManagement";
    HotelOperationType[HotelOperationType["Franchise"] = 2] = "Franchise";
    HotelOperationType[HotelOperationType["Independent"] = 3] = "Independent";
})(HotelOperationType || (HotelOperationType = {}));
/** CoStar.Api.SuiteDetail.Types.UtilitySubtype */
export var UtilitySubtype;
(function (UtilitySubtype) {
    UtilitySubtype[UtilitySubtype["None"] = 0] = "None";
    UtilitySubtype[UtilitySubtype["CityWater"] = 1] = "CityWater";
    UtilitySubtype[UtilitySubtype["CountyWater"] = 2] = "CountyWater";
    UtilitySubtype[UtilitySubtype["Well"] = 3] = "Well";
    UtilitySubtype[UtilitySubtype["Natural"] = 4] = "Natural";
    UtilitySubtype[UtilitySubtype["Propane"] = 5] = "Propane";
    UtilitySubtype[UtilitySubtype["Electric"] = 6] = "Electric";
    UtilitySubtype[UtilitySubtype["Gas"] = 7] = "Gas";
    UtilitySubtype[UtilitySubtype["OilFired"] = 8] = "OilFired";
    UtilitySubtype[UtilitySubtype["OilSteam"] = 9] = "OilSteam";
    UtilitySubtype[UtilitySubtype["Fluorescent"] = 10] = "Fluorescent";
    UtilitySubtype[UtilitySubtype["Incandescent"] = 11] = "Incandescent";
    UtilitySubtype[UtilitySubtype["CitySewer"] = 18] = "CitySewer";
    UtilitySubtype[UtilitySubtype["CountySewer"] = 19] = "CountySewer";
    UtilitySubtype[UtilitySubtype["SepticField"] = 20] = "SepticField";
    UtilitySubtype[UtilitySubtype["MetalHalide"] = 21] = "MetalHalide";
    UtilitySubtype[UtilitySubtype["Sodium"] = 22] = "Sodium";
    UtilitySubtype[UtilitySubtype["Mercury"] = 23] = "Mercury";
    UtilitySubtype[UtilitySubtype["Vapor"] = 24] = "Vapor";
    UtilitySubtype[UtilitySubtype["Halogen"] = 25] = "Halogen";
    UtilitySubtype[UtilitySubtype["Halide"] = 26] = "Halide";
})(UtilitySubtype || (UtilitySubtype = {}));
/** CoStar.Api.SuiteDetail.Types.UtilityType */
export var UtilityType;
(function (UtilityType) {
    UtilityType[UtilityType["None"] = 0] = "None";
    UtilityType[UtilityType["Lighting"] = 1] = "Lighting";
    UtilityType[UtilityType["Gas"] = 2] = "Gas";
    UtilityType[UtilityType["Water"] = 3] = "Water";
    UtilityType[UtilityType["Sewer"] = 4] = "Sewer";
    UtilityType[UtilityType["Heating"] = 5] = "Heating";
})(UtilityType || (UtilityType = {}));
/** CoStar.Api.SuiteDetail.Types.LoanType */
export var LoanType;
(function (LoanType) {
    LoanType[LoanType["None"] = 0] = "None";
    LoanType[LoanType["AcquisitionAndDevelopment"] = 1] = "AcquisitionAndDevelopment";
    LoanType[LoanType["Wraparound"] = 2] = "Wraparound";
    LoanType[LoanType["Assumed"] = 3] = "Assumed";
    LoanType[LoanType["BondFinancing"] = 4] = "BondFinancing";
    LoanType[LoanType["Construction"] = 5] = "Construction";
    LoanType[LoanType["InterimFinancing"] = 6] = "InterimFinancing";
    LoanType[LoanType["LineOfCredit"] = 7] = "LineOfCredit";
    LoanType[LoanType["SmallBusinessAdministration"] = 8] = "SmallBusinessAdministration";
    LoanType[LoanType["ShortTerm"] = 9] = "ShortTerm";
    LoanType[LoanType["Conventional"] = 10] = "Conventional";
})(LoanType || (LoanType = {}));
/** CoStar.Api.SuiteDetail.Types.MortgageClass */
export var MortgageClass;
(function (MortgageClass) {
    MortgageClass[MortgageClass["None"] = 0] = "None";
    MortgageClass[MortgageClass["FirstMortgage"] = 1] = "FirstMortgage";
    MortgageClass[MortgageClass["SecondMortgage"] = 2] = "SecondMortgage";
    MortgageClass[MortgageClass["ThirdMortgage"] = 3] = "ThirdMortgage";
    MortgageClass[MortgageClass["Unknown"] = 4] = "Unknown";
})(MortgageClass || (MortgageClass = {}));
/** CoStar.Api.SuiteDetail.Types.SaleEntityType */
export var SaleEntityType;
(function (SaleEntityType) {
    SaleEntityType[SaleEntityType["Unknown"] = 0] = "Unknown";
    SaleEntityType[SaleEntityType["Property"] = 1] = "Property";
    SaleEntityType[SaleEntityType["CondoUnit"] = 2] = "CondoUnit";
    SaleEntityType[SaleEntityType["RumorProperty"] = 3] = "RumorProperty";
})(SaleEntityType || (SaleEntityType = {}));
import { InterestOnlyType } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteDetail.Types.InterestOnlyType */
export { InterestOnlyType };
/** CoStar.Api.SuiteDetail.Types.LoanRateType */
export var LoanRateType;
(function (LoanRateType) {
    LoanRateType[LoanRateType["None"] = 0] = "None";
    LoanRateType[LoanRateType["Fixed"] = 1] = "Fixed";
    LoanRateType[LoanRateType["Variable"] = 2] = "Variable";
    LoanRateType[LoanRateType["InterestOnly"] = 3] = "InterestOnly";
    LoanRateType[LoanRateType["InterestOnlyFixed"] = 4] = "InterestOnlyFixed";
    LoanRateType[LoanRateType["InterestOnlyVariable"] = 5] = "InterestOnlyVariable";
})(LoanRateType || (LoanRateType = {}));
/** CoStar.Api.SuiteDetail.Types.LoanPaymentFrequency */
export var LoanPaymentFrequency;
(function (LoanPaymentFrequency) {
    LoanPaymentFrequency[LoanPaymentFrequency["None"] = 0] = "None";
    LoanPaymentFrequency[LoanPaymentFrequency["Monthly"] = 1] = "Monthly";
    LoanPaymentFrequency[LoanPaymentFrequency["Quarterly"] = 2] = "Quarterly";
    LoanPaymentFrequency[LoanPaymentFrequency["Yearly"] = 3] = "Yearly";
    LoanPaymentFrequency[LoanPaymentFrequency["SemiAnnually"] = 4] = "SemiAnnually";
})(LoanPaymentFrequency || (LoanPaymentFrequency = {}));
/** CoStar.Api.SuiteDetail.Types.LoanPaymentStatus */
export var LoanPaymentStatus;
(function (LoanPaymentStatus) {
    LoanPaymentStatus[LoanPaymentStatus["None"] = 0] = "None";
    LoanPaymentStatus[LoanPaymentStatus["Performing"] = 1] = "Performing";
    LoanPaymentStatus[LoanPaymentStatus["Delinquent30Days"] = 2] = "Delinquent30Days";
    LoanPaymentStatus[LoanPaymentStatus["Delinquent60Days"] = 3] = "Delinquent60Days";
    LoanPaymentStatus[LoanPaymentStatus["Delinquent90PlusDays"] = 4] = "Delinquent90PlusDays";
    LoanPaymentStatus[LoanPaymentStatus["MaturityDefault"] = 5] = "MaturityDefault";
    LoanPaymentStatus[LoanPaymentStatus["Foreclosed"] = 6] = "Foreclosed";
    LoanPaymentStatus[LoanPaymentStatus["Defeased"] = 7] = "Defeased";
    LoanPaymentStatus[LoanPaymentStatus["Bankrupt"] = 8] = "Bankrupt";
    LoanPaymentStatus[LoanPaymentStatus["RealEstateOwned"] = 9] = "RealEstateOwned";
})(LoanPaymentStatus || (LoanPaymentStatus = {}));
/** CoStar.Api.SuiteDetail.Types.DataSourceType */
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType[DataSourceType["None"] = 0] = "None";
    DataSourceType[DataSourceType["TaxRecord"] = 1] = "TaxRecord";
    DataSourceType[DataSourceType["BuildingContact"] = 2] = "BuildingContact";
    DataSourceType[DataSourceType["TenantUpdateCall"] = 3] = "TenantUpdateCall";
    DataSourceType[DataSourceType["FieldResearcher"] = 4] = "FieldResearcher";
    DataSourceType[DataSourceType["System"] = 5] = "System";
    DataSourceType[DataSourceType["Broker"] = 6] = "Broker";
    DataSourceType[DataSourceType["Buyer"] = 7] = "Buyer";
    DataSourceType[DataSourceType["CoStarMktEstimate"] = 8] = "CoStarMktEstimate";
    DataSourceType[DataSourceType["BOMAGuidelines"] = 9] = "BOMAGuidelines";
    DataSourceType[DataSourceType["Infogroup"] = 10] = "Infogroup";
    DataSourceType[DataSourceType["CostarResearch"] = 11] = "CostarResearch";
    DataSourceType[DataSourceType["ResearchUpdate"] = 12] = "ResearchUpdate";
    DataSourceType[DataSourceType["NCOAUpdate"] = 13] = "NCOAUpdate";
    DataSourceType[DataSourceType["ACSUpdate"] = 14] = "ACSUpdate";
    DataSourceType[DataSourceType["CRMResearch"] = 15] = "CRMResearch";
    DataSourceType[DataSourceType["NRB"] = 16] = "NRB";
    DataSourceType[DataSourceType["ADC"] = 17] = "ADC";
    DataSourceType[DataSourceType["AerialImage"] = 18] = "AerialImage";
    DataSourceType[DataSourceType["FOCUS"] = 19] = "FOCUS";
    DataSourceType[DataSourceType["UKMigration"] = 20] = "UKMigration";
    DataSourceType[DataSourceType["CommunityCaller"] = 21] = "CommunityCaller";
    DataSourceType[DataSourceType["UserEntry"] = 22] = "UserEntry";
    DataSourceType[DataSourceType["ListingFeed"] = 23] = "ListingFeed";
    DataSourceType[DataSourceType["GoSell"] = 24] = "GoSell";
    DataSourceType[DataSourceType["DunBradstreet"] = 25] = "DunBradstreet";
    DataSourceType[DataSourceType["HMLandRegistry"] = 26] = "HMLandRegistry";
    DataSourceType[DataSourceType["Factual"] = 27] = "Factual";
    DataSourceType[DataSourceType["Creditsafe"] = 28] = "Creditsafe";
    DataSourceType[DataSourceType["Intex"] = 29] = "Intex";
    DataSourceType[DataSourceType["Emporis"] = 30] = "Emporis";
    DataSourceType[DataSourceType["HospitalityFeed"] = 31] = "HospitalityFeed";
    DataSourceType[DataSourceType["Doorda"] = 32] = "Doorda";
    DataSourceType[DataSourceType["TenX"] = 33] = "TenX";
})(DataSourceType || (DataSourceType = {}));
/** CoStar.Api.SuiteDetail.Types.StageType */
export var StageType;
(function (StageType) {
    StageType[StageType["None"] = 0] = "None";
    StageType[StageType["Lockout"] = 1] = "Lockout";
    StageType[StageType["Defeasance"] = 2] = "Defeasance";
    StageType[StageType["YieldMaintenance"] = 3] = "YieldMaintenance";
    StageType[StageType["Points"] = 4] = "Points";
    StageType[StageType["Open"] = 5] = "Open";
})(StageType || (StageType = {}));
/** CoStar.Api.SuiteDetail.Types.ApartmentFeeType */
export var ApartmentFeeType;
(function (ApartmentFeeType) {
    ApartmentFeeType[ApartmentFeeType["Unknown"] = 0] = "Unknown";
    ApartmentFeeType[ApartmentFeeType["AmenityFee"] = 1] = "AmenityFee";
    ApartmentFeeType[ApartmentFeeType["AdminFee"] = 2] = "AdminFee";
    ApartmentFeeType[ApartmentFeeType["ApplicationFee"] = 3] = "ApplicationFee";
    ApartmentFeeType[ApartmentFeeType["MoveIn"] = 4] = "MoveIn";
    ApartmentFeeType[ApartmentFeeType["NonCashGift"] = 6] = "NonCashGift";
    ApartmentFeeType[ApartmentFeeType["Other"] = 7] = "Other";
    ApartmentFeeType[ApartmentFeeType["SatelliteFee"] = 9] = "SatelliteFee";
    ApartmentFeeType[ApartmentFeeType["StorageFee"] = 10] = "StorageFee";
})(ApartmentFeeType || (ApartmentFeeType = {}));
import { PetType } from "../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.PetType */
export { PetType };
/** CoStar.Api.SuiteDetail.Types.ParkingType */
export var ParkingType;
(function (ParkingType) {
    ParkingType[ParkingType["None"] = 0] = "None";
    ParkingType[ParkingType["Surface"] = 1] = "Surface";
    ParkingType[ParkingType["SurfaceTandem"] = 2] = "SurfaceTandem";
    ParkingType[ParkingType["Covered"] = 3] = "Covered";
    ParkingType[ParkingType["CoveredTandem"] = 4] = "CoveredTandem";
    ParkingType[ParkingType["IndustrialTrailer"] = 5] = "IndustrialTrailer";
    ParkingType[ParkingType["OneCarGarage"] = 6] = "OneCarGarage";
    ParkingType[ParkingType["TwoCarGarage"] = 7] = "TwoCarGarage";
    ParkingType[ParkingType["ReserveParking"] = 8] = "ReserveParking";
    ParkingType[ParkingType["AttachedGarage"] = 9] = "AttachedGarage";
})(ParkingType || (ParkingType = {}));
/** CoStar.Api.SuiteDetail.Types.BelowMarketSaleReason */
export var BelowMarketSaleReason;
(function (BelowMarketSaleReason) {
    BelowMarketSaleReason[BelowMarketSaleReason["Unknown"] = 0] = "Unknown";
    BelowMarketSaleReason[BelowMarketSaleReason["AssignmentOfBeneficialInterestDeed"] = 1] = "AssignmentOfBeneficialInterestDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["AffidavitOfDeath"] = 2] = "AffidavitOfDeath";
    BelowMarketSaleReason[BelowMarketSaleReason["AssignmentOfLease"] = 4] = "AssignmentOfLease";
    BelowMarketSaleReason[BelowMarketSaleReason["BusinessSaleZeroReallocation"] = 7] = "BusinessSaleZeroReallocation";
    BelowMarketSaleReason[BelowMarketSaleReason["ChangeInTitleVesting"] = 8] = "ChangeInTitleVesting";
    BelowMarketSaleReason[BelowMarketSaleReason["ContractInstallmentSale"] = 9] = "ContractInstallmentSale";
    BelowMarketSaleReason[BelowMarketSaleReason["CorrectionDeed"] = 10] = "CorrectionDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["DatedSalePrice"] = 11] = "DatedSalePrice";
    BelowMarketSaleReason[BelowMarketSaleReason["DeedInLieuOfForeclosure"] = 12] = "DeedInLieuOfForeclosure";
    BelowMarketSaleReason[BelowMarketSaleReason["DevelopmentAuthoritySale"] = 13] = "DevelopmentAuthoritySale";
    BelowMarketSaleReason[BelowMarketSaleReason["EasementRightOfWay"] = 15] = "EasementRightOfWay";
    BelowMarketSaleReason[BelowMarketSaleReason["GiftDeed"] = 16] = "GiftDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["InterrelatedParties"] = 17] = "InterrelatedParties";
    BelowMarketSaleReason[BelowMarketSaleReason["MortgageReleaseOfMortgage"] = 21] = "MortgageReleaseOfMortgage";
    BelowMarketSaleReason[BelowMarketSaleReason["PackageSaleRandomAllocation"] = 25] = "PackageSaleRandomAllocation";
    BelowMarketSaleReason[BelowMarketSaleReason["PartnershipDissolution"] = 27] = "PartnershipDissolution";
    BelowMarketSaleReason[BelowMarketSaleReason["QuitclaimDeed"] = 28] = "QuitclaimDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["Rerecording"] = 29] = "Rerecording";
    BelowMarketSaleReason[BelowMarketSaleReason["RedevelopmentAgencySale"] = 30] = "RedevelopmentAgencySale";
    BelowMarketSaleReason[BelowMarketSaleReason["Refinance"] = 31] = "Refinance";
    BelowMarketSaleReason[BelowMarketSaleReason["RelatedPrincipals"] = 32] = "RelatedPrincipals";
    BelowMarketSaleReason[BelowMarketSaleReason["ReleaseOfCosigner"] = 33] = "ReleaseOfCosigner";
    BelowMarketSaleReason[BelowMarketSaleReason["RightOfWay"] = 35] = "RightOfWay";
    BelowMarketSaleReason[BelowMarketSaleReason["TrustDeed"] = 39] = "TrustDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["TrustTransfer"] = 40] = "TrustTransfer";
    BelowMarketSaleReason[BelowMarketSaleReason["TrusteesDeed"] = 41] = "TrusteesDeed";
    BelowMarketSaleReason[BelowMarketSaleReason["UnknownReason"] = 42] = "UnknownReason";
    BelowMarketSaleReason[BelowMarketSaleReason["Foreclosure"] = 43] = "Foreclosure";
    BelowMarketSaleReason[BelowMarketSaleReason["EminentDomain"] = 44] = "EminentDomain";
})(BelowMarketSaleReason || (BelowMarketSaleReason = {}));
/** CoStar.Api.SuiteDetail.Types.CompStatusType */
export var CompStatusType;
(function (CompStatusType) {
    CompStatusType[CompStatusType["Unknown"] = 0] = "Unknown";
    CompStatusType[CompStatusType["InProgress"] = 1] = "InProgress";
    CompStatusType[CompStatusType["ResearchCompleteNewInfo"] = 2] = "ResearchCompleteNewInfo";
    CompStatusType[CompStatusType["ResearchCompleteCorrection"] = 3] = "ResearchCompleteCorrection";
    CompStatusType[CompStatusType["ResearchComplete"] = 4] = "ResearchComplete";
    CompStatusType[CompStatusType["ClosedBySystem"] = 5] = "ClosedBySystem";
    CompStatusType[CompStatusType["Initial"] = 6] = "Initial";
    CompStatusType[CompStatusType["InvalidComp"] = 7] = "InvalidComp";
    CompStatusType[CompStatusType["ResearchCompleteClosedBySystem"] = 8] = "ResearchCompleteClosedBySystem";
    CompStatusType[CompStatusType["PublicRecord"] = 9] = "PublicRecord";
})(CompStatusType || (CompStatusType = {}));
/** CoStar.Api.SuiteDetail.Types.VerificationSourceType */
export var VerificationSourceType;
(function (VerificationSourceType) {
    VerificationSourceType[VerificationSourceType["None"] = 0] = "None";
    VerificationSourceType[VerificationSourceType["OtherNoCall"] = 1] = "OtherNoCall";
    VerificationSourceType[VerificationSourceType["DocInspection"] = 2] = "DocInspection";
    VerificationSourceType[VerificationSourceType["PressRelease"] = 3] = "PressRelease";
    VerificationSourceType[VerificationSourceType["SEC"] = 4] = "SEC";
    VerificationSourceType[VerificationSourceType["SalesReportForm"] = 5] = "SalesReportForm";
    VerificationSourceType[VerificationSourceType["ListingBroker"] = 6] = "ListingBroker";
    VerificationSourceType[VerificationSourceType["BuyerBroker"] = 7] = "BuyerBroker";
    VerificationSourceType[VerificationSourceType["Buyer"] = 8] = "Buyer";
    VerificationSourceType[VerificationSourceType["Seller"] = 9] = "Seller";
    VerificationSourceType[VerificationSourceType["OtherCall"] = 10] = "OtherCall";
})(VerificationSourceType || (VerificationSourceType = {}));
/** CoStar.Api.SuiteDetail.Types.Month */
export var Month;
(function (Month) {
    Month[Month["None"] = 0] = "None";
    Month[Month["January"] = 1] = "January";
    Month[Month["February"] = 2] = "February";
    Month[Month["March"] = 3] = "March";
    Month[Month["April"] = 4] = "April";
    Month[Month["May"] = 5] = "May";
    Month[Month["June"] = 6] = "June";
    Month[Month["July"] = 7] = "July";
    Month[Month["August"] = 8] = "August";
    Month[Month["September"] = 9] = "September";
    Month[Month["October"] = 10] = "October";
    Month[Month["November"] = 11] = "November";
    Month[Month["December"] = 12] = "December";
})(Month || (Month = {}));
/** CoStar.Api.SuiteDetail.Types.OccupancyType */
export var OccupancyType;
(function (OccupancyType) {
    OccupancyType[OccupancyType["None"] = 0] = "None";
    OccupancyType[OccupancyType["Leased"] = 1] = "Leased";
    OccupancyType[OccupancyType["Subleased"] = 2] = "Subleased";
    OccupancyType[OccupancyType["Owned"] = 3] = "Owned";
    OccupancyType[OccupancyType["Assignment"] = 4] = "Assignment";
    OccupancyType[OccupancyType["Coworking"] = 5] = "Coworking";
    OccupancyType[OccupancyType["Unknown"] = 6] = "Unknown";
})(OccupancyType || (OccupancyType = {}));
import { BusinessType } from "../../../../CoStar/Api/Brokers/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.BusinessType */
export { BusinessType };
import { CreditRating } from "../../../../CoStar/Api/FusionSearch/Criteria/index.js";
/** CoStar.Api.SuiteDetail.Types.CreditRating */
export { CreditRating };
import { GrowthType } from "../../../../CoStar/Api/Brokers/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.GrowthType */
export { GrowthType };
import { StockExchange } from "../../../../CoStar/Api/Brokers/ViewModels/index.js";
/** CoStar.Api.SuiteDetail.Types.StockExchange */
export { StockExchange };
/** CoStar.Api.SuiteDetail.Types.StoreType */
export var StoreType;
(function (StoreType) {
    StoreType[StoreType["None"] = 0] = "None";
    StoreType[StoreType["EmploymentAgency"] = 1] = "EmploymentAgency";
    StoreType[StoreType["Bagel"] = 2] = "Bagel";
    StoreType[StoreType["Fitness"] = 3] = "Fitness";
    StoreType[StoreType["AutoShowroom"] = 4] = "AutoShowroom";
    StoreType[StoreType["FilmProcessing"] = 5] = "FilmProcessing";
    StoreType[StoreType["SpecialtyFoods"] = 6] = "SpecialtyFoods";
    StoreType[StoreType["CardGifts"] = 7] = "CardGifts";
    StoreType[StoreType["OtherRetail"] = 9] = "OtherRetail";
    StoreType[StoreType["IceCream"] = 10] = "IceCream";
    StoreType[StoreType["Books"] = 11] = "Books";
    StoreType[StoreType["OtherServices"] = 13] = "OtherServices";
    StoreType[StoreType["CandyNuts"] = 14] = "CandyNuts";
    StoreType[StoreType["ConsumerElectronics"] = 16] = "ConsumerElectronics";
    StoreType[StoreType["FloorCovering"] = 17] = "FloorCovering";
    StoreType[StoreType["MusicInstruments"] = 18] = "MusicInstruments";
    StoreType[StoreType["LeatherLuggagePurses"] = 19] = "LeatherLuggagePurses";
    StoreType[StoreType["Tobacco"] = 20] = "Tobacco";
    StoreType[StoreType["Automotive"] = 21] = "Automotive";
    StoreType[StoreType["GasolineStation"] = 22] = "GasolineStation";
    StoreType[StoreType["NailSalon"] = 23] = "NailSalon";
    StoreType[StoreType["SalonBarberSpa"] = 24] = "SalonBarberSpa";
    StoreType[StoreType["ChildrenApparel"] = 25] = "ChildrenApparel";
    StoreType[StoreType["CocktailBar"] = 26] = "CocktailBar";
    StoreType[StoreType["TravelAgent"] = 27] = "TravelAgent";
    StoreType[StoreType["HomeImprovement"] = 28] = "HomeImprovement";
    StoreType[StoreType["ChinaGlass"] = 29] = "ChinaGlass";
    StoreType[StoreType["Coffee"] = 30] = "Coffee";
    StoreType[StoreType["Bakery"] = 31] = "Bakery";
    StoreType[StoreType["Laundry"] = 32] = "Laundry";
    StoreType[StoreType["WindowCoverings"] = 33] = "WindowCoverings";
    StoreType[StoreType["ArtCrafts"] = 35] = "ArtCrafts";
    StoreType[StoreType["Supermarket"] = 36] = "Supermarket";
    StoreType[StoreType["MedicalDoctorOrDoctorOfDentalSurgery"] = 37] = "MedicalDoctorOrDoctorOfDentalSurgery";
    StoreType[StoreType["Florist"] = 38] = "Florist";
    StoreType[StoreType["KeyShop"] = 39] = "KeyShop";
    StoreType[StoreType["DepartmentStore"] = 40] = "DepartmentStore";
    StoreType[StoreType["OffPrice"] = 41] = "OffPrice";
    StoreType[StoreType["LadiesApparel"] = 42] = "LadiesApparel";
    StoreType[StoreType["Bank"] = 43] = "Bank";
    StoreType[StoreType["ArtGallery"] = 44] = "ArtGallery";
    StoreType[StoreType["OfficeSupply"] = 45] = "OfficeSupply";
    StoreType[StoreType["DrugStore"] = 46] = "DrugStore";
    StoreType[StoreType["LampsLighting"] = 47] = "LampsLighting";
    StoreType[StoreType["GameStore"] = 48] = "GameStore";
    StoreType[StoreType["Shoes"] = 49] = "Shoes";
    StoreType[StoreType["BowlingBilliards"] = 50] = "BowlingBilliards";
    StoreType[StoreType["Hardware"] = 52] = "Hardware";
    StoreType[StoreType["InvestmentService"] = 53] = "InvestmentService";
    StoreType[StoreType["AccountingTaxPrep"] = 56] = "AccountingTaxPrep";
    StoreType[StoreType["FastFood"] = 57] = "FastFood";
    StoreType[StoreType["HealthFood"] = 58] = "HealthFood";
    StoreType[StoreType["WirelessCommunication"] = 60] = "WirelessCommunication";
    StoreType[StoreType["Imports"] = 61] = "Imports";
    StoreType[StoreType["Newsstand"] = 62] = "Newsstand";
    StoreType[StoreType["Arcade"] = 63] = "Arcade";
    StoreType[StoreType["PetShopSupplies"] = 64] = "PetShopSupplies";
    StoreType[StoreType["FabricShop"] = 65] = "FabricShop";
    StoreType[StoreType["UnisexApparel"] = 66] = "UnisexApparel";
    StoreType[StoreType["FormalWear"] = 70] = "FormalWear";
    StoreType[StoreType["DiscountStore"] = 71] = "DiscountStore";
    StoreType[StoreType["Cinema"] = 72] = "Cinema";
    StoreType[StoreType["Accessory"] = 73] = "Accessory";
    StoreType[StoreType["Cafeteria"] = 74] = "Cafeteria";
    StoreType[StoreType["PaintWallpaper"] = 75] = "PaintWallpaper";
    StoreType[StoreType["WholesaleClub"] = 76] = "WholesaleClub";
    StoreType[StoreType["BikeShop"] = 77] = "BikeShop";
    StoreType[StoreType["FurnitureMattress"] = 78] = "FurnitureMattress";
    StoreType[StoreType["Toys"] = 79] = "Toys";
    StoreType[StoreType["HomeAccessories"] = 80] = "HomeAccessories";
    StoreType[StoreType["Photographer"] = 81] = "Photographer";
    StoreType[StoreType["ChurchCommonHall"] = 83] = "ChurchCommonHall";
    StoreType[StoreType["ConvenienceMarket"] = 84] = "ConvenienceMarket";
    StoreType[StoreType["OtherOffice"] = 86] = "OtherOffice";
    StoreType[StoreType["DonutShop"] = 87] = "DonutShop";
    StoreType[StoreType["Liquor"] = 88] = "Liquor";
    StoreType[StoreType["VideoGamesRental"] = 89] = "VideoGamesRental";
    StoreType[StoreType["Stationery"] = 90] = "Stationery";
    StoreType[StoreType["Insurance"] = 91] = "Insurance";
    StoreType[StoreType["BusinessCopyPostalService"] = 92] = "BusinessCopyPostalService";
    StoreType[StoreType["DiscountGrocer"] = 93] = "DiscountGrocer";
    StoreType[StoreType["AutomaticTellerMachine"] = 94] = "AutomaticTellerMachine";
    StoreType[StoreType["Optical"] = 96] = "Optical";
    StoreType[StoreType["ButcherFishMarket"] = 97] = "ButcherFishMarket";
    StoreType[StoreType["Candles"] = 98] = "Candles";
    StoreType[StoreType["KitchenDiningAccessories"] = 99] = "KitchenDiningAccessories";
    StoreType[StoreType["Legal"] = 100] = "Legal";
    StoreType[StoreType["HealthCare"] = 101] = "HealthCare";
    StoreType[StoreType["SportingGoods"] = 102] = "SportingGoods";
    StoreType[StoreType["MusicVideoGames"] = 103] = "MusicVideoGames";
    StoreType[StoreType["Hobby"] = 104] = "Hobby";
    StoreType[StoreType["GourmetMarket"] = 105] = "GourmetMarket";
    StoreType[StoreType["Cameras"] = 106] = "Cameras";
    StoreType[StoreType["Appliances"] = 107] = "Appliances";
    StoreType[StoreType["MensApparel"] = 109] = "MensApparel";
    StoreType[StoreType["Dance"] = 110] = "Dance";
    StoreType[StoreType["ShoeRepair"] = 111] = "ShoeRepair";
    StoreType[StoreType["Daycare"] = 112] = "Daycare";
    StoreType[StoreType["Cleaners"] = 114] = "Cleaners";
    StoreType[StoreType["Cookies"] = 115] = "Cookies";
    StoreType[StoreType["Pretzels"] = 116] = "Pretzels";
    StoreType[StoreType["SavingsAndLoan"] = 117] = "SavingsAndLoan";
    StoreType[StoreType["RealEstate"] = 118] = "RealEstate";
    StoreType[StoreType["NutritionCenter"] = 119] = "NutritionCenter";
    StoreType[StoreType["Restaurant"] = 120] = "Restaurant";
    StoreType[StoreType["RentalShop"] = 121] = "RentalShop";
    StoreType[StoreType["HealthAndBeautyAids"] = 122] = "HealthAndBeautyAids";
    StoreType[StoreType["JewelryWatches"] = 124] = "JewelryWatches";
    StoreType[StoreType["EyewearAccessories"] = 125] = "EyewearAccessories";
    StoreType[StoreType["AutoRental"] = 126] = "AutoRental";
    StoreType[StoreType["GardenPatioPool"] = 127] = "GardenPatioPool";
    StoreType[StoreType["CheckCashingQuickLoans"] = 128] = "CheckCashingQuickLoans";
    StoreType[StoreType["DrinksJuices"] = 129] = "DrinksJuices";
    StoreType[StoreType["DollarVarietyThrift"] = 130] = "DollarVarietyThrift";
    StoreType[StoreType["Marine"] = 131] = "Marine";
    StoreType[StoreType["PawnShop"] = 132] = "PawnShop";
    StoreType[StoreType["TanningSalon"] = 133] = "TanningSalon";
    StoreType[StoreType["AnimalCareGroom"] = 134] = "AnimalCareGroom";
    StoreType[StoreType["FinanceCompany"] = 135] = "FinanceCompany";
    StoreType[StoreType["HotelMotel"] = 136] = "HotelMotel";
    StoreType[StoreType["Pizza"] = 137] = "Pizza";
    StoreType[StoreType["SubSandwich"] = 138] = "SubSandwich";
    StoreType[StoreType["Yogurt"] = 139] = "Yogurt";
    StoreType[StoreType["AutoMaintenanceOilChange"] = 140] = "AutoMaintenanceOilChange";
    StoreType[StoreType["Massage"] = 141] = "Massage";
})(StoreType || (StoreType = {}));
/** CoStar.Api.SuiteDetail.Types.TenantType */
export var TenantType;
(function (TenantType) {
    TenantType[TenantType["Unknown"] = 0] = "Unknown";
    TenantType[TenantType["Anchor"] = 1] = "Anchor";
    TenantType[TenantType["Outparcel"] = 2] = "Outparcel";
    TenantType[TenantType["Regular"] = 3] = "Regular";
    TenantType[TenantType["RetailInOfficeBuilding"] = 4] = "RetailInOfficeBuilding";
    TenantType[TenantType["InStoreTenant"] = 5] = "InStoreTenant";
    TenantType[TenantType["EndCap"] = 6] = "EndCap";
    TenantType[TenantType["Inline"] = 7] = "Inline";
    TenantType[TenantType["Vacant"] = 8] = "Vacant";
})(TenantType || (TenantType = {}));
/** CoStar.Api.SuiteDetail.Types.LeaseOptionType */
export var LeaseOptionType;
(function (LeaseOptionType) {
    LeaseOptionType[LeaseOptionType["None"] = 0] = "None";
    LeaseOptionType[LeaseOptionType["Renewal"] = 1] = "Renewal";
    LeaseOptionType[LeaseOptionType["Expansion"] = 2] = "Expansion";
    LeaseOptionType[LeaseOptionType["RightOfFirstRefusal"] = 3] = "RightOfFirstRefusal";
    LeaseOptionType[LeaseOptionType["Termination"] = 4] = "Termination";
    LeaseOptionType[LeaseOptionType["Purchase"] = 5] = "Purchase";
    LeaseOptionType[LeaseOptionType["RightOfFirstOffer"] = 6] = "RightOfFirstOffer";
})(LeaseOptionType || (LeaseOptionType = {}));
import { EmployeeGrowthType } from "../../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.SuiteDetail.Types.EmployeeGrowthType */
export { EmployeeGrowthType };
/** CoStar.Api.SuiteDetail.Types.FutureGrowthType */
export var FutureGrowthType;
(function (FutureGrowthType) {
    FutureGrowthType[FutureGrowthType["None"] = 0] = "None";
    FutureGrowthType[FutureGrowthType["Reducing"] = 1] = "Reducing";
    FutureGrowthType[FutureGrowthType["Relocating"] = 2] = "Relocating";
    FutureGrowthType[FutureGrowthType["Adding"] = 3] = "Adding";
})(FutureGrowthType || (FutureGrowthType = {}));
/** CoStar.Api.SuiteDetail.Types.DealType */
export var DealType;
(function (DealType) {
    DealType[DealType["None"] = 0] = "None";
    DealType[DealType["NewLease"] = 1] = "NewLease";
    DealType[DealType["Renewal"] = 2] = "Renewal";
})(DealType || (DealType = {}));
/** CoStar.Api.SuiteDetail.Types.FloorName */
export var FloorName;
(function (FloorName) {
    FloorName[FloorName["UnknownFloor"] = 1] = "UnknownFloor";
    FloorName[FloorName["MechanicalLevel3"] = 2] = "MechanicalLevel3";
    FloorName[FloorName["MechanicalLevel2"] = 3] = "MechanicalLevel2";
    FloorName[FloorName["MechanicalLevel1"] = 4] = "MechanicalLevel1";
    FloorName[FloorName["ParkingLevel10"] = 5] = "ParkingLevel10";
    FloorName[FloorName["ParkingLevel9"] = 6] = "ParkingLevel9";
    FloorName[FloorName["ParkingLevel8"] = 7] = "ParkingLevel8";
    FloorName[FloorName["ParkingLevel7"] = 8] = "ParkingLevel7";
    FloorName[FloorName["ParkingLevel6"] = 9] = "ParkingLevel6";
    FloorName[FloorName["ParkingLevel5"] = 10] = "ParkingLevel5";
    FloorName[FloorName["ParkingLevel4"] = 11] = "ParkingLevel4";
    FloorName[FloorName["ParkingLevel3"] = 12] = "ParkingLevel3";
    FloorName[FloorName["ParkingLevel2"] = 13] = "ParkingLevel2";
    FloorName[FloorName["ParkingLevel1"] = 14] = "ParkingLevel1";
    FloorName[FloorName["Terrace"] = 15] = "Terrace";
    FloorName[FloorName["Subway"] = 16] = "Subway";
    FloorName[FloorName["Metro"] = 17] = "Metro";
    FloorName[FloorName["LowerLevel"] = 18] = "LowerLevel";
    FloorName[FloorName["Concourse"] = 19] = "Concourse";
    FloorName[FloorName["Basement"] = 20] = "Basement";
    FloorName[FloorName["Plaza"] = 21] = "Plaza";
    FloorName[FloorName["Lobby"] = 22] = "Lobby";
    FloorName[FloorName["Ground"] = 23] = "Ground";
    FloorName[FloorName["Floor1"] = 24] = "Floor1";
    FloorName[FloorName["Floor2"] = 25] = "Floor2";
    FloorName[FloorName["Mezzanine"] = 26] = "Mezzanine";
    FloorName[FloorName["Floor3"] = 27] = "Floor3";
    FloorName[FloorName["Floor4"] = 28] = "Floor4";
    FloorName[FloorName["Floor5"] = 29] = "Floor5";
    FloorName[FloorName["Floor6"] = 30] = "Floor6";
    FloorName[FloorName["Floor7"] = 31] = "Floor7";
    FloorName[FloorName["Floor8"] = 32] = "Floor8";
    FloorName[FloorName["Floor9"] = 33] = "Floor9";
    FloorName[FloorName["Floor10"] = 34] = "Floor10";
    FloorName[FloorName["Floor11"] = 35] = "Floor11";
    FloorName[FloorName["Floor12"] = 36] = "Floor12";
    FloorName[FloorName["Floor13"] = 37] = "Floor13";
    FloorName[FloorName["Floor14"] = 38] = "Floor14";
    FloorName[FloorName["Floor15"] = 39] = "Floor15";
    FloorName[FloorName["Floor16"] = 40] = "Floor16";
    FloorName[FloorName["Floor17"] = 41] = "Floor17";
    FloorName[FloorName["Floor18"] = 42] = "Floor18";
    FloorName[FloorName["Floor19"] = 43] = "Floor19";
    FloorName[FloorName["Floor20"] = 44] = "Floor20";
    FloorName[FloorName["Floor21"] = 45] = "Floor21";
    FloorName[FloorName["Floor22"] = 46] = "Floor22";
    FloorName[FloorName["Floor23"] = 47] = "Floor23";
    FloorName[FloorName["Floor24"] = 48] = "Floor24";
    FloorName[FloorName["Floor25"] = 49] = "Floor25";
    FloorName[FloorName["Floor26"] = 50] = "Floor26";
    FloorName[FloorName["Floor27"] = 51] = "Floor27";
    FloorName[FloorName["Floor28"] = 52] = "Floor28";
    FloorName[FloorName["Floor29"] = 53] = "Floor29";
    FloorName[FloorName["Floor30"] = 54] = "Floor30";
    FloorName[FloorName["Floor31"] = 55] = "Floor31";
    FloorName[FloorName["Floor32"] = 56] = "Floor32";
    FloorName[FloorName["Floor33"] = 57] = "Floor33";
    FloorName[FloorName["Floor34"] = 58] = "Floor34";
    FloorName[FloorName["Floor35"] = 59] = "Floor35";
    FloorName[FloorName["Floor36"] = 60] = "Floor36";
    FloorName[FloorName["Floor37"] = 61] = "Floor37";
    FloorName[FloorName["Floor38"] = 62] = "Floor38";
    FloorName[FloorName["Floor39"] = 63] = "Floor39";
    FloorName[FloorName["Floor40"] = 64] = "Floor40";
    FloorName[FloorName["Floor41"] = 65] = "Floor41";
    FloorName[FloorName["Floor42"] = 66] = "Floor42";
    FloorName[FloorName["Floor43"] = 67] = "Floor43";
    FloorName[FloorName["Floor44"] = 68] = "Floor44";
    FloorName[FloorName["Floor45"] = 69] = "Floor45";
    FloorName[FloorName["Floor46"] = 70] = "Floor46";
    FloorName[FloorName["Floor47"] = 71] = "Floor47";
    FloorName[FloorName["Floor48"] = 72] = "Floor48";
    FloorName[FloorName["Floor49"] = 73] = "Floor49";
    FloorName[FloorName["Floor50"] = 74] = "Floor50";
    FloorName[FloorName["Floor51"] = 75] = "Floor51";
    FloorName[FloorName["Floor52"] = 76] = "Floor52";
    FloorName[FloorName["Floor53"] = 77] = "Floor53";
    FloorName[FloorName["Floor54"] = 78] = "Floor54";
    FloorName[FloorName["Floor55"] = 79] = "Floor55";
    FloorName[FloorName["Floor56"] = 80] = "Floor56";
    FloorName[FloorName["Floor57"] = 81] = "Floor57";
    FloorName[FloorName["Floor58"] = 82] = "Floor58";
    FloorName[FloorName["Floor59"] = 83] = "Floor59";
    FloorName[FloorName["Floor60"] = 84] = "Floor60";
    FloorName[FloorName["Floor61"] = 85] = "Floor61";
    FloorName[FloorName["Floor62"] = 86] = "Floor62";
    FloorName[FloorName["Floor63"] = 87] = "Floor63";
    FloorName[FloorName["Floor64"] = 88] = "Floor64";
    FloorName[FloorName["Floor65"] = 89] = "Floor65";
    FloorName[FloorName["Floor66"] = 90] = "Floor66";
    FloorName[FloorName["Floor67"] = 91] = "Floor67";
    FloorName[FloorName["Floor68"] = 92] = "Floor68";
    FloorName[FloorName["Floor69"] = 93] = "Floor69";
    FloorName[FloorName["Floor70"] = 94] = "Floor70";
    FloorName[FloorName["Floor71"] = 95] = "Floor71";
    FloorName[FloorName["Floor72"] = 96] = "Floor72";
    FloorName[FloorName["Floor73"] = 97] = "Floor73";
    FloorName[FloorName["Floor74"] = 98] = "Floor74";
    FloorName[FloorName["Floor75"] = 99] = "Floor75";
    FloorName[FloorName["Floor76"] = 100] = "Floor76";
    FloorName[FloorName["Floor77"] = 101] = "Floor77";
    FloorName[FloorName["Floor78"] = 102] = "Floor78";
    FloorName[FloorName["Floor79"] = 103] = "Floor79";
    FloorName[FloorName["Floor80"] = 104] = "Floor80";
    FloorName[FloorName["Floor81"] = 105] = "Floor81";
    FloorName[FloorName["Floor82"] = 106] = "Floor82";
    FloorName[FloorName["Floor83"] = 107] = "Floor83";
    FloorName[FloorName["Floor84"] = 108] = "Floor84";
    FloorName[FloorName["Floor85"] = 109] = "Floor85";
    FloorName[FloorName["Floor86"] = 110] = "Floor86";
    FloorName[FloorName["Floor87"] = 111] = "Floor87";
    FloorName[FloorName["Floor88"] = 112] = "Floor88";
    FloorName[FloorName["Floor89"] = 113] = "Floor89";
    FloorName[FloorName["Floor90"] = 114] = "Floor90";
    FloorName[FloorName["Floor91"] = 115] = "Floor91";
    FloorName[FloorName["Floor92"] = 116] = "Floor92";
    FloorName[FloorName["Floor93"] = 117] = "Floor93";
    FloorName[FloorName["Floor94"] = 118] = "Floor94";
    FloorName[FloorName["Floor95"] = 119] = "Floor95";
    FloorName[FloorName["Floor96"] = 120] = "Floor96";
    FloorName[FloorName["Floor97"] = 121] = "Floor97";
    FloorName[FloorName["Floor98"] = 122] = "Floor98";
    FloorName[FloorName["Floor99"] = 123] = "Floor99";
    FloorName[FloorName["Floor100"] = 124] = "Floor100";
    FloorName[FloorName["Floor101"] = 125] = "Floor101";
    FloorName[FloorName["Floor102"] = 126] = "Floor102";
    FloorName[FloorName["Floor103"] = 127] = "Floor103";
    FloorName[FloorName["Floor104"] = 128] = "Floor104";
    FloorName[FloorName["Floor105"] = 129] = "Floor105";
    FloorName[FloorName["Floor106"] = 130] = "Floor106";
    FloorName[FloorName["Floor107"] = 131] = "Floor107";
    FloorName[FloorName["Floor108"] = 132] = "Floor108";
    FloorName[FloorName["Floor109"] = 133] = "Floor109";
    FloorName[FloorName["Floor110"] = 134] = "Floor110";
    FloorName[FloorName["Floor111"] = 135] = "Floor111";
    FloorName[FloorName["Floor112"] = 136] = "Floor112";
    FloorName[FloorName["Floor113"] = 137] = "Floor113";
    FloorName[FloorName["Floor114"] = 138] = "Floor114";
    FloorName[FloorName["Floor115"] = 139] = "Floor115";
    FloorName[FloorName["Floor116"] = 140] = "Floor116";
    FloorName[FloorName["Floor117"] = 141] = "Floor117";
    FloorName[FloorName["Floor118"] = 142] = "Floor118";
    FloorName[FloorName["Floor119"] = 143] = "Floor119";
    FloorName[FloorName["Floor120"] = 144] = "Floor120";
    FloorName[FloorName["Floor121"] = 145] = "Floor121";
    FloorName[FloorName["Floor122"] = 146] = "Floor122";
    FloorName[FloorName["Floor123"] = 147] = "Floor123";
    FloorName[FloorName["Floor124"] = 148] = "Floor124";
    FloorName[FloorName["Floor125"] = 149] = "Floor125";
    FloorName[FloorName["Penthouse"] = 150] = "Penthouse";
    FloorName[FloorName["PrincipalFloor"] = 151] = "PrincipalFloor";
})(FloorName || (FloorName = {}));
/** CoStar.Api.SuiteDetail.Types.TenantTransactionType */
export var TenantTransactionType;
(function (TenantTransactionType) {
    TenantTransactionType[TenantTransactionType["None"] = 0] = "None";
    TenantTransactionType[TenantTransactionType["MoveIn"] = 1] = "MoveIn";
    TenantTransactionType[TenantTransactionType["MoveOut"] = 2] = "MoveOut";
    TenantTransactionType[TenantTransactionType["Growth"] = 3] = "Growth";
    TenantTransactionType[TenantTransactionType["Reduction"] = 4] = "Reduction";
    TenantTransactionType[TenantTransactionType["Renewal"] = 5] = "Renewal";
    TenantTransactionType[TenantTransactionType["RenewalGrowth"] = 6] = "RenewalGrowth";
    TenantTransactionType[TenantTransactionType["RenewalReduction"] = 7] = "RenewalReduction";
    TenantTransactionType[TenantTransactionType["Redundant"] = 8] = "Redundant";
    TenantTransactionType[TenantTransactionType["FutureMoveIn"] = 9] = "FutureMoveIn";
    TenantTransactionType[TenantTransactionType["FutureMoveOut"] = 10] = "FutureMoveOut";
    TenantTransactionType[TenantTransactionType["FirstOccupancy"] = 11] = "FirstOccupancy";
    TenantTransactionType[TenantTransactionType["Relocation"] = 12] = "Relocation";
    TenantTransactionType[TenantTransactionType["FutureRenewal"] = 13] = "FutureRenewal";
})(TenantTransactionType || (TenantTransactionType = {}));
